<template>
  <el-container>
    <el-container>
      <el-main>
        <div class="runmax">
          <div class="runmax_title">
            <div class="title_main">
              <div class="title_left">
                <p class="img_style">
                  <img :src="testInfo0.proj_icon" alt="" />
                </p>
                <ul>
                  <li>{{ testInfo0.proj_name }}</li>
                  <li>Version:{{ testInfo0.game_version }}</li>
                  <li>Package:{{ testInfo0.pkgname }}</li>
                </ul>
              </div>
              <div class="title_right">
                <div>
                  <p class="img_style">
                    <img src="../assets/icon/iPhone.png" alt="" />
                  </p>
                  <ul>
                    <li>{{ testInfo0.device }}</li>
                    <li>CPU:{{ testInfo0.cpu_name }}</li>
                    <li>GPU:{{ testInfo0.gpu_name }}</li>
                  </ul>
                </div>
                <div>
                  <p class="img_style">
                    <img src="../assets/icon/people.png" alt="" />
                  </p>
                  <ul>
                    <li>创建者</li>

                    <li>{{ testInfo0.tester }}</li>
                  </ul>
                </div>
                <div>
                  <p class="img_style">
                    <img src="../assets/icon/time.png" alt="" />
                  </p>
                  <ul>
                    <li>时长</li>
                    <li>{{ testInfo0.duration }}</li>
                  </ul>
                </div>
                <div>
                  <p class="img_style">
                    <img src="../assets/icon/uptime.png" alt="" />
                  </p>
                  <ul>
                    <li>上传时间</li>
                    <li>{{ testInfo0.timestamp_start }}</li>
                  </ul>
                </div>
              </div>
            </div>
            <p class="title_end">
              测试场景：<span>{{ testInfo0.map_name }}</span>
            </p>
          </div>

          <el-card class="overview">
            <template #header>
              <div class="header_style">
                <h2 class="h2_style">概览</h2>
                <div>
                  <a
                    v-if="logUrl != ''"
                    :href="logUrl"
                    download
                    style="cursor: pointer; margin-right: 10px"
                  >
                    <i class="el-icon-download"></i>下载日志</a
                  >
                  <a
                    :href="downloadUrl"
                    onclick="return false"
                    @click="downloadCsv"
                    ><i class="el-icon-download"></i>下载CSV文件</a
                  >
                </div>
              </div>
              <el-divider></el-divider>
            </template>

            <div class="label_style">
              <div v-for="item in overviewValue2" :key="item.label">
                <ul v-if="item.value !== '-'">
                  <li v-if="item.value !== '-'">{{ item.label }}</li>
                  <li v-if="item.value !== '-'">{{ item.value }}</li>
                </ul>
              </div>
            </div>
            <div class="overview_table">
              <el-popover
                placement="bottom-start"
                width="200"
                trigger="hover"
                content="All：指全部区域；所有标记区域：将标记过的区域作为整体来查看"
              >
                <template #reference>
                  <p class="table_p">标签<i class="el-icon-question"></i></p>
                </template>
              </el-popover>
              <el-table
                ref="dataTable"
                :data="testInfoList"
                size="mini"
                header-cell-class-name="tabelHeader"
                class="tabelStyle"
              >
                <el-table-column :fixed="true" width="35" align="center">
                  <template #default="scope">
                    <el-checkbox
                      @change="checkBoxChange(scope.row.id_label)"
                      v-model="scope.row.is_group"
                    ></el-checkbox>
                  </template>
                </el-table-column>
                <el-table-column
                  v-for="item in getCol(columns)"
                  :key="item.prop"
                  :label="item.label"
                  :prop="item.prop"
                  align="center"
                  :fixed="item.fixed"
                  width="100"
                >
                </el-table-column>
              </el-table>
            </div>
          </el-card>
          <!--FPS-->
          <el-card
            id="fps_line_scroll"
            v-show="fpsBoxCardShow"
            class="box-card mt-3"
          >
            <template #header>
              <h2 class="h2_style">FPS</h2>
              <el-divider></el-divider>
            </template>
            <div v-show="fpsCardShow" v-loading="loading1" class="label_style">
              <ul
                v-for="item in FPSValue"
                :key="item.label"
                style="text-align: center"
              >
                <li
                  v-if="
                    item.label != 'FPS<=10[%]' && item.label != 'FPS>=25[%]'
                  "
                >
                  {{ item.label }}
                </li>
                <li
                  v-else-if="item.label == 'FPS<=10[%]'"
                  style="text-align: center; width: 100px"
                >
                  <div style="display: flex">
                    {{ lte }}

                    <input
                      @blur="lteclick(lteValue)"
                      v-model="lteValue"
                      style="
                        width: 60px;
                        box-sizing: border-box;
                        padding-left: 10px;
                        border-radius: 3px;
                        outline: none;
                        border: 1px solid #dcdfe6;
                      "
                    />

                    <span>%</span>
                  </div>
                </li>
                <li v-else-if="item.label == 'FPS>=25[%]'">
                  <div style="display: flex">
                    {{ gte }}

                    <input
                      @blur="gteclick(gteValue)"
                      v-model="gteValue"
                      style="
                        width: 60px;
                        box-sizing: border-box;
                        padding-left: 10px;
                        border-radius: 3px;
                        outline: none;
                        border: 1px solid #dcdfe6;
                      "
                    />

                    <span>%</span>
                  </div>
                </li>
                <li>{{ item.value }}</li>
              </ul>
            </div>
            <div v-loading="loading">
              <div v-show="fpsCardShow" style="position: relative">
                <div class="lable_box" v-show="fpsShow">
                  <div
                    class="lable_item"
                    style="height: 27px; text-align: center"
                    v-for="item in lableList"
                    :key="item.id"
                    :style="{ background: item.color, width: item.width }"
                  >
                    {{ item.id_label }}
                  </div>
                </div>
                <div id="fps_line" style="width: 100%; height: 400px"></div>
                <div id="info-box"></div>
              </div>
              <br />
              <div v-show="frametimeCardShow" style="position: relative">
                <div class="lable_box" v-show="frameShow">
                  <div
                    class="lable_item"
                    style="height: 27px; text-align: center"
                    v-for="item in lableList"
                    :key="item.id"
                    :style="{ background: item.color, width: item.width }"
                  >
                    {{ item.id_label }}
                  </div>
                </div>
                <div
                  id="frametime_line"
                  style="width: 100%; height: 400px"
                ></div>
              </div>
            </div>
          </el-card>

          <!--CPU-->
          <el-card id="cpuBox" v-show="cpuCardShow" class="box-card mt-3">
            <template #header>
              <h2 class="h2_style">cpu</h2>
              <el-divider></el-divider>
            </template>
            <div v-loading="loading1" class="label_style">
              <ul v-for="item in CPUValue" :key="item.label">
                <li>{{ item.label }}</li>
                <li>{{ item.value }}</li>
              </ul>
            </div>
            <div v-loading="loading">
              <!-- <div style="position: relative">
                <div class="lable_box" v-show="cpuShow">
                  <div
                    class="lable_item"
                    style="height: 27px; text-align: center"
                    v-for="item in lableList"
                    :key="item.id"
                    :style="{ background: item.color, width: item.width }"
                  >
                    {{ item.id_label }}
                  </div>
                </div>
                <div
                  id="cpu_usage_line"
                  style="width: 100%; height: 400px"
                ></div>
              </div> -->
              <br />
              <div style="position: relative">
                <div class="lable_box" v-show="cpuShow1">
                  <div
                    class="lable_item"
                    style="height: 27px; text-align: center"
                    v-for="item in lableList"
                    :key="item.id"
                    :style="{ background: item.color, width: item.width }"
                  >
                    {{ item.id_label }}
                  </div>
                </div>
                <div
                  id="cpu_core_usage"
                  style="width: 100%; height: 400px"
                ></div>
              </div>
              <!-- <br /> -->
              <!-- <div style="position: relative">
                <div class="lable_box" v-show="cpuShow4">
                  <div
                    class="lable_item"
                    style="height: 27px; text-align: center"
                    v-for="item in lableList"
                    :key="item.id"
                    :style="{ background: item.color, width: item.width }"
                  >
                    {{ item.id_label }}
                  </div>
                </div>
                <div
                  id="cpu_usage_normalized"
                  style="width: 100%; height: 400px"
                ></div>
              </div> -->
              <!-- <br /> -->
              <!-- <div style="position: relative">
                <div class="lable_box" v-show="lableShow1">
                  <div
                    class="lable_item"
                    style="height: 27px; text-align: center"
                    v-for="item in lableList"
                    :key="item.id"
                    :style="{ background: item.color, width: item.width }"
                  >
                    {{ item.id_label }}
                  </div>
                </div>
                <div
                  id="cpu_freq_line"
                  style="width: 100%; height: 400px"
                ></div>
              </div> -->
              <!-- <br /> -->
              <!-- <div style="position: relative">
                <div class="lable_box" v-show="cpuShow2">
                  <div
                    class="lable_item"
                    style="height: 27px; text-align: center"
                    v-for="item in lableList"
                    :key="item.id"
                    :style="{ background: item.color, width: item.width }"
                  >
                    {{ item.id_label }}
                  </div>
                </div>
                <div id="cpu_clock" style="width: 100%; height: 400px"></div>
              </div> -->
            </div>
          </el-card>

          <!--PSS-->
          <el-card id="MemoryBox" v-show="MemoryCardshow" class="box-card mt-3">
            <template #header>
              <h2 class="h2_style">Memory</h2>
              <el-divider></el-divider>
            </template>

            <div v-loading="loading1" class="label_style">
              <ul v-for="item in MemoryValue" :key="item.label">
                <li>{{ item.label }}</li>
                <li>{{ item.value }}</li>
              </ul>
            </div>
            <div v-loading="loading">
              <!-- <div style="position: relative">
                <div class="lable_box" v-show="pssShow">
                  <div
                    class="lable_item"
                    style="height: 27px; text-align: center"
                    v-for="item in lableList"
                    :key="item.id"
                    :style="{ background: item.color, width: item.width }"
                  >
                    {{ item.id_label }}
                  </div>
                </div>
                <div id="pss_line" style="width: 100%; height: 400px"></div>
              </div>
              <br /> -->
              <div style="position: relative">
                <div class="lable_box" v-show="memoryShow">
                  <div
                    class="lable_item"
                    style="height: 27px; text-align: center"
                    v-for="item in lableList"
                    :key="item.id"
                    :style="{ background: item.color, width: item.width }"
                  >
                    {{ item.id_label }}
                  </div>
                </div>
                <div
                  id="memory_detail"
                  style="width: 100%; height: 400px"
                ></div>
              </div>
            </div>
          </el-card>

          <!--VSS-->
          <el-card id="gpuBox" v-show="GpuCardShow" class="box-card mt-3">
            <template #header>
              <h2 class="h2_style">GPU</h2>
              <el-divider></el-divider>
            </template>
            <div v-loading="loading1" class="label_style">
              <ul v-for="item in GPUValue" :key="item.label">
                <li>{{ item.label }}</li>
                <li>{{ item.value }}</li>
              </ul>
            </div>
            <div v-loading="loading">
              <div style="position: relative">
                <div class="lable_box" v-show="gpuShow">
                  <div
                    class="lable_item"
                    style="height: 27px; text-align: center"
                    v-for="item in lableList"
                    :key="item.id"
                    :style="{ background: item.color, width: item.width }"
                  >
                    {{ item.id_label }}
                  </div>
                </div>
                <div id="gpu_usage" style="width: 100%; height: 400px"></div>
              </div>
            </div>
          </el-card>
          <el-card id="gpuBox" v-show="GpuCardShow" class="box-card mt-3">
            <template #header>
              <h2 class="h2_style">GPU Memory</h2>
              <el-divider></el-divider>
            </template>
            <div v-loading="loading1" class="label_style">
              <ul v-for="item in GPUMemoryUsage" :key="item.label">
                <li>{{ item.label }}</li>
                <li>{{ item.value }}</li>
              </ul>
            </div>
            <div v-loading="loading">
              <div style="position: relative">
                <div class="lable_box" v-show="gpuShow">
                  <div
                    class="lable_item"
                    style="height: 27px; text-align: center"
                    v-for="item in lableList"
                    :key="item.id"
                    :style="{ background: item.color, width: item.width }"
                  >
                    {{ item.id_label }}
                  </div>
                </div>
                <div id="gpu_memory" style="width: 100%; height: 400px"></div>
              </div>
            </div>
          </el-card>
          <el-card id="gpuBox" v-show="GpuCardShow" class="box-card mt-3">
            <template #header>
              <h2 class="h2_style">Render</h2>
              <el-divider></el-divider>
            </template>
            <div v-loading="loading1" class="label_style">
              <ul v-for="item in renderValue" :key="item.label">
                <li>{{ item.label }}</li>
                <li>{{ item.value }}</li>
              </ul>
            </div>
            <div v-loading="loading">
              <div style="position: relative">
                <div class="lable_box" v-show="gpuShow">
                  <div
                    class="lable_item"
                    style="height: 27px; text-align: center"
                    v-for="item in lableList"
                    :key="item.id"
                    :style="{ background: item.color, width: item.width }"
                  >
                    {{ item.id_label }}
                  </div>
                </div>
                <div id="gpu_usage" style="width: 100%; height: 400px"></div>
              </div>
            </div>
          </el-card>
          <el-card id="gpuBox" v-show="GpuCardShow" class="box-card mt-3">
            <template #header>
              <h2 class="h2_style">IO</h2>
              <el-divider></el-divider>
            </template>
            <div v-loading="loading1" class="label_style">
              <ul v-for="item in ioValue" :key="item.label">
                <li>{{ item.label }}</li>
                <li>{{ item.value }}</li>
              </ul>
            </div>
            <div v-loading="loading">
              <div style="position: relative">
                <div class="lable_box" v-show="gpuShow">
                  <div
                    class="lable_item"
                    style="height: 27px; text-align: center"
                    v-for="item in lableList"
                    :key="item.id"
                    :style="{ background: item.color, width: item.width }"
                  >
                    {{ item.id_label }}
                  </div>
                </div>
                <div id="io" style="width: 100%; height: 400px"></div>
              </div>
            </div>
          </el-card>
          <el-card id="gpuBox" v-show="GpuCardShow" class="box-card mt-3">
            <template #header>
              <h2 class="h2_style">Thread</h2>
              <el-divider></el-divider>
            </template>
            <div v-loading="loading1" class="label_style">
              <ul v-for="item in threadValue" :key="item.label">
                <li>{{ item.label }}</li>
                <li>{{ item.value }}</li>
              </ul>
            </div>
            <div v-loading="loading">
              <div style="position: relative">
                <div class="lable_box" v-show="gpuShow">
                  <div
                    class="lable_item"
                    style="height: 27px; text-align: center"
                    v-for="item in lableList"
                    :key="item.id"
                    :style="{ background: item.color, width: item.width }"
                  >
                    {{ item.id_label }}
                  </div>
                </div>
                <div id="thread" style="width: 100%; height: 400px"></div>
              </div>
            </div>
          </el-card>
          <el-card id="gpuBox" v-show="GpuCardShow" class="box-card mt-3">
            <template #header>
              <h2 class="h2_style">Handle</h2>
              <el-divider></el-divider>
            </template>
            <div v-loading="loading1" class="label_style">
              <ul v-for="item in handledValue" :key="item.label">
                <li>{{ item.label }}</li>
                <li>{{ item.value }}</li>
              </ul>
            </div>
            <div v-loading="loading">
              <div style="position: relative">
                <div class="lable_box" v-show="gpuShow">
                  <div
                    class="lable_item"
                    style="height: 27px; text-align: center"
                    v-for="item in lableList"
                    :key="item.id"
                    :style="{ background: item.color, width: item.width }"
                  >
                    {{ item.id_label }}
                  </div>
                </div>
                <div id="Handle" style="width: 100%; height: 400px"></div>
              </div>
            </div>
          </el-card>

          <!--NetWork-->

          <!--整机状态-->

          <!--MONO堆内存-->

          <!--渲染趋势-->

          <el-dialog v-model="tableAddShow">
            <el-table
              :data="tableList_new"
              border
              class="my-table"
              :key="itemKey"
              @sort-change="sort_change"
            >
              <el-table-column label="搜索">
                <template #header>
                  <div style="width: 240px; padding: 10px">
                    <el-input
                      v-model="serch"
                      @change="serchChange"
                      size="mini"
                      width="200"
                      placeholder="输入名称关键字搜索"
                    ></el-input>
                  </div>
                </template>
                <el-table-column
                  show-overflow-tooltip="false"
                  prop="name"
                  label="函数"
                >
                  <template #default="scope">
                    <span class="ellipsis">{{ scope.row.name }}</span>
                  </template>
                </el-table-column>
                <el-table-column
                  prop="rate"
                  sortable="average_value"
                  width="220"
                  label="平均耗时(ms)"
                >
                  <template #default="scope">
                    <span>{{ scope.row.average_value }}</span>
                  </template>
                </el-table-column>
                <el-table-column
                  prop="rate"
                  sortable="custom"
                  width="80"
                  label="占比"
                >
                  <template #default="scope">
                    <span>{{ scope.row.rate }}%</span>
                  </template>
                </el-table-column>

                <el-table-column width="70" label="趋势">
                  <template #default="scope">
                    <el-checkbox
                      :disabled="scope.row.id === 9999999"
                      v-model="scope.row.check"
                      @change="
                        checkChange(
                          scope.row.check,
                          scope.row.id,
                          scope.row.name
                        )
                      "
                    ></el-checkbox>
                  </template>
                </el-table-column>
              </el-table-column>
            </el-table>
            <el-pagination
              class="page_count spacName"
              style="text-align: right; margin-top: 10px"
              v-model:currentPage="currentPage"
              page-size="10"
              :total="total"
              layout="total, prev, pager, next, jumper"
              @current-change="handleCurrentChange"
            ></el-pagination>
          </el-dialog>
          <!--FPS-->

          <!-- 页尾 -->
          <div class="footer">
            Copyright&ensp;©&ensp;2021
            &ensp;品质管理部成都二组.&ensp;自动化平台&ensp;企业微信联系：<span
              >pagezhang,&ensp;blackcheng</span
            >
          </div>
        </div>
        <el-backtop></el-backtop>

        <el-drawer
          class="tree_rgb"
          v-model="showDrawer"
          v-show="showDrawer"
          :direction="'ltr'"
          :size="'14%'"
          style="background: rgba(255, 255, 255, 0.5)"
          :before-close="handleDrawerClose"
          :append-to-body="true"
          :lock-scroll="false"
        >
          <!-- 在这里添加您的内容 -->
          <el-tree
            v-loading="checkLoading"
            :data="treeData"
            node-key="id"
            ref="tree"
            :props="defaultProps"
          >
            <!-- 使用插槽自定义树节点内容 -->
            <template #default="{ data }">
              <el-checkbox
                @change="handleChangeRow(data)"
                v-model="data.is_check"
              ></el-checkbox
              ><span
                @click="textScroll(data.label)"
                style="font-size: 14px; width: 100%"
                >{{ data.label }}</span
              >
            </template>
          </el-tree>
        </el-drawer>
      </el-main>
    </el-container>
  </el-container>
  <div id="testnum"><div id="cs" style="width: 210px; color: #fff">.</div></div>
  <div
    class="down_nav_list"
    :style="{ width: innerwidth, transition: trans_time }"
  >
    <div v-show="rightBtn" class="gallery__box">
      <ul id="scro" class="gallery__list">
        <li
          :id="item.time"
          v-for="(item, index) in pictureArr"
          :class="{ select: displaylist == index }"
          :key="index"
        >
          <img @click="btn(index)" :src="item.img" style="width: 210px" />
          <p class="time_stap" style="color: #666">{{ item.time }}</p>
        </li>
      </ul>
    </div>
    <div @click="maskBtn($event)" v-show="showMask" class="gallery__big">
      <div class="gallery__big_box">
        <div ref="mask" class="gallery__big_wrap">
          <i
            @click="leftBtn(maskImg?.img)"
            class="el-icon-arrow-left"
            style="
              display: inline-block;
              height: 100%;
              font-size: 54px;
              cursor: pointer;
              color: #fff;
            "
          ></i>
          <img :src="maskImg.img" />
          <i
            @click="rightBtn1(maskImg?.img)"
            class="el-icon-arrow-right"
            style="
              display: inline-block;
              height: 100%;
              font-size: 54px;
              cursor: pointer;
              color: #fff;
            "
          ></i>
        </div>
      </div>
    </div>
    <button
      v-show="rightBtn"
      :disabled="closePictureBtn"
      @click="pictureSwitch"
      class="gallery_btn"
    >
      <i class="el-icon-d-arrow-left"></i>
    </button>
    <button v-if="false" @click="openBtn()" class="gallery_btn1">
      <i class="el-icon-d-arrow-right"></i>
    </button>
  </div>
</template>

<script>
import {
  dispatchGetPerfAvgdData,
  dispatchDownloadCsv,
  dispatchGetLabelInfo,
  dispatchGetperfInfo,
  dispatchGetPerfSecondData,
  dispatchGetTestInfo,
  dispatchGetlogDownload,
  dispatchChangeFPSlte,
  dispatchChangeFPSgte,
  dispatchGetPerfIdTest,
  dispatchGetPerformanceAovTrend,
  dispatchDeepPerformancefuncList,
  dispatchDeepPerformanceCpuCpuByFrame,
  dispatchDeepPerformanceTrendNode,
  dispatchGetLabelInfoLabel,
} from "@/store/performance/actions";
import * as echarts from "echarts";
import { store } from "@/store";
import { getLocalProject } from "@/utils";
import {
  readLabelInfo,
  readPerfInfo,
  readPerfSecondData,
  readTestInfo,
  readLogDownload,
  readChangeFPSlte,
  readChangeFPSgte,
  readPerfReportIdTest,
  readAvgData,
  readGetdeepfuncList,
  readGetdeepCpuByFrame,
  readGetdeepTrendNode,
  readLabelInfoLabel,
} from "@/store/performance/getters";
import Log from "./Log.vue";
export default {
  name: "app",
  components: {},
  data: function () {
    this.dataZoom = [
      // {
      //     type: 'inside',
      //     // show: true,
      //     start: 0,
      //     end: 100,
      // },
      {
        type: "slider",
        start: 0,
        end: 100,
        height: 20,
      },
    ];

    this.chartSettings = {
      // dataZoom: [
      //   // {
      //   //   type: "slider",
      //   //   start: 0,
      //   //   end: 100,
      //   //   height: 14,
      //   //   fillerColor: "#4371fd",
      //   //   showDataShadow: false,
      //   // },
      // ],
      dataZoom: [
        {
          start: this.startValue,
          end: this.endValue,
          // end: 100 - 1500 / 31, //默认为100
          type: "slider",
          yAxisIndex: "false",
          show: true,
          xAxisIndex: [0],
          // handleSize: 0, //滑动条的 左右2个滑动条的大小
          height: 14, //组件高度
          // left: 50, //左边的距离
          // right: 40, //右边的距离
          bottom: 40, //右边的距离
          handleColor: "#ddd", //h滑动图标的颜色
          handleStyle: {
            borderColor: "#cacaca",
            borderWidth: "1",
            shadowBlur: 2,
            background: "#ddd",
            shadowColor: "#ddd",
          },
          fillerColor: new echarts.graphic.LinearGradient(1, 0, 0, 0, [
            {
              //给颜色设置渐变色 前面4个参数，给第一个设置1，第四个设置0 ，就是水平渐变
              //给第一个设置0，第四个设置1，就是垂直渐变
              offset: 0,
              color: "#1eb5e5",
            },
            {
              offset: 1,
              color: "#5ccbb1",
            },
          ]),
          backgroundColor: "#ddd", //两边未选中的滑动条区域的颜色
          showDataShadow: false, //是否显示数据阴影 默认auto
          // showDetail: false, //即拖拽时候是否显示详细数值信息 默认true
          handleIcon:
            "M-292,322.2c-3.2,0-6.4-0.6-9.3-1.9c-2.9-1.2-5.4-2.9-7.6-5.1s-3.9-4.8-5.1-7.6c-1.3-3-1.9-6.1-1.9-9.3c0-3.2,0.6-6.4,1.9-9.3c1.2-2.9,2.9-5.4,5.1-7.6s4.8-3.9,7.6-5.1c3-1.3,6.1-1.9,9.3-1.9c3.2,0,6.4,0.6,9.3,1.9c2.9,1.2,5.4,2.9,7.6,5.1s3.9,4.8,5.1,7.6c1.3,3,1.9,6.1,1.9,9.3c0,3.2-0.6,6.4-1.9,9.3c-1.2,2.9-2.9,5.4-5.1,7.6s-4.8,3.9-7.6,5.1C-285.6,321.5-288.8,322.2-292,322.2z",
          filterMode: "filter",
        },
        //下面这个属性是里面拖到
        {
          type: "inside",
          show: true,
          xAxisIndex: [0],
          // zoomLock: false,
          disabled: true, // 禁用鼠标滚动缩放
          //  start: 0,//默认为1
          //  end: 100-1500/31,//默认为100
        },
      ],

      toolbox: {
        feature: {
          saveAsImage: {},
        },
      },

      tooltip: {
        trigger: "axis",
        axisPointer: {
          // 坐标轴指示器，坐标轴触发有效
          type: "line", // 默认为直线，可选为：'line' | 'shadow'
        },
      },
      legend: {
        type: "scroll",
        y: "bottom",
      },
      grid: {
        left: "3%",
        right: "4%",
        bottom: "25%",
        top: "25%",
        // containLabel: true,    死都别加
      },
      yAxis: {
        type: "value",
      },
      itemStyle: {
        normal: {
          color: "#3ba272",
          lineStyle: {
            width: 1, // 正常时的折线宽度
          },
        },
        emphasis: {
          lineStyle: {
            width: 1, // hover时的折线宽度
          },
        },
      },
      itemStyle2: {
        normal: {
          lineStyle: {
            width: 1,
          },
        },
        emphasis: {
          lineStyle: {
            width: 1, // hover时的折线宽度
          },
        },
      },
      // timeline: {
      //   lineStyle: {
      //     width: 2,
      //   },
      // },
      // series: [
      //     {
      //         name: '用电量',
      //         type: 'line',
      //         smooth: true,
      //         markArea: {
      //             data: [
      //                 [{
      //                     name: '早高峰',
      //                     xAxis: 20
      //                 }, {
      //                     xAxis: 30
      //                 }]
      //             ]
      //         }
      //     }
      // ],
    };
    this.legend = {
      type: "scroll",
      y: "bottom",
    };

    return {
      showDrawer: false,
      opacity: 0,
      frameShow: true,
      month_new: 0,
      lte: "FPS<=",
      lteValue: "10",
      gte: "FPS>=",
      allselecitonList: ["all"],
      gteValue: "25",
      flowShow: true,
      gpuShow2: true,
      csWithchShow: true,
      wakeupsShow: true,
      memoryShow: true,
      fps_seris_data: [],
      cpu_usage_line_data: [],
      cpu_usage_normalized_data: [],
      cpu_core_usage_data: [],
      analyse_data: [],
      startValue: 0,
      endValue: 100,
      temp_line_data: [],
      pss_line_data: [],
      flow_line_data: [],
      frametime_line_data: [],
      gpu_general_counter_data: [],
      gpu_memory_counter_data: [],
      memory_detail_data: [],
      gpu_shader_counter_data: [],
      wakeups_data: [],
      cswitch_data: [],
      cpu_freq_line_data: [],
      electric_line_data: [],
      cpu_clock_data: [],
      gpuShow1: true,
      gpuShow: true,
      pssShow: true,
      cpuShow2: true,
      fpsShow: true,
      cpuShow: true,
      cpuShow4: true,
      cpuShow1: true,
      EnergyShow: true,
      lableShow1: true,
      lableShow3: true,
      deviceTableData: [],
      rightBtn: true,
      multipleSelection: [],
      file: 0,
      closePictureBtn: false,
      showMask: false,
      GpuCardShow: true,
      cpuCardShow: true,
      wakeupsBoxCardShow: true,
      statusCardShow: true,
      modelStatusShow: true,
      MemoryCardshow: true,
      displaylist: "",
      flag: true,
      trans_time: "",
      innerwidth: "",
      chartDataFPS: {},
      chartDataSec: {},
      chartDatacustom: {},
      chartDataFrame: {},
      chartDataCPU: {},
      chartDataCPUFreq: {},
      chartDataPSS: {},
      chartDataVSS: {},
      chartDataFlow: {},
      chartDataMonoMem: {},
      chartDataDrawCall: {},
      chartDataTriangle: {},
      chartDataTemp: {},
      chartDataElectric: {},
      treeData: [
        {
          id: 1,
          is_check: true,
          label: "FPS",
          children: [
            // { id: 6, label: "fps", is_check: true },
            // { id: 2, label: "BigJank", is_check: true },
            // { id: 3, label: "InterFrame", is_check: true },
            // { id: 4, label: "Jank", is_check: true },
            // { id: 5, label: "Stutter", is_check: true },
          ],
        },
        {
          id: 8,
          is_check: true,
          label: "FrameTime",
          children: [
            // { id: 6, label: "fps", is_check: true },
            // { id: 2, label: "BigJank", is_check: true },
            // { id: 3, label: "InterFrame", is_check: true },
            // { id: 4, label: "Jank", is_check: true },
            // { id: 5, label: "Stutter", is_check: true },
          ],
        },
        {
          id: 101,
          is_check: true,
          label: "线程函数",
          children: [],
        },
        {
          id: 9,
          is_check: true,
          label: "CPU",
          children: [
            { id: 19, label: "CPU Usage", is_check: true },
            { id: 20, label: "CPU Core Usage", is_check: true },
            { id: 21, label: "CPU Usage(Normalized)", is_check: true },
            { id: 22, label: "CPU Core USage(Normalized)", is_check: true },
            { id: 23, label: "CPU Clock", is_check: true },
          ],
        },
        {
          id: 10,
          is_check: true,
          label: "Memory",
          children: [
            { id: 40, label: "Memory Usage", is_check: true },
            { id: 41, label: "MemoryDetail", is_check: true },
          ],
        },
        {
          id: 11,
          is_check: true,
          label: "GPU",
          children: [
            { id: 90, label: "GPU General Counter", is_check: true },
            { id: 91, label: "GPU Memory Counter", is_check: true },
            { id: 92, label: "GPU Shader Counter", is_check: true },
          ],
        },

        {
          id: 12,
          is_check: true,

          label: "NetWork",
          children: [],
        },
        {
          id: 17,
          is_check: true,
          label: "温度",
          children: [],
        },
        {
          id: 13,
          is_check: true,
          label: "Energy",
          children: [],
        },
        {
          id: 65,
          is_check: true,
          label: "CSwitch",
          children: [],
        },
        {
          id: 66,
          is_check: true,
          label: "Wakeups",
          children: [],
        },
      ],
      defaultProps: {
        children: "children",
        label: "label",
      },
      list: [],
      loading: false,
      loading1: false,
      pictureData: {},
      checkLoading: false,
      logUrl: "",
      treeNum: 0,
      testInfo0: {
        date: "-",
        timestamp_start: "-",
        period: null,
        pkgname: "-",
        game_version: "-",
        tester: "-",
        device: "-",
        remark: null,
        avg_fps: "-",
        max_pss: "-",
        max_mono_used: "-",
        max_mono_total: "-",
        avg_cpu: "-",
        fps_lt_10_pcnt: "-",
        fps_lt_18_pcnt: "-",
        fps_lt_25_pcnt: "-",
        fps_lt_40_pcnt: "-",
        cpu_lt_60_pcnt: "-",
        cpu_lt_80_pcnt: "-",
        dps: "-",
        avg_dc: "-",
        max_dc: "-",
        max_triangle: "-",
        duration: "-",
        game_scene: null,
        avg_flow: "-",
        max_swap: "-",
        max_vss: "-",
        max_swap_add_pss: "-",
        lag_pcnt: "-",
      },
      maskImg: {
        img: "",
      },
      pictureList: [],
      timeList: [],
      pictureArr: [],
      frametimeCardShow: true,
      memory_detail: [
        "NativePss[MB]",
        "Gfx[MB]",
        "GL[MB]",
        "JavaHeap[MB]",
        "Unknown[MB]",
        "DalvikHeap[MB]",
        "DalvikOther[MB]",
        "Stack[MB]",
        "Cursor[MB]",
        "Ashmem[MB]",
        "OtherDev[MB]",
        ".so_mmap[MB]",
        ".jar_mmap[MB]",
        ".apk_mmap[MB]",
        ".ttf_mmap[MB]",
        ".dex_mmap[MB]",
        "Other_mmap[MB]",
        ".oat_mmap[MB]",
        ".art_mmap[MB]",
        "EGL_mtrack[MB]",
        "Other_mtrack[MB]",
      ],
      ChangeFPS: {
        lteFPS: "-",
        gteFPS: "-",
      },
      testInfo: {
        date: "-",
        timestamp_start: "-",
        period: null,
        pkgname: "-",
        game_version: "-",
        tester: "-",
        device: "-",
        remark: null,
        avg_fps: "-",
        max_pss: "-",
        max_mono_used: "-",
        max_mono_total: "-",
        avg_cpu: "-",
        fps_lt_10_pcnt: "-",
        fps_lt_18_pcnt: "-",
        fps_lt_25_pcnt: "-",
        fps_lt_40_pcnt: "-",
        cpu_lt_60_pcnt: "-",
        cpu_lt_80_pcnt: "-",
        dps: "-",
        avg_dc: "-",
        max_dc: "-",
        max_triangle: "-",
        duration: "-",
        game_scene: null,
        avg_flow: "-",
        max_swap: "-",
        max_vss: "-",
        max_swap_add_pss: "-",
        lag_pcnt: "-",
        gc_freq: "-",
        gc_cnt: "-",
      },
      CSwitchBoxCardShow: true,
      fpsCardShow: true,
      fpsBoxCardShow: true,
      testInfo2: {
        date: "-",
        timestamp_start: "-",
        period: null,
        pkgname: "-",
        game_version: "-",
        tester: "-",
        device: "-",
        remark: null,
        avg_fps: "-",
        max_pss: "-",
        max_mono_used: "-",
        max_mono_total: "-",
        avg_cpu: "-",
        fps_lt_10_pcnt: "-",
        fps_lt_18_pcnt: "-",
        fps_lt_25_pcnt: "-",
        fps_lt_40_pcnt: "-",
        cpu_lt_60_pcnt: "-",
        cpu_lt_80_pcnt: "-",
        dps: "-",
        avg_dc: "-",
        max_dc: "-",
        max_triangle: "-",
        duration: "-",
        game_scene: null,
        avg_flow: "-",
        max_swap: "-",
        max_vss: "-",
        max_swap_add_pss: "-",
        lag_pcnt: "-",
        gc_freq: "-",
        gc_cnt: "-",
      },
      testInfo3: {
        date: "-",
        timestamp_start: "-",
        period: null,
        pkgname: "-",
        game_version: "-",
        tester: "-",
        device: "-",
        remark: null,
        avg_fps: "-",
        max_pss: "-",
        max_mono_used: "-",
        max_mono_total: "-",
        avg_cpu: "-",
        fps_lt_10_pcnt: "-",
        fps_lt_18_pcnt: "-",
        fps_lt_25_pcnt: "-",
        fps_lt_40_pcnt: "-",
        cpu_lt_60_pcnt: "-",
        cpu_lt_80_pcnt: "-",
        dps: "-",
        avg_dc: "-",
        max_dc: "-",
        max_triangle: "-",
        duration: "-",
        game_scene: null,
        avg_flow: "-",
        max_swap: "-",
        max_vss: "-",
        max_swap_add_pss: "-",
        lag_pcnt: "-",
        gc_freq: "-",
        gc_cnt: "-",
      },
      analyseCardShow: true,
      testInfoList: [],
      testInfoList2: [],
      lableList: [],
      lableList3: [],
      lablecolorList1: [],
      threadShow: true,
      lableColorList: [
        "rgba(237, 86, 100)",
        "rgba(145, 124, 190)",
        "rgba(94, 190, 181)",
        "rgba(237, 131, 92)",
        "rgba(102, 132, 213)",
        "rgba(250, 203, 97)",
        "rgba(59, 162, 114)",
        "rgba(102, 132, 213)",
        "rgba(53, 166, 159)",
        "rgba(250, 203, 97)",
        "rgba(237, 86, 100)",
        "rgba(145, 124, 190)",
        "rgba(94, 190, 181)",
        "rgba(237, 131, 92)",
        "rgba(102, 132, 213)",
        "rgba(250, 203, 97)",
        "rgba(59, 162, 114)",
        "rgba(102, 132, 213)",
        "rgba(53, 166, 159)",
        "rgba(250, 203, 97)",
        "rgba(237, 86, 100)",
        "rgba(145, 124, 190)",
        "rgba(94, 190, 181)",
        "rgba(237, 131, 92)",
        "rgba(102, 132, 213)",
        "rgba(250, 203, 97)",
        "rgba(59, 162, 114)",
        "rgba(102, 132, 213)",
        "rgba(53, 166, 159)",
        "rgba(250, 203, 97)",
        "rgba(237, 86, 100)",
        "rgba(145, 124, 190)",
        "rgba(94, 190, 181)",
        "rgba(237, 131, 92)",
        "rgba(102, 132, 213)",
        "rgba(250, 203, 97)",
        "rgba(59, 162, 114)",
        "rgba(102, 132, 213)",
        "rgba(53, 166, 159)",
        "rgba(250, 203, 97)",
        "rgba(237, 86, 100)",
        "rgba(145, 124, 190)",
        "rgba(94, 190, 181)",
        "rgba(237, 131, 92)",
        "rgba(102, 132, 213)",
        "rgba(250, 203, 97)",
        "rgba(59, 162, 114)",
        "rgba(102, 132, 213)",
        "rgba(53, 166, 159)",
        "rgba(250, 203, 97)",
        "rgba(237, 86, 100)",
        "rgba(145, 124, 190)",
        "rgba(94, 190, 181)",
        "rgba(237, 131, 92)",
        "rgba(102, 132, 213)",
        "rgba(250, 203, 97)",
        "rgba(59, 162, 114)",
        "rgba(102, 132, 213)",
        "rgba(53, 166, 159)",
        "rgba(250, 203, 97)",
        "rgba(237, 86, 100)",
        "rgba(145, 124, 190)",
        "rgba(94, 190, 181)",
        "rgba(237, 131, 92)",
        "rgba(102, 132, 213)",
        "rgba(250, 203, 97)",
        "rgba(59, 162, 114)",
        "rgba(102, 132, 213)",
        "rgba(53, 166, 159)",
        "rgba(250, 203, 97)",
        "rgba(237, 86, 100)",
        "rgba(145, 124, 190)",
        "rgba(94, 190, 181)",
        "rgba(237, 131, 92)",
        "rgba(102, 132, 213)",
        "rgba(250, 203, 97)",
        "rgba(59, 162, 114)",
        "rgba(102, 132, 213)",
        "rgba(53, 166, 159)",
        "rgba(250, 203, 97)",
        "rgba(237, 86, 100)",
        "rgba(145, 124, 190)",
        "rgba(94, 190, 181)",
        "rgba(237, 131, 92)",
        "rgba(102, 132, 213)",
        "rgba(250, 203, 97)",
        "rgba(59, 162, 114)",
        "rgba(102, 132, 213)",
        "rgba(53, 166, 159)",
        "rgba(250, 203, 97)",
        "rgba(237, 86, 100)",
        "rgba(145, 124, 190)",
        "rgba(94, 190, 181)",
        "rgba(237, 131, 92)",
        "rgba(102, 132, 213)",
        "rgba(250, 203, 97)",
        "rgba(59, 162, 114)",
        "rgba(102, 132, 213)",
        "rgba(53, 166, 159)",
        "rgba(250, 203, 97)",
        "rgba(237, 86, 100)",
        "rgba(145, 124, 190)",
        "rgba(94, 190, 181)",
        "rgba(237, 131, 92)",
        "rgba(102, 132, 213)",
        "rgba(250, 203, 97)",
        "rgba(59, 162, 114)",
        "rgba(102, 132, 213)",
        "rgba(53, 166, 159)",
        "rgba(250, 203, 97)",
        "rgba(237, 86, 100)",
        "rgba(145, 124, 190)",
        "rgba(94, 190, 181)",
        "rgba(237, 131, 92)",
        "rgba(102, 132, 213)",
        "rgba(250, 203, 97)",
        "rgba(59, 162, 114)",
        "rgba(102, 132, 213)",
        "rgba(53, 166, 159)",
        "rgba(250, 203, 97)",
        "rgba(237, 86, 100)",
        "rgba(145, 124, 190)",
        "rgba(94, 190, 181)",
        "rgba(237, 131, 92)",
        "rgba(102, 132, 213)",
        "rgba(250, 203, 97)",
        "rgba(59, 162, 114)",
        "rgba(102, 132, 213)",
        "rgba(53, 166, 159)",
        "rgba(250, 203, 97)",
        "rgba(237, 86, 100)",
        "rgba(145, 124, 190)",
        "rgba(94, 190, 181)",
        "rgba(237, 131, 92)",
        "rgba(102, 132, 213)",
        "rgba(250, 203, 97)",
        "rgba(59, 162, 114)",
        "rgba(102, 132, 213)",
        "rgba(53, 166, 159)",
        "rgba(250, 203, 97)",
        "rgba(237, 86, 100)",
        "rgba(145, 124, 190)",
        "rgba(94, 190, 181)",
        "rgba(237, 131, 92)",
        "rgba(102, 132, 213)",
        "rgba(250, 203, 97)",
        "rgba(59, 162, 114)",
        "rgba(102, 132, 213)",
        "rgba(53, 166, 159)",
        "rgba(250, 203, 97)",
        "rgba(237, 86, 100)",
        "rgba(145, 124, 190)",
        "rgba(94, 190, 181)",
        "rgba(237, 131, 92)",
        "rgba(102, 132, 213)",
        "rgba(250, 203, 97)",
        "rgba(59, 162, 114)",
        "rgba(102, 132, 213)",
        "rgba(53, 166, 159)",
        "rgba(250, 203, 97)",
        "rgba(237, 86, 100)",
        "rgba(145, 124, 190)",
        "rgba(94, 190, 181)",
        "rgba(237, 131, 92)",
        "rgba(102, 132, 213)",
        "rgba(250, 203, 97)",
        "rgba(59, 162, 114)",
        "rgba(102, 132, 213)",
        "rgba(53, 166, 159)",
        "rgba(250, 203, 97)",
        "rgba(237, 86, 100)",
        "rgba(145, 124, 190)",
        "rgba(94, 190, 181)",
        "rgba(237, 131, 92)",
        "rgba(102, 132, 213)",
        "rgba(250, 203, 97)",
        "rgba(59, 162, 114)",
        "rgba(102, 132, 213)",
        "rgba(53, 166, 159)",
        "rgba(250, 203, 97)",
        "rgba(237, 86, 100)",
        "rgba(145, 124, 190)",
        "rgba(94, 190, 181)",
        "rgba(237, 131, 92)",
        "rgba(102, 132, 213)",
        "rgba(250, 203, 97)",
        "rgba(59, 162, 114)",
        "rgba(102, 132, 213)",
        "rgba(53, 166, 159)",
        "rgba(250, 203, 97)",
        "rgba(237, 86, 100)",
        "rgba(145, 124, 190)",
        "rgba(94, 190, 181)",
        "rgba(237, 131, 92)",
        "rgba(102, 132, 213)",
        "rgba(250, 203, 97)",
        "rgba(59, 162, 114)",
        "rgba(102, 132, 213)",
        "rgba(53, 166, 159)",
        "rgba(250, 203, 97)",
        "rgba(237, 86, 100)",
        "rgba(145, 124, 190)",
        "rgba(94, 190, 181)",
        "rgba(237, 131, 92)",
        "rgba(102, 132, 213)",
        "rgba(250, 203, 97)",
        "rgba(59, 162, 114)",
        "rgba(102, 132, 213)",
        "rgba(53, 166, 159)",
        "rgba(250, 203, 97)",
        "rgba(237, 86, 100)",
        "rgba(145, 124, 190)",
        "rgba(94, 190, 181)",
        "rgba(237, 131, 92)",
        "rgba(102, 132, 213)",
        "rgba(250, 203, 97)",
        "rgba(59, 162, 114)",
        "rgba(102, 132, 213)",
        "rgba(53, 166, 159)",
        "rgba(250, 203, 97)",
        "rgba(237, 86, 100)",
        "rgba(145, 124, 190)",
        "rgba(94, 190, 181)",
        "rgba(237, 131, 92)",
        "rgba(102, 132, 213)",
        "rgba(250, 203, 97)",
        "rgba(59, 162, 114)",
        "rgba(102, 132, 213)",
        "rgba(53, 166, 159)",
        "rgba(250, 203, 97)",
        "rgba(237, 86, 100)",
        "rgba(145, 124, 190)",
        "rgba(94, 190, 181)",
        "rgba(237, 131, 92)",
        "rgba(102, 132, 213)",
        "rgba(250, 203, 97)",
        "rgba(59, 162, 114)",
        "rgba(102, 132, 213)",
        "rgba(53, 166, 159)",
        "rgba(250, 203, 97)",
        "rgba(237, 86, 100)",
        "rgba(145, 124, 190)",
        "rgba(94, 190, 181)",
        "rgba(237, 131, 92)",
        "rgba(102, 132, 213)",
        "rgba(250, 203, 97)",
        "rgba(59, 162, 114)",
        "rgba(102, 132, 213)",
        "rgba(53, 166, 159)",
        "rgba(250, 203, 97)",
        "rgba(237, 86, 100)",
        "rgba(145, 124, 190)",
        "rgba(94, 190, 181)",
        "rgba(237, 131, 92)",
        "rgba(102, 132, 213)",
        "rgba(250, 203, 97)",
        "rgba(59, 162, 114)",
        "rgba(102, 132, 213)",
        "rgba(53, 166, 159)",
        "rgba(250, 203, 97)",
        "rgba(237, 86, 100)",
        "rgba(145, 124, 190)",
        "rgba(94, 190, 181)",
        "rgba(237, 131, 92)",
        "rgba(102, 132, 213)",
        "rgba(250, 203, 97)",
        "rgba(59, 162, 114)",
        "rgba(102, 132, 213)",
        "rgba(53, 166, 159)",
        "rgba(250, 203, 97)",
        "rgba(237, 86, 100)",
        "rgba(145, 124, 190)",
        "rgba(94, 190, 181)",
        "rgba(237, 131, 92)",
        "rgba(102, 132, 213)",
        "rgba(250, 203, 97)",
        "rgba(59, 162, 114)",
        "rgba(102, 132, 213)",
        "rgba(53, 166, 159)",
        "rgba(250, 203, 97)",
        "rgba(237, 86, 100)",
        "rgba(145, 124, 190)",
        "rgba(94, 190, 181)",
        "rgba(237, 131, 92)",
        "rgba(102, 132, 213)",
        "rgba(250, 203, 97)",
        "rgba(59, 162, 114)",
        "rgba(102, 132, 213)",
        "rgba(53, 166, 159)",
        "rgba(250, 203, 97)",
        "rgba(237, 86, 100)",
        "rgba(145, 124, 190)",
        "rgba(94, 190, 181)",
        "rgba(237, 131, 92)",
        "rgba(102, 132, 213)",
        "rgba(250, 203, 97)",
        "rgba(59, 162, 114)",
        "rgba(102, 132, 213)",
        "rgba(53, 166, 159)",
        "rgba(250, 203, 97)",
        "rgba(237, 86, 100)",
        "rgba(145, 124, 190)",
        "rgba(94, 190, 181)",
        "rgba(237, 131, 92)",
        "rgba(102, 132, 213)",
        "rgba(250, 203, 97)",
        "rgba(59, 162, 114)",
        "rgba(102, 132, 213)",
        "rgba(53, 166, 159)",
        "rgba(250, 203, 97)",
        "rgba(237, 86, 100)",
        "rgba(145, 124, 190)",
        "rgba(94, 190, 181)",
        "rgba(237, 131, 92)",
        "rgba(102, 132, 213)",
        "rgba(250, 203, 97)",
        "rgba(59, 162, 114)",
        "rgba(102, 132, 213)",
        "rgba(53, 166, 159)",
        "rgba(250, 203, 97)",
        "rgba(237, 86, 100)",
        "rgba(145, 124, 190)",
        "rgba(94, 190, 181)",
        "rgba(237, 131, 92)",
        "rgba(102, 132, 213)",
        "rgba(250, 203, 97)",
        "rgba(59, 162, 114)",
        "rgba(102, 132, 213)",
        "rgba(53, 166, 159)",
        "rgba(250, 203, 97)",
        "rgba(237, 86, 100)",
        "rgba(145, 124, 190)",
        "rgba(94, 190, 181)",
        "rgba(237, 131, 92)",
        "rgba(102, 132, 213)",
        "rgba(250, 203, 97)",
        "rgba(59, 162, 114)",
        "rgba(102, 132, 213)",
        "rgba(53, 166, 159)",
        "rgba(250, 203, 97)",
        "rgba(237, 86, 100)",
        "rgba(145, 124, 190)",
        "rgba(94, 190, 181)",
        "rgba(237, 131, 92)",
        "rgba(102, 132, 213)",
        "rgba(250, 203, 97)",
        "rgba(59, 162, 114)",
        "rgba(102, 132, 213)",
        "rgba(53, 166, 159)",
        "rgba(250, 203, 97)",
        "rgba(237, 86, 100)",
        "rgba(145, 124, 190)",
        "rgba(94, 190, 181)",
        "rgba(237, 131, 92)",
        "rgba(102, 132, 213)",
        "rgba(250, 203, 97)",
        "rgba(59, 162, 114)",
        "rgba(102, 132, 213)",
        "rgba(53, 166, 159)",
        "rgba(250, 203, 97)",
        "rgba(237, 86, 100)",
        "rgba(145, 124, 190)",
        "rgba(94, 190, 181)",
        "rgba(237, 131, 92)",
        "rgba(102, 132, 213)",
        "rgba(250, 203, 97)",
        "rgba(59, 162, 114)",
        "rgba(102, 132, 213)",
        "rgba(53, 166, 159)",
        "rgba(250, 203, 97)",
        "rgba(237, 86, 100)",
        "rgba(145, 124, 190)",
        "rgba(94, 190, 181)",
        "rgba(237, 131, 92)",
        "rgba(102, 132, 213)",
        "rgba(250, 203, 97)",
        "rgba(59, 162, 114)",
        "rgba(102, 132, 213)",
        "rgba(53, 166, 159)",
        "rgba(250, 203, 97)",
        "rgba(237, 86, 100)",
        "rgba(145, 124, 190)",
        "rgba(94, 190, 181)",
        "rgba(237, 131, 92)",
        "rgba(102, 132, 213)",
        "rgba(250, 203, 97)",
        "rgba(59, 162, 114)",
        "rgba(102, 132, 213)",
        "rgba(53, 166, 159)",
        "rgba(250, 203, 97)",
        "rgba(237, 86, 100)",
        "rgba(145, 124, 190)",
        "rgba(94, 190, 181)",
        "rgba(237, 131, 92)",
        "rgba(102, 132, 213)",
        "rgba(250, 203, 97)",
        "rgba(59, 162, 114)",
        "rgba(102, 132, 213)",
        "rgba(53, 166, 159)",
        "rgba(250, 203, 97)",
        "rgba(237, 86, 100)",
        "rgba(145, 124, 190)",
        "rgba(94, 190, 181)",
        "rgba(237, 131, 92)",
        "rgba(102, 132, 213)",
        "rgba(250, 203, 97)",
        "rgba(59, 162, 114)",
        "rgba(102, 132, 213)",
        "rgba(53, 166, 159)",
        "rgba(250, 203, 97)",
      ],
      url: "/api/perf/tag-info?id=" + Number(this.id_test),
      //       PCPerfChineseFields = {
      //     "avg_fps": "Avg(FPS)",
      //     "Smooth": "Smooth(稳帧指数)",
      //     'SmallJank(/10min)': 'SmallJank(微小卡顿)\n(/10min)',
      //     'Jank(/10min)': 'Jank(卡顿)(/10min)',
      //     'BigJank(/10min)': 'BigJank(严重卡顿)(/10min)',
      //     'Std(FPS)': 'Std(FPS)',
      //     'var_fps': 'Var(FPS)',
      //     'Stutter[%]': 'Stutter(卡顿率) [%]',
      //     'avg_cpu': 'Avg(AppCPU) [%]',
      //     'fps_lt_18_pcnt': 'FPS>=18 [%]',
      //     'fps_lt_25_pcnt': 'FPS>=25 [%]',
      //     'Drop(FPS)[/h]': 'Drop(FPS)[/h]',
      //     'min_fps': 'Min(FPS)',
      //     'Median(FPS)': 'Median(FPS)',
      //     'MedRange(FPS)[%]': 'MedRange(FPS)[%]',
      //     'Avg(FTime)': 'Avg(FTime)',
      //     'Std(FTime)': 'Std(FTime)',
      //     'Var(FTime)': 'Var(FTime)',
      //     'FTime>=100[%]': 'FTime>=100[%]',
      //     'Delta(FTime)>100ms[/h]': 'Delta(FTime)>100ms[/h]',
      //     'cpu_lt_60_pcnt': 'AppCPU<=60 [%]',
      //     'cpu_lt_80_pcnt': 'AppCPU<=80 [%]',
      //     'AppUserCPU<=60[%]': 'AppUserCPU<=60 [%]',
      //     'AppUserCPU<=80[%]': 'AppUserCPU<=80 [%]',
      //     'AppKernelCPU<=60[%]': 'AppKernelCPU<=60 [%]',
      //     'AppKernelCPU<=80[%]': 'AppKernelCPU<=80 [%]',
      //     'WorkingSet': 'Avg(VirtualBytes) [MB]',
      //     'PrivateBytes': 'Avg(PrivateBytes) [MB]',
      //     'VirtualBytes': 'Avg(VirtualBytes) [MB]',
      //     'PageFaults': 'Avg(PageFaults)',
      //     'GTemp0': 'Avg(GTemp0) [℃]',
      //     'GTemp2': 'Avg(GTemp2) [℃]',
      //     'AppGUsage3D0': 'Avg(AppGUsage3D0) [%]',
      //     'TotalGUsage3D0': 'Avg(TotalGUsage3D0) [%]',
      //     'TotalGUsage3D1': 'Avg(TotalGUsage3D1) [%]',
      //     'TotalGUsage3D2': 'Avg(TotalGUsage3D2) [%]',
      //     'IOReadCount': 'Avg(IOReadCount)',
      //     'IOReadBytes': 'Avg(IOReadBytes)',
      //     'IOWriteCount': 'Avg(IOWriteCount)',
      //     'IOWriteBytes': 'Avg(IOWriteBytes)',
      //     'ThreadCount': 'Avg(ThreadCount)',
      //     'HandleCount': 'Avg(HandleCount)',
      //     'AppDedicated0': 'Avg(AppDedicated0) [bytes]',
      //     'AppShared0': 'Avg(AppShared0) [bytes]',
      //     'Dedicated0': 'Avg(Dedicated0) [bytes]',
      //     'Shared0': 'Avg(Shared0) [bytes]',
      //     'Dedicated1': 'Avg(Dedicated1) [bytes]',
      //     'Shared1': 'Avg(Shared1) [bytes]',
      //     'avg_dc': 'Avg(DrawCall)'
      // },
      columns: [
        // {type: 'selection', align: 'center', fixed: true},
        { prop: "tagName", label: "标签", align: "center", fixed: true },
        { prop: "avg_fps", label: "Avg(FPS)" },
        { prop: "var_fps", label: "Var(FPS)" },
        { prop: "lag_pcnt", label: "卡顿率[%]" },
        { prop: "big_jank", label: "BigJank" },
        { prop: "jank", label: "Jank" },
        { prop: "fps_lt_10_pcnt", label: "FPS<10[%]" },
        { prop: "fps_lt_18_pcnt", label: "FPS>18[%]" },
        { prop: "fps_lt_25_pcnt", label: "FPS>25[%]" },
        { prop: "fps_lt_40_pcnt", label: "FPS>40[%]" },
        { prop: "avg_cpu", label: "Avg(CPU)[%]" },
        { prop: "cpu_lt_60_pcnt", label: "CPU<60[%]" },
        { prop: "cpu_lt_80_pcnt", label: "CPU<80[%]" },
        { prop: "max_pss", label: "Max(PSS)[M]" },
        { prop: "avg_pss", label: "Avg(PSS)[M]" },
        { prop: "max_mono_used", label: "Max(MonoUsed)[M]" },
        { prop: "max_mono_total", label: "Max(MonoTotal)[M]" },
        // {prop: 'dps', label: 'DPS[KB/s]'},
        { prop: "avg_dc", label: "Avg(Drawcall)[次]" },
        { prop: "max_dc", label: "Max(Drawcall)[次]" },
        { prop: "max_triangle", label: "Max(Triangle)[次]" },
        { prop: "duration", label: "时长[ms]" },
        // {prop: 'avg_flow', label: 'Avg(Flow)[KB/s]'},
        { prop: "max_swap", label: "Max(Swap)[M]" },
        { prop: "max_vss", label: "Max(Vss)[M]" },
        { prop: "max_swap_add_pss", label: "Max(SwapAddPss)[M]" },

        { prop: "lag_cnt", label: "总卡顿[次]" },
        { prop: "single_peak_lag_cnt", label: "毛刺卡顿[次]" },
        { prop: "multiple_peak_lag_cnt", label: "连续卡顿[次]" },
        { prop: "continue_low_lag_cnt", label: "持续卡顿[次]" },
        // {prop: 'lag_pcnt', label: '卡顿率[%]'},
        { prop: "lag_freq", label: "卡顿频率[次/min]" },
      ],
      form: [
        {
          type: "input",
          id: "name",
          label: "姓名",
          rules: [
            {
              required: true,
              message: "请输入姓名",
              trigger: "blur",
              transform: (v) => v && v.trim(),
            },
          ],
          el: { placeholder: "请输入姓名" },
        },
      ],
      // searchForm: [
      //     {
      //         el: {placeholder: '请输入'},
      //         label: '姓名',
      //         id: 'name',
      //         type: 'input'
      //     }
      // ],
      markArea: {
        data: [],
      },
      markAreaFrame: {
        data: [],
      },
      start_thread: 0,
      end_thread: 100,
      overviewValue: [],
      overviewValue2: [],
      FPSValue: [],
      CPUValue: [],
      renderValue: [],
      ioValue: [],
      handledValue: [],
      threadValue: [],
      MemoryValue: [],
      GPUValue: [],
      GPUMemoryUsage: [],
      NetworkCardShow: true,
      NetWorkValue: [],
      isSettingCheckedKeys: false,
      CswitchValue: [],
      WakeupsValue: [],
      paramsData: {
        task_record_id: "",
        task_group_index: "",
        device_id: "",
      },
      tableList_new: [],
      total: 0,
      serch: "",
      tableListAdd: [],
      currentPage: 1,
      tableAddShow: false,
      seies_num: 0,
      id_test: "",
      project_id: "",
    };
  },
  async created() {
    const project = Number(getLocalProject());
    // this.loading = true;
    // this.loading1 = true;

    if (this.$route.query.id_test === undefined) {
      this.paramsData.task_record_id = this.$route.query.task_record_id;
      this.paramsData.task_group_index = this.$route.query.task_group_index;
      this.paramsData.device_id = this.$route.query.device_id;
      await dispatchGetPerfIdTest(store, {
        task_record_id: Number(this.paramsData.task_record_id),
        task_group_index: Number(this.paramsData.task_group_index),
        device_id: Number(this.paramsData.device_id),
      });

      await this.getTestIdTest();
      await dispatchGetperfInfo(store, {
        id_test: this.id_test,
        // id_label: "all",
      });
      await this.getPerfInfo();
    } else {
      this.id_test = Number(this.$route.query.id_test);
      await dispatchGetperfInfo(store, {
        id_test: this.id_test,
        // id_label: "all",
      });
      await this.getPerfInfo();
      this.project_id =
        Number(this.$route.query.project) === undefined
          ? this.testInfo2.project
          : Number(this.$route.query.project);
    }

    await dispatchDeepPerformanceCpuCpuByFrame(store, {
      project: this.project_id,
      id_test: this.id_test,
    });
    await dispatchDeepPerformancefuncList(store, {
      project: this.project_id,
      id_test: this.id_test,
    });
    this.tableAddList();

    await dispatchGetTestInfo(store, {
      project: this.project_id,
      id: this.id_test,
    });
    await dispatchGetLabelInfo(store, {
      project: this.project_id,
      id_test: this.id_test,
      // id_label: "all",
    });
    // await dispatchGetLabelInfoLabel(store, {
    //   project: this.project_id,
    //   id_test: this.id_test,
    //   id_label: "all",
    // });

    // if(project===27){

    // }
    await this.getTestInfo(); //页面标题数据
    await this.getLabelInfo();
    let allData = this.testInfoList.filter((v) => v.id_label == "all")[0];
    this.getFPSValue(allData);
    // 重构结构
    // await this.labels1();

    // this.getOverview2(this.testInfo2, this.testInfo, false);
    // this.getCPUValue(this.testInfo);
    // this.getMemoryValue(this.testInfo);
    // this.getGPUValue(this.testInfo);
    // this.getNetWorkValue(this.testInfo);
    // this.getCsWitch(this.testInfo);
    // this.getWakeups(this.testInfo);
    // this.getCustom(this.testInfo2);

    // if (
    //   this.testInfo0.task_record_id != "" ||
    //   this.testInfo0.task_record_id.length > 0
    // ) {
    //   await dispatchGetlogDownload(store, {
    //     project: this.project_id,
    //     task_record_id: this.testInfo0.task_record_id,
    //     UUID: this.testInfo0.UUID,
    //     scene_id: this.testInfo0.scene_id,
    //     // id_label: "all",
    //   });
    // }

    // await this.getlogDownload();

    // // 正则判断
    // // if(project)
    // // let req = /Battle$/;

    // let req = RegExp(/_G_Battle/);
    // let hasSelectList = [];

    // // this.getLableInfo();

    // if (readPerfInfo(store).project === 27) {
    //   this.testInfoList.forEach(function (v) {
    //     if (req.test(v.tagName)) {
    //       hasSelectList.push(v.tagName);
    //     }
    //   });

    //   this.$nextTick(() => {
    //     this.testInfoList.forEach((row) => {
    //       if (hasSelectList.indexOf(row.tagName) >= 0) {
    //         this.$refs.dataTable.toggleRowSelection(row, true);
    //       }
    //     });
    //   });

    //   await dispatchGetPerfAvgdData(store, {
    //     project: this.project_id,
    //     id_test: this.id_test,
    //     id_label: hasSelectList,
    //   });
    await dispatchChangeFPSlte(store, {
      project: this.project_id,
      id_test: this.id_test,
      value: this.lteValue,
      labels: "all",
      mode: "lte",
    });
    await dispatchChangeFPSgte(store, {
      project: this.project_id,
      id_test: this.id_test,
      value: this.gteValue,
      labels: "all",
      mode: "gte",
    });
    //   await this.getTestInfo();
    //   await this.getLabelInfo();
    //   await this.getPerfInfo();
    await this.getChangeFPS();

    //   await this.getperNewInfo();
    //   await this.getFPSValue(this.testInfo3);
    //   await this.getOverview2(this.testInfo2, this.testInfo3, true);
    //   await this.getCPUValue(this.testInfo3);
    this.getFPSValue(allData);
    this.getCPUValue(allData);
    this.getMemoryValue(allData);
    this.getGPUValue(allData);
    this.getGPUMemoryValue(allData);
    this.getRenderValue(allData);
    this.getIoValue(allData);
    this.getThreadValue(allData);
    this.getHandledValue(allData);
    await dispatchGetPerfSecondData(store, {
      project: this.project_id,
      id_test: this.id_test,
      id_label: "all",
    });
    //   await this.getNetWorkValue(this.testInfo3);
    //   await this.getCsWitch(this.testInfo3);
    //   await this.getWakeups(this.testInfo3);
    //   await this.getCustom(this.testInfo3);
    //   this.loading1 = false;
    //   await this.getChangeFPS();
    await this.getData();
    await this.getLableInfo();
    //   await this.getLableInfo();
    //   let timeArr = [];
    //   this.lableList3.forEach(function (v) {
    //     hasSelectList.forEach(function (j) {
    //       if (v.id_label == j) {
    //         timeArr.push(v);
    //       }
    //     });
    //   });

    //   let labelWidthAll1 = [];

    //   let labelWidth1 = this.chartDataResult.rows.timeline.length;
    //   this.chartDataResult.rows.label.forEach(function (v) {
    //     labelWidthAll1.push((v.length / labelWidth1) * 100 + "%");
    //   });

    //   timeArr.forEach(function (v, i) {
    //     labelWidthAll1.forEach(function (j, index) {
    //       if (i == index) {
    //         v.width = j;
    //       }
    //     });
    //   });
    //   this.lableList = timeArr;
    //   let req1 = RegExp(/_G_Battle/);
    //   let arr15 = JSON.parse(JSON.stringify(this.lableList));
    //   for (let i = 0; i < arr15.length; i++) {
    //     if (req1.test(arr15[i].id_label)) {
    //       arr15[i].id_label = arr15[i].id_label.replace("_G_Battle", "");
    //     }
    //   }
    //   this.lableList = arr15;
    // } else {
    //   this.$refs.dataTable.toggleAllSelection();
    //   await dispatchChangeFPSgte(store, {
    //     project: this.project_id,
    //     id_test: this.id_test,
    //     value: this.gteValue,
    //     labels: ["all"],
    //     mode: "gte",
    //   });
    //   await dispatchChangeFPSlte(store, {
    //     project: this.project_id,
    //     id_test: this.id_test,
    //     value: this.lteValue,
    //     labels: ["all"],
    //     mode: "lte",
    //   });
    //   await this.getPerfInfo();
    //   await this.getChangeFPS();
    //   this.getFPSValue(this.testInfo);
    //   this.loading1 = false;

    //   await dispatchGetPerfSecondData(store, {
    //     project: this.project_id,
    //     id_test: this.id_test,
    //     id_label: ["all"],
    //   });
    //   await this.getData();
    //   await this.getLableInfo();
    // }

    // // this.$refs.dataTable.toggleAllSelection();
    // //
    await this.fps_series();
    await this.frametime_line_series();
    await this.cpu_usage_line_series();

    await this.cpu_usage_normalized_series();

    await this.gpu_memory_counter_series();

    await this.gpu_general_counter_series();
    await this.gpu_shader_counter_series();
    await this.wakeups_data_series();

    await this.memory_detail_series();

    await this.cpu_core_usage_series();

    this.drawPieChartFPS();
    this.drawPieChartFrameTime();
    this.drawPieChartCPUCoreUsage();
    this.drawPieChartCPUUsage();

    this.drawPieChartMemoryDetail();

    this.drawPieChartGPUGeneralCounter();
    // this.drawPieChartGPUMemoryCounter();
    this.drawPieChartGPUShaderCounter();
    this.drawPieChartWakeups();
    this.drawPieChartCPUUsageNormalized();
    // this.drawPieChartFlow();
    // this.drawAnalyseTrend();
    // if (this.testInfo0.device.toUpperCase().indexOf("IPHONE") != -1) {
    //   this.drawPieChartCsWitch();
    //   this.drawPieChartWakeups();
    // }

    // if (this.chartDatacustom?.rows?.i?.length !== 0) {
    //   this.drawPieChartMonomem();
    //   this.drawPieChartVerts();
    //   this.drawPieChartTris();
    //   this.drawPieChartDc();
    //   this.drawPieChartGc();
    // }

    // //
    // if (this.chartDataMonoMem?.rows?.timeline?.length !== 0) {
    //   this.drawPieChartMono();
    // }
    // if (this.chartDataDrawCall?.rows?.timeline?.length !== 0) {
    //   this.drawPieChartDrawCall();
    // }
    // if (this.chartDataTriangle?.rows?.timeline?.length !== 0) {
    //   this.drawPieChartTriangle();
    // }
    // if (this.chartDataTemp?.rows?.timeline?.length !== 0) {
    //   this.drawPieChartTemp();
    // }
    // if (this.chartDataElectric?.rows?.timeline?.length !== 0) {
    //   this.drawPieChartElectric();
    // }

    this.getPictureData();

    // this.drawPieChartCPUCoreUsage();
    // this.drawPieChartCPUClock();

    // //     const allNodeIds = this.getAllNodeIds(this.treeData);
    // // this.isSettingCheckedKeys = true;
    // // this.$refs.tree.setCheckedKeys(allNodeIds);
    // // this.isSettingCheckedKeys = false;

    this.loading = false;
  },

  computed: {
    // a computed getter
    downloadUrl: function () {
      // `this` points to the vm instance
      return (
        "/api/v1/performance/download_csv/?project=" +
        "&project=" +
        Number(this.project_id) +
        "&id_test=" +
        Number(this.id_test)
      );
    },
    cpu_by_frame() {
      return readGetdeepCpuByFrame(store);
    },
    cpu_by_frame_list() {
      let list = JSON.parse(JSON.stringify(readGetdeepCpuByFrame(store)));
      let list1 = [];
      list.labels.forEach((v, index) => {
        list1.push(v.map((k) => k + "_" + index));
      });

      return list1;
    },
  },

  // mounted:{

  // },
  // mounted() {
  //   this.getLabelInfo()
  //   this.deviceTableData = this.testInfoList;
  //
  //   this.$nextTick(() => {
  //     for (let i = 0; i < this.deviceTableData.length; i++) {
  //       this.$refs.dataTable.toggleRowSelection(
  //         this.deviceTableData[1].id_label,
  //         true
  //       );
  //     }
  //   });
  // },

  methods: {
    async checkBoxChange(id) {
      if (id === "all") {
        const allIsGroup = this.testInfoList.find(
          (item) => item.id_label === "all"
        ).is_group;
        this.testInfoList.forEach((item) => {
          item.is_group = allIsGroup;
        });
      } else {
        let allIsGroup = true;
        for (let i = 0; i < this.testInfoList.length; i++) {
          if (this.testInfoList[i].id_label === "all") {
            continue;
          }

          if (!this.testInfoList[i].is_group) {
            allIsGroup = false;
            break;
          }
        }

        for (let i = 0; i < this.testInfoList.length; i++) {
          if (this.testInfoList[i].id_label === "all") {
            this.testInfoList[i].is_group = allIsGroup;
          }
        }
      }
      let id_labels = this.testInfoList.filter((v) => v.is_group == true);
      let allData = {};
      if (id_labels.length == this.testInfoList.length) {
        dispatchGetLabelInfoLabel(store, {
          project: this.project_id,
          id_test: this.id_test,
          id_label: "all",
        });
        await dispatchChangeFPSlte(store, {
          project: this.project_id,
          id_test: this.id_test,
          value: this.lteValue,
          labels: "all",
          mode: "lte",
        });
        await dispatchChangeFPSgte(store, {
          project: this.project_id,
          id_test: this.id_test,
          value: this.gteValue,
          labels: "all",
          mode: "gte",
        });
        await dispatchGetPerfSecondData(store, {
          project: this.project_id,
          id_test: this.id_test,
          id_label: "all",
        });
        await this.getLabelInfo();
        allData = this.testInfoList.filter((v) => v.id_label == "all")[0];
      } else {
        await dispatchGetPerfAvgdData(store, {
          project: this.project_id,
          id_test: this.id_test,
          id_label: id_labels.map((v) => v.id_label),
        });
        await dispatchChangeFPSlte(store, {
          project: this.project_id,
          id_test: this.id_test,
          value: this.lteValue,
          labels: id_labels.map((v) => v.id_label),
          mode: "lte",
        });
        await dispatchChangeFPSgte(store, {
          project: this.project_id,
          id_test: this.id_test,
          value: this.gteValue,
          labels: id_labels.map((v) => v.id_label),
          mode: "gte",
        });
        await dispatchGetPerfSecondData(store, {
          project: this.project_id,
          id_test: this.id_test,
          id_label: id_labels.map((v) => v.id_label),
        });
        await this.getperNewInfo();
        allData = this.testInfo3;
      }
      this.getFPSValue(allData);
      this.getCPUValue(allData);
      this.getMemoryValue(allData);
      this.getGPUValue(allData);
      this.getGPUMemoryValue(allData);
      this.getRenderValue(allData);
      this.getIoValue(allData);
      this.getThreadValue(allData);
      this.getHandledValue(allData);
      await this.getData();
      await this.fps_series();
      await this.frametime_line_series();
      await this.cpu_usage_line_series();

      await this.cpu_usage_normalized_series();

      await this.gpu_memory_counter_series();

      await this.gpu_general_counter_series();
      await this.gpu_shader_counter_series();
      await this.wakeups_data_series();

      await this.memory_detail_series();

      await this.cpu_core_usage_series();

      this.drawPieChartFPS();
      this.drawPieChartFrameTime();
      this.drawPieChartCPUCoreUsage();
      this.drawPieChartCPUUsage();

      this.drawPieChartMemoryDetail();

      this.drawPieChartGPUGeneralCounter();
      // this.drawPieChartGPUMemoryCounter();
      this.drawPieChartGPUShaderCounter();
      this.drawPieChartWakeups();
      this.drawPieChartCPUUsageNormalized();
    },
    async checkChange(item, id, name) {
      await dispatchDeepPerformanceTrendNode(store, {
        project: this.localProject,
        id_test: this.id_test,
        node_id: id,
      });
      if (item) {
        this.analyse_data.push({
          name: name,
          type: "line",

          showSymbol: false,

          itemStyle: {
            normal: {
              lineStyle: {
                width: 1,
              },
            },
            emphasis: {
              lineStyle: {
                width: 1, // hover时的折线宽度
              },
            },
          },
          yAxisIndex: 0,
          data: readGetdeepTrendNode(store).map((item) =>
            item === null ? 0 : item
          ),
        });
      } else {
        let target_index = this.analyse_data.findIndex((v) => v.name == name);
        this.analyse_data.splice(target_index, 1);
      }

      this.drawAnalyseTrend();
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      this.tableList_new = this.tableListAdd.slice(
        (this.currentPage - 1) * 10,
        this.currentPage * 10
      );
    },
    sort_change(column) {
      this.currentPage = 1;

      this.tableListAdd.sort(
        this.sortFun(column?.prop, column?.order === "ascending")
      );
      this.tableList_new = this.tableListAdd.slice(0, 10);
    },
    sortFun(attr, rev) {
      //第一个参数传入info里的prop表示排的是哪一列，第二个参数是升还是降排序
      if (rev == undefined) {
        rev = 1;
      } else {
        rev = rev ? 1 : -1;
      }
      return function (a, b) {
        a = a[attr];
        b = b[attr];
        if (a < b) {
          return rev * -1;
        }
        if (a > b) {
          return rev * 1;
        }
        return 0;
      };
    },
    serchChange() {
      this.currentPage = 1;
      let list = this.tableListAdd.filter((v) => {
        return v.name.toUpperCase().includes(this.serch.toUpperCase());
      });

      this.total = list.length;
      this.tableList_new = list.slice(
        (this.currentPage - 1) * 10,
        this.currentPage * 10
      );
    },
    tableAddList() {
      const project = Number(getLocalProject());
      this.tableListAdd = Object.entries(readGetdeepfuncList(store)).map(
        ([key, value]) => ({
          id: key,
          name: value.name,
          average_value: value.value,
          rate: value.rate,
          check: false,
        })
      );
      this.total = this.tableListAdd.length;
      this.tableListAdd.forEach((v) => {
        if (project == 34) {
          if (
            v.name === "UnityMain" ||
            v.name === "CoreThread" ||
            v.name === "UnityGfx" ||
            v.name === "NativeThread" ||
            v.name === "Worker Thread"
          ) {
            v.check = true;
          } else {
            v.check = false;
          }
        } else {
          if (v.name === "GameThread" || v.name === "RenderThread") {
            v.check = true;
          } else {
            v.check = false;
          }
        }
      });
      this.tableList_new = this.tableListAdd.slice(
        (this.currentPage - 1) * 10,
        this.currentPage * 10
      );
    },
    add() {
      this.tableAddShow = true;
    },
    openBtn() {
      this.treeNum++;

      this.showDrawer = true;
      // if (this.treeNum == 1) {
      //   let allNodeIds = this.getAllNodeIds(this.treeData);
      //   this.$nextTick(() => {
      //     this.isSettingCheckedKeys = true;
      //     this.$refs.tree.setCheckedKeys(allNodeIds);
      //   });
      // }
    },
    // 重构整个项目数据
    getAllNodeIds(treeData) {
      let ids = [];
      treeData.forEach((node) => {
        ids.push(node.id);
        if (node.children) {
          ids = ids.concat(this.getAllNodeIds(node.children));
        }
      });
      return ids;
    },
    cpu_clock_series() {
      this.cpu_clock_data = [
        {
          name: "Clock0",
          type: "line",
          showSymbol: false,
          data: this.chartDataResult.rows["CPUClock0[MHz]"],
          lineStyle: {
            width: 1,
          },
          emphasis: {
            lineStyle: {
              width: 1, // hover时的折线宽度
            },
          },
          markLine: {
            symbol: ["circle", "arrow"],
            data: [
              {
                silent: true,
                xAxis: this.month_new,
                label: {
                  position: "end",
                  show: true,
                  formatter: this.month_new,
                  color: "ED5664",
                },
                lineStyle: {
                  type: "solid",
                  color: "#ED5664",
                  width: "1",
                  opacity: this.opacity, // 设置为0，使标记线不可见
                },
              },
            ],
          },
        },
        {
          name: "Clock1",
          type: "line",
          showSymbol: false,
          data: this.chartDataResult.rows["CPUClock1[MHz]"],
          lineStyle: {
            width: 1,
          },
          emphasis: {
            lineStyle: {
              width: 1, // hover时的折线宽度
            },
          },
        },
        {
          name: "Clock2",
          type: "line",
          showSymbol: false,
          data: this.chartDataResult.rows["CPUClock2[MHz]"],
          lineStyle: {
            width: 1,
          },
          emphasis: {
            lineStyle: {
              width: 1, // hover时的折线宽度
            },
          },
        },
        {
          name: "Clock3",
          type: "line",
          showSymbol: false,
          data: this.chartDataResult.rows["CPUClock3[MHz]"],
          lineStyle: {
            width: 1,
          },
          emphasis: {
            lineStyle: {
              width: 1, // hover时的折线宽度
            },
          },
        },
        {
          name: "Clock4",
          type: "line",
          showSymbol: false,
          data: this.chartDataResult.rows["CPUClock4[MHz]"],
          lineStyle: {
            width: 1,
          },
          emphasis: {
            lineStyle: {
              width: 1, // hover时的折线宽度
            },
          },
        },
        {
          name: "Clock5",
          type: "line",
          showSymbol: false,
          data: this.chartDataResult.rows["CPUClock5[MHz]"],
          lineStyle: {
            width: 1,
          },
          emphasis: {
            lineStyle: {
              width: 1, // hover时的折线宽度
            },
          },
        },
        {
          name: "Clock6",
          type: "line",
          showSymbol: false,
          data: this.chartDataResult.rows["CPUClock6[MHz]"],
          lineStyle: {
            width: 1,
          },
          emphasis: {
            lineStyle: {
              width: 1, // hover时的折线宽度
            },
          },
        },
        {
          name: "Clock7",
          type: "line",
          showSymbol: false,
          data: this.chartDataResult.rows["CPUClock7[MHz]"],
          lineStyle: {
            width: 1,
          },
          emphasis: {
            lineStyle: {
              width: 1, // hover时的折线宽度
            },
          },
        },
      ];
    },
    electric_line_series() {
      this.electric_line_data = [
        {
          name: "electric_pcnt",
          type: "line",
          showSymbol: false,
          data: this.chartDataElectric.rows.electric_pcnt,
          markLine: {
            symbol: ["circle", "arrow"],
            data: [
              {
                silent: true,
                xAxis: this.month_new,
                label: {
                  position: "end",
                  show: true,
                  formatter: this.month_new,
                  color: "ED5664",
                },
                lineStyle: {
                  type: "solid",
                  color: "#ED5664",
                  width: "1",
                  opacity: this.opacity, // 设置为0，使标记线不可见
                },
              },
            ],
          },
        },
      ];
    },
    cpu_usage_line_series() {
      this.cpu_usage_line_data = [
        {
          name: "HandleCount",
          type: "line",
          showSymbol: false,
          data: this.chartDataResult.rows["HandleCount"],
          itemStyle: this.chartSettings.itemStyle2,
          markLine: {
            symbol: ["circle", "arrow"],
            data: [
              {
                silent: true,
                xAxis: this.month_new,
                label: {
                  position: "end",
                  show: true,
                  formatter: this.month_new,
                  color: "ED5664",
                },
                lineStyle: {
                  type: "solid",
                  color: "#ED5664",
                  width: "1",
                  opacity: this.opacity, // 设置为0，使标记线不可见
                },
              },
            ],
          },
        },
      ];
    },
    temp_line_series() {
      this.temp_line_data = [
        {
          name: "CTemp",
          type: "line",
          showSymbol: false,
          data: this.chartDataTemp.rows.cpu_temp,
          itemStyle: this.chartSettings.itemStyle2,
        },
        {
          name: "BTemp",
          type: "line",
          showSymbol: false,
          data: this.chartDataResult.rows["BTemp[℃]"],
          connectNulls: true,
          itemStyle: this.chartSettings.itemStyle2,
        },
      ];
      if (this.testInfo0.device.toUpperCase().indexOf("IPHONE") != -1) {
        this.temp_line_data.splice(0, 1);
      }
      this.temp_line_data[0].markLine = {
        symbol: ["circle", "arrow"],
        data: [
          {
            silent: true,
            xAxis: this.month_new,
            label: {
              position: "end",
              show: true,
              formatter: this.month_new,
              color: "ED5664",
            },
            lineStyle: {
              type: "solid",
              color: "#ED5664",
              width: "1",
              opacity: this.opacity, // 设置为0，使标记线不可见
            },
          },
        ],
      };
    },
    cpu_core_usage_series() {
      this.cpu_core_usage_data = [
        {
          name: "AppCPU",
          type: "line",
          showSymbol: false,
          data: this.chartDataResult.rows.AppCPU,
          lineStyle: {
            width: 1,
          },
          emphasis: {
            lineStyle: {
              width: 1, // hover时的折线宽度
            },
          },
          markLine: {
            symbol: ["circle", "arrow"],
            data: [
              {
                silent: true,
                xAxis: this.month_new,
                label: {
                  position: "end",
                  show: true,
                  formatter: this.month_new,
                  color: "ED5664",
                },
                lineStyle: {
                  type: "solid",
                  color: "#ED5664",
                  width: "1",
                  opacity: this.opacity, // 设置为0，使标记线不可见
                },
              },
            ],
          },
        },
        {
          name: "AppUserCPU",
          type: "line",
          showSymbol: false,
          data: this.chartDataResult.rows["AppUserCPU[%]"],
          lineStyle: {
            width: 1,
          },
          emphasis: {
            lineStyle: {
              width: 1, // hover时的折线宽度
            },
          },
        },
        {
          name: "AppKernelCPU",
          type: "line",
          showSymbol: false,
          data: this.chartDataResult.rows["AppKernelCPU[%]"],
          lineStyle: {
            width: 1,
          },
          emphasis: {
            lineStyle: {
              width: 1, // hover时的折线宽度
            },
          },
        },
      ];
    },
    cpu_usage_normalized_series() {
      this.cpu_usage_normalized_data = [
        {
          name: "ThreadCount",
          type: "line",
          showSymbol: false,
          data: this.chartDataResult.rows["ThreadCount"],
          itemStyle: this.chartSettings.itemStyle2,
          markLine: {
            symbol: ["circle", "arrow"],
            data: [
              {
                silent: true,
                xAxis: this.month_new,
                label: {
                  position: "end",
                  show: true,
                  formatter: this.month_new,
                  color: "ED5664",
                },
                lineStyle: {
                  type: "solid",
                  color: "#ED5664",
                  width: "1",
                  opacity: this.opacity, // 设置为0，使标记线不可见
                },
              },
            ],
          },
        },
      ];
    },
    frametime_line_series() {
      this.frametime_line_data = [
        {
          name: "FTime",
          type: "line",
          showSymbol: false,
          data: this.chartDataFrame.rows.frame_time,
          itemStyle: this.chartSettings.itemStyle,
          markLine: {
            symbol: ["circle", "arrow"],
            data: [
              {
                silent: true,
                xAxis: this.month_new,
                label: {
                  position: "end",
                  show: true,
                  formatter: this.month_new,
                  color: "ED5664",
                },
                lineStyle: {
                  type: "solid",
                  color: "#ED5664",
                  width: "1",
                  opacity: this.opacity, // 设置为0，使标记线不可见
                },
              },
            ],
          },
        },
      ];
    },
    flow_line_series() {
      this.flow_line_data = [
        {
          name: "Send",
          type: "line",
          showSymbol: false,
          data: this.chartDataResult.rows["Send[KB/s]"],
          itemStyle: this.chartSettings.itemStyle2,
          markLine: {
            symbol: ["circle", "arrow"],
            data: [
              {
                silent: true,
                xAxis: this.month_new,
                label: {
                  position: "end",
                  show: true,
                  formatter: this.month_new,
                  color: "ED5664",
                },
                lineStyle: {
                  type: "solid",
                  color: "#ED5664",
                  width: "1",
                  opacity: this.opacity, // 设置为0，使标记线不可见
                },
              },
            ],
          },
        },
        {
          name: "Recv",
          type: "line",
          showSymbol: false,
          data: this.chartDataResult.rows["Recv[KB/s]"],
          itemStyle: this.chartSettings.itemStyle2,
        },
      ];
    },
    cpu_freq_line_series() {
      this.cpu_freq_line_data = [
        {
          name: "CPU0",
          type: "line",
          showSymbol: false,
          data: this.chartDataResult.rows["CPUUsage0[%](Normalized)"],
          lineStyle: {
            width: 1,
          },

          emphasis: {
            lineStyle: {
              width: 1, // hover时的折线宽度
            },
          },
          markLine: {
            symbol: ["circle", "arrow"],
            data: [
              {
                silent: true,
                xAxis: this.month_new,
                label: {
                  position: "end",
                  show: true,
                  formatter: this.month_new,
                  color: "ED5664",
                },
                lineStyle: {
                  type: "solid",
                  color: "#ED5664",
                  width: "1",
                  opacity: this.opacity, // 设置为0，使标记线不可见
                },
              },
            ],
          },
        },
        {
          name: "CPU1",
          type: "line",
          showSymbol: false,
          data: this.chartDataResult.rows["CPUUsage1[%](Normalized)"],
          lineStyle: {
            width: 1,
          },
          emphasis: {
            lineStyle: {
              width: 1, // hover时的折线宽度
            },
          },
        },
        {
          name: "CPU2",
          type: "line",
          showSymbol: false,
          data: this.chartDataResult.rows["CPUUsage2[%](Normalized)"],
          lineStyle: {
            width: 1,
          },
          emphasis: {
            lineStyle: {
              width: 1, // hover时的折线宽度
            },
          },
        },
        {
          name: "CPU3",
          type: "line",
          showSymbol: false,
          data: this.chartDataResult.rows["CPUUsage3[%](Normalized)"],
          lineStyle: {
            width: 1,
          },
          emphasis: {
            lineStyle: {
              width: 1, // hover时的折线宽度
            },
          },
        },
        {
          name: "CPU4",
          type: "line",
          showSymbol: false,
          data: this.chartDataResult.rows["CPUUsage4[%](Normalized)"],
          lineStyle: {
            width: 1,
          },
          emphasis: {
            lineStyle: {
              width: 1, // hover时的折线宽度
            },
          },
        },
        {
          name: "CPU5",
          type: "line",
          showSymbol: false,
          data: this.chartDataResult.rows["CPUUsage5[%](Normalized)"],
          lineStyle: {
            width: 1,
          },
          emphasis: {
            lineStyle: {
              width: 1, // hover时的折线宽度
            },
          },
        },
        {
          name: "CPU6",
          type: "line",
          showSymbol: false,
          data: this.chartDataResult.rows["CPUUsage6[%](Normalized)"],
          lineStyle: {
            width: 1,
          },
          emphasis: {
            lineStyle: {
              width: 1, // hover时的折线宽度
            },
          },
        },
        {
          name: "CPU7",
          type: "line",
          showSymbol: false,
          data: this.chartDataResult.rows["CPUUsage7[%](Normalized)"],
          lineStyle: {
            width: 1,
          },
          emphasis: {
            lineStyle: {
              width: 1, // hover时的折线宽度
            },
          },
        },
      ];
    },
    pss_line_series() {
      this.pss_line_data = [
        {
          name: "Memory[MB]",
          type: "line",
          showSymbol: false,
          data: this.chartDataResult.rows["Memory[MB]"],
          itemStyle: this.chartSettings.itemStyle2,
          markLine: {
            symbol: ["circle", "arrow"],
            data: [
              {
                silent: true,
                xAxis: this.month_new,
                label: {
                  position: "end",
                  show: true,
                  formatter: this.month_new,
                  color: "ED5664",
                },
                lineStyle: {
                  type: "solid",
                  color: "#ED5664",
                  width: "1",
                  opacity: this.opacity, // 设置为0，使标记线不可见
                },
              },
            ],
          },
        },
        {
          name: "SwapMemory[MB]",
          type: "line",
          showSymbol: false,
          data: this.chartDataResult.rows["SwapMemory[MB]"],
          itemStyle: this.chartSettings.itemStyle2,
        },
        {
          name: "VirtualMemory[MB]",
          type: "line",
          showSymbol: false,
          data: this.chartDataResult.rows["VirtualMemory[MB]"],
          itemStyle: this.chartSettings.itemStyle2,
        },
        {
          name: "AvailableMemory[MB]",
          type: "line",
          showSymbol: false,
          data: this.chartDataResult.rows["AvailableMemory[MB]"],
          itemStyle: this.chartSettings.itemStyle2,
        },
      ];
    },
    memory_detail_series() {
      this.memory_detail_data = [];
      this.memory_detail_data = [
        {
          name: "WorkingSet",
          type: "line",
          showSymbol: false,
          data: this.chartDataResult.rows["WorkingSet[MB]"],
          lineStyle: {
            width: 1,
          },
          emphasis: {
            lineStyle: {
              width: 1, // hover时的折线宽度
            },
          },
          markLine: {
            symbol: ["circle", "arrow"],
            data: [
              {
                silent: true,
                xAxis: this.month_new,
                label: {
                  position: "end",
                  show: true,
                  formatter: this.month_new,
                  color: "ED5664",
                },
                lineStyle: {
                  type: "solid",
                  color: "#ED5664",
                  width: "1",
                  opacity: this.opacity, // 设置为0，使标记线不可见
                },
              },
            ],
          },
        },
        {
          name: "PrivateBytes",
          type: "line",
          showSymbol: false,
          data: this.chartDataResult.rows["PrivateBytes[MB]"],
          lineStyle: {
            width: 1,
          },
          emphasis: {
            lineStyle: {
              width: 1, // hover时的折线宽度
            },
          },
        },

        {
          name: "VirtualBytes",
          type: "line",
          showSymbol: false,
          data: this.chartDataResult.rows["VirtualBytes[MB]"],
          lineStyle: {
            width: 1,
          },
          emphasis: {
            lineStyle: {
              width: 1, // hover时的折线宽度
            },
          },
        },
        {
          name: "AvailableMemory",
          type: "line",
          showSymbol: false,
          data: this.chartDataResult.rows["AvailableMemory[MB]"],
          lineStyle: {
            width: 1,
          },
          emphasis: {
            lineStyle: {
              width: 1, // hover时的折线宽度
            },
          },
        },
        {
          name: "PageFaults",
          type: "line",
          showSymbol: false,
          data: this.chartDataResult.rows.PageFaults,
          lineStyle: {
            width: 1,
          },
          emphasis: {
            lineStyle: {
              width: 1, // hover时的折线宽度
            },
          },
        },
      ];
      // this.memory_detail.forEach((item, index) => {
      //   if (index == 0) {
      //     this.memory_detail_data.push({
      //       name: item,
      //       type: "line",
      //       showSymbol: false,
      //       data: this.chartDataResult.rows[item],
      //       itemStyle: this.chartSettings.itemStyle2,
      //       markLine: {
      //         symbol: ["circle", "arrow"],
      //         data: [
      //           {
      //             silent: true,
      //             xAxis: this.month_new,
      //             label: {
      //               position: "end",
      //               show: true,
      //               formatter: this.month_new,
      //               color: "ED5664",
      //             },
      //             lineStyle: {
      //               type: "solid",
      //               color: "#ED5664",
      //               width: "1",
      //               opacity: this.opacity, // 设置为0，使标记线不可见
      //             },
      //           },
      //         ],
      //       },
      //     });
      //   } else {
      //     this.memory_detail_data.push({
      //       name: item,
      //       type: "line",
      //       showSymbol: false,
      //       data: this.chartDataResult.rows[item],
      //       itemStyle: this.chartSettings.itemStyle2,
      //     });
      //   }
      // });
    },
    gpu_memory_counter_series() {
      this.gpu_memory_counter_data = [
        {
          name: "ReadTotal",
          type: "line",
          showSymbol: false,
          data: this.chartDataResult.rows["ReadTotal[MB]"],
          itemStyle: this.chartSettings.itemStyle2,
          markLine: {
            symbol: ["circle", "arrow"],
            data: [
              {
                silent: true,
                xAxis: this.month_new,
                label: {
                  position: "end",
                  show: true,
                  formatter: this.month_new,
                  color: "ED5664",
                },
                lineStyle: {
                  type: "solid",
                  color: "#ED5664",
                  width: "1",
                  opacity: this.opacity, // 设置为0，使标记线不可见
                },
              },
            ],
          },
        },
        {
          name: "WriteTotal",
          type: "line",
          showSymbol: false,
          data: this.chartDataResult.rows["WriteTotal[MB]"],
          itemStyle: this.chartSettings.itemStyle2,
        },
        {
          name: "TextureL2Miss",
          type: "line",
          showSymbol: false,
          data: this.chartDataResult.rows["TextureL2Miss[%]"],
          itemStyle: this.chartSettings.itemStyle2,
        },
        {
          name: "StalledOnSystemMemory",
          type: "line",
          showSymbol: false,
          data: this.chartDataResult.rows["StalledOnSystemMemory[%]"],
          itemStyle: this.chartSettings.itemStyle2,
        },
      ];
    },
    gpu_general_counter_series() {
      this.gpu_general_counter_data = [
        {
          name: "AppDedicated",
          type: "line",
          showSymbol: false,
          data: this.chartDataResult.rows["AppDedicated0[bytes]"],
          itemStyle: this.chartSettings.itemStyle2,
          markLine: {
            symbol: ["circle", "arrow"],
            data: [
              {
                silent: true,
                xAxis: this.month_new,
                label: {
                  position: "end",
                  show: true,
                  formatter: this.month_new,
                  color: "ED5664",
                },
                lineStyle: {
                  type: "solid",
                  color: "#ED5664",
                  width: "1",
                  opacity: this.opacity, // 设置为0，使标记线不可见
                },
              },
            ],
          },
        },
        {
          name: "AppShared0",
          type: "line",
          showSymbol: false,
          data: this.chartDataResult.rows["AppShared0[bytes]"],
          itemStyle: this.chartSettings.itemStyle2,
        },
        {
          name: "Dedicated0",
          type: "line",
          showSymbol: false,
          data: this.chartDataResult.rows["Dedicated0[bytes]"],
          itemStyle: this.chartSettings.itemStyle2,
        },
        {
          name: "Shared0",
          type: "line",
          showSymbol: false,
          data: this.chartDataResult.rows["Shared0[bytes]"],
          itemStyle: this.chartSettings.itemStyle2,
        },
        {
          name: "Dedicated1",
          type: "line",
          showSymbol: false,
          data: this.chartDataResult.rows["Dedicated1[bytes]"],
          itemStyle: this.chartSettings.itemStyle2,
        },
        {
          name: "Shared1",
          type: "line",
          showSymbol: false,
          data: this.chartDataResult.rows["Shared1[bytes]"],
          itemStyle: this.chartSettings.itemStyle2,
        },
      ];
    },
    wakeups_data_series() {
      this.wakeups_data = [
        {
          name: "IOReadCount",
          type: "line",
          showSymbol: false,
          data: this.chartDataResult.rows["IOReadCount"],
          itemStyle: this.chartSettings.itemStyle2,
          markLine: {
            symbol: ["circle", "arrow"],
            data: [
              {
                silent: true,
                xAxis: this.month_new,
                label: {
                  position: "end",
                  show: true,
                  formatter: this.month_new,
                  color: "ED5664",
                },
                lineStyle: {
                  type: "solid",
                  color: "#ED5664",
                  width: "1",
                  opacity: this.opacity, // 设置为0，使标记线不可见
                },
              },
            ],
          },
        },
        {
          name: "IOReadBytes",
          type: "line",
          showSymbol: false,
          data: this.chartDataResult.rows["IOReadBytes"],
          itemStyle: this.chartSettings.itemStyle2,
        },
        {
          name: "IOWriteBytes",
          type: "line",
          showSymbol: false,
          data: this.chartDataResult.rows["IOWriteBytes"],
          itemStyle: this.chartSettings.itemStyle2,
        },
        {
          name: "IOWriteCount",
          type: "line",
          showSymbol: false,
          data: this.chartDataResult.rows["IOWriteCount"],
          itemStyle: this.chartSettings.itemStyle2,
        },
      ];
    },
    cswitch_data_series() {
      this.cswitch_data = [
        {
          name: "CSwitch",
          type: "line",
          showSymbol: false,
          data: this.chartDataSec.rows["CSwitch"],
          itemStyle: this.chartSettings.itemStyle2,
          markLine: {
            symbol: ["circle", "arrow"],
            data: [
              {
                silent: true,
                xAxis: this.month_new,
                label: {
                  position: "end",
                  show: true,
                  formatter: this.month_new,
                  color: "ED5664",
                },
                lineStyle: {
                  type: "solid",
                  color: "#ED5664",
                  width: "1",
                  opacity: this.opacity, // 设置为0，使标记线不可见
                },
              },
            ],
          },
        },
      ];
    },
    gpu_shader_counter_series() {
      this.gpu_shader_counter_data = [
        {
          name: "GTemp0",
          type: "line",
          showSymbol: false,
          data: this.chartDataResult.rows["GTemp0[℃]"],
          itemStyle: this.chartSettings.itemStyle2,
          markLine: {
            symbol: ["circle", "arrow"],
            data: [
              {
                silent: true,
                xAxis: this.month_new,
                label: {
                  position: "end",
                  show: true,
                  formatter: this.month_new,
                  color: "ED5664",
                },
                lineStyle: {
                  type: "solid",
                  color: "#ED5664",
                  width: "1",
                  opacity: this.opacity, // 设置为0，使标记线不可见
                },
              },
            ],
          },
        },
        {
          name: "AppGUsage3D0",
          type: "line",
          showSymbol: false,
          data: this.chartDataResult.rows["AppGUsage3D0[%]"],
          itemStyle: this.chartSettings.itemStyle2,
        },
        {
          name: "TotalGUsage3D0",
          type: "line",
          showSymbol: false,
          data: this.chartDataResult.rows["TotalGUsage3D0[%]"],
          itemStyle: this.chartSettings.itemStyle2,
        },
        {
          name: "TotalGUsage3D1",
          type: "line",
          showSymbol: false,
          data: this.chartDataResult.rows["TotalGUsage3D1[%]"],
          itemStyle: this.chartSettings.itemStyle2,
        },
        {
          name: "GTemp2",
          type: "line",
          showSymbol: false,
          data: this.chartDataResult.rows["GTemp2[℃]"],
          itemStyle: this.chartSettings.itemStyle2,
        },
        {
          name: "TotalGUsage3D2",
          type: "line",
          showSymbol: false,
          data: this.chartDataResult.rows["TotalGUsage3D2[%]"],
          itemStyle: this.chartSettings.itemStyle2,
        },
      ];
    },
    analyse_series() {
      this.analyse_data = [];
      let list = Object.keys(this.cpu_by_frame?.thread_list);

      list.forEach((v, index) => {
        this.analyse_data.push({
          name: v,
          type: "line",

          showSymbol: false,

          itemStyle: {
            normal: {
              lineStyle: {
                width: 1,
              },
            },
            emphasis: {
              lineStyle: {
                width: 1, // hover时的折线宽度
              },
            },
          },
          yAxisIndex: 0,
          id: this.cpu_by_frame?.thread_list[v],
          data: this.cpu_by_frame?.series[index],
        });
      });
    },
    fps_series() {
      this.fps_seris_data = [
        {
          name: "fps",
          type: "line",
          showSymbol: false,
          data: this.chartDataResult.rows["FPS"],

          itemStyle: this.chartSettings.itemStyle2,
          // renderItem: (params, api) => {
          //   const xValue = api.value(0);
          //   const yValue = api.value(1);
          //   const point = api.coord([xValue, yValue]);
          //   return {
          //     type: "circle",
          //     shape: {
          //       cx: point[0],
          //       cy: point[1],
          //       r: 5,
          //     },
          //     style: {
          //       fill: "red",
          //     },
          //   };
          // },
          markLine: {
            symbol: ["circle", "arrow"],
            data: [
              {
                silent: true,
                xAxis: this.month_new,
                label: {
                  position: "end",
                  show: true,
                  formatter: this.month_new,
                  color: "ED5664",
                },
                lineStyle: {
                  type: "solid",
                  color: "#ED5664",
                  width: "1",
                  opacity: this.opacity, // 设置为0，使标记线不可见
                },
              },
            ],
          },
        },
        {
          name: "Smooth",
          type: "line",
          showSymbol: false,
          data: this.chartDataResult.rows["Smooth"],

          itemStyle: this.chartSettings.itemStyle2,
        },
        {
          name: "SmallJank",
          type: "line",
          showSymbol: false,
          data: this.chartDataResult.rows["SmallJank"],
          itemStyle: this.chartSettings.itemStyle2,
        },
        {
          name: "Jank",
          type: "line",
          showSymbol: false,
          data: this.chartDataResult.rows["Jank"],
          itemStyle: this.chartSettings.itemStyle2,
        },
        {
          name: "BigJank",
          type: "line",
          showSymbol: false,
          data: this.chartDataResult.rows["BigJank"],

          itemStyle: this.chartSettings.itemStyle2,
        },
        {
          name: "Stutter[%]",
          type: "line",
          showSymbol: false,
          data: this.chartDataResult.rows["Stutter"],

          itemStyle: this.chartSettings.itemStyle2,
        },
      ];
    },
    traverseNode(node, checkedKeys, checkedNodeList) {
      if (checkedKeys.includes(node.id.toString())) {
        checkedNodeList.push(node);
      }
      if (node.children) {
        node.children.forEach((child) => {
          this.traverseNode(child, checkedKeys, checkedNodeList);
        });
      }
    },
    findNodeAndParentById(treeData, id, parent = null) {
      for (let i = 0; i < treeData.length; i++) {
        const node = treeData[i];
        if (node.children && node.children.some((child) => child.id === id)) {
          return [node.children, node.label];
        }
        if (node.children) {
          const foundResult = this.findNodeAndParentById(
            node.children,
            id,
            node
          );
          if (foundResult) {
            return foundResult;
          }
        }
      }
      return null;
    },
    labels1() {
      this.list = [];
      let num = 0;
      this.cpu_by_frame?.labels?.forEach((v) => {
        num += v.length;
      });
      this.cpu_by_frame?.labels?.forEach((v, index) => {
        this.list.push({
          label: v[0] + "_" + index,
          width: (v.length / num) * 100 + "%",
          color: this.lableColorList[index],
        });
      });
    },
    setParentChecked(id) {
      const checkedKeys = this.$refs.tree.getCheckedKeys();

      if (checkedKeys.indexOf(id) != -1) {
        checkedKeys.splice(checkedKeys.indexOf(id), 1);
      }

      this.$refs.tree.setCheckedKeys(checkedKeys);
    },
    setParentAddChecked(id) {
      const checkedKeys = this.$refs.tree.getCheckedKeys();

      checkedKeys.push(id);

      this.$refs.tree.setCheckedKeys(checkedKeys);
    },

    async handleChangeRow(data) {
      if (data.children) {
        if (data.is_check) {
          data.children.forEach((v) => {
            v.is_check = true;
          });
          if (data.label === "温度") {
            this.modelStatusShow = true;
            this.statusCardShow = true;
            await this.temp_line_series();
            this.lableShow3 = !this.showBox(this.temp_line_data);
            this.drawPieChartTemp();
            const targetElement = document.querySelector("#status");
            targetElement.scrollIntoView();
          }
          if (data.label === "FrameTime") {
            this.fpsBoxCardShow = true;
            this.frametimeCardShow = true;
            this.frameShow = true;
            await this.frametime_line_series();
            this.drawPieChartFrameTime();
            const targetElement = document.querySelector("#frametime_line");
            targetElement.scrollIntoView();
          }
          if (data.label === "Wakeups") {
            this.wakeupsBoxCardShow = true;
            await this.wakeups_data_series();
            this.wakeupsShow = !this.showBox(this.wakeups_data);
            this.drawPieChartWakeups();
            const targetElement = document.querySelector("#wakeupsBox");
            targetElement.scrollIntoView();
          }
          if (data.label === "CSwitch") {
            this.CSwitchBoxCardShow = true;
            await this.cswitch_data_series();
            this.csWithchShow = !this.showBox(this.cswitch_data);
            this.drawPieChartCsWitch();
            const targetElement = document.querySelector("#CSwitchBox");
            targetElement.scrollIntoView();
          }
          if (data.label === "线程函数") {
            this.analyseCardShow = true;
            this.threadShow = true;
            await this.analyse_series();
            this.drawAnalyseTrend();
            const targetElement = document.querySelector("#analyse_box");
            targetElement.scrollIntoView();
          }
          if (data.label === "FPS") {
            this.fpsBoxCardShow = true;
            this.fpsCardShow = true;
            this.fpsShow = true;
            await this.fps_series();
            this.drawPieChartFPS();
            const targetElement = document.querySelector("#fps_line");
            targetElement.scrollIntoView();
          }

          if (data.label === "NetWork") {
            this.NetworkCardShow = true;
            await this.flow_line_series();
            this.flowShow = !this.showBox(this.flow_line_data);

            this.drawPieChartFlow();
            const targetElement = document.querySelector("#flow_line_box");
            targetElement.scrollIntoView();
          }
          if (data.label === "Memory") {
            this.MemoryCardshow = true;
            await this.pss_line_series();
            await this.memory_detail_series();
            this.pssShow = !this.showBox(this.pss_line_data);
            this.memoryShow = !this.showBox(this.memory_detail_data);
            this.drawPieChartPSS();
            this.drawPieChartMemoryDetail();
            const targetElement = document.querySelector("#MemoryBox");
            targetElement.scrollIntoView();
          }
          if (data.label === "Energy") {
            this.modelStatusShow = true;
            this.EnergyCardShow = true;
            await this.electric_line_series();
            this.EnergyShow = !this.showBox(this.electric_line_data);
            this.drawPieChartElectric();
            const targetElement = document.querySelector("#electric_line");
            targetElement.scrollIntoView();
          }
          if (data.label === "GPU") {
            this.GpuCardShow = true;
            await this.gpu_general_counter_series();
            await this.gpu_memory_counter_series();
            await this.gpu_shader_counter_series();
            // let m = this.gpu_general_counter_data
            //   .map((v) => v.data.every((item) => item == ""))
            //   .every((i) => i == true);
            this.gpuShow = !this.showBox(this.gpu_general_counter_data);
            this.gpuShow1 = !this.showBox(this.gpu_memory_counter_data);
            this.gpuShow2 = !this.showBox(this.gpu_shader_counter_data);
            this.drawPieChartGPUGeneralCounter();
            this.drawPieChartGPUShaderCounter();
            this.drawPieChartGPUMemoryCounter();
            const targetElement = document.querySelector("#gpuBox");
            targetElement.scrollIntoView();
          }
          if (data.label === "CPU") {
            this.cpuCardShow = true;
            await this.cpu_usage_line_series();
            await this.cpu_freq_line_series();
            await this.cpu_core_usage_series();
            await this.cpu_usage_normalized_series();
            await this.cpu_clock_series();
            this.cpuShow = !this.showBox(this.cpu_usage_line_data);
            this.lableShow1 = !this.showBox(this.cpu_freq_line_data);
            this.cpuShow1 = !this.showBox(this.cpu_core_usage_data);
            this.cpuShow4 = !this.showBox(this.cpu_usage_normalized_data);
            this.cpuShow2 = !this.showBox(this.cpu_clock_data);
            this.drawPieChartCPUUsage();
            this.drawPieChartCPUUsageNormalized();
            this.cpu_usage_normalized_series();
            this.drawPieChartCPUClock();
            this.drawPieChartCPUCoreUsage();
            this.drawPieChartCPUFreq();
            const targetElement = document.querySelector("#cpuBox");
            targetElement.scrollIntoView();
          }
        } else {
          data.children.forEach((v) => {
            v.is_check = false;
          });
          if (data.label === "温度") {
            this.statusCardShow = false;
            if (this.EnergyCardShow == false && this.statusCardShow == false) {
              this.modelStatusShow = false;
            }
            this.lableShow3 = false;
            this.temp_line_data = [];
            this.drawPieChartTemp();
          }
          if (data.label === "FrameTime") {
            this.frametimeCardShow = false;
            if (this.fpsCardShow == false && this.frametimeCardShow == false) {
              this.fpsBoxCardShow = false;
            }
            this.frameShow = false;
            this.frametime_line_data = [];
            this.drawPieChartFrameTime();
          }
          if (data.label === "Wakeups") {
            this.wakeupsBoxCardShow = false;
            this.wakeupsShow = false;
            this.wakeups_data = [];
            this.drawPieChartWakeups();
          }
          if (data.label === "线程函数") {
            this.analyseCardShow = false;
            this.threadShow = false;
            this.analyse_data = [];
            this.drawAnalyseTrend();
          }
          if (data.label === "Energy") {
            this.EnergyCardShow = false;
            if (this.EnergyCardShow == false && this.statusCardShow == false) {
              this.modelStatusShow = false;
            }

            this.EnergyShow = false;
            this.electric_line_data = [];
            this.drawPieChartElectric();
          }
          if (data.label === "CSwitch") {
            this.CSwitchBoxCardShow = false;
            this.csWithchShow = false;
            this.cswitch_data = [];
            this.drawPieChartCsWitch();
          }
          if (data.label === "FPS") {
            this.fpsCardShow = false;
            if (this.fpsCardShow == false && this.frametimeCardShow == false) {
              this.fpsBoxCardShow = false;
            }
            this.fpsShow = false;
            this.fps_seris_data = [];
            this.drawPieChartFPS();
          }

          if (data.label === "NetWork") {
            this.NetworkCardShow = false;
            this.flow_line_data = [];
            this.flowShow = false;
            this.drawPieChartFlow();
          }

          // if (data.label === "GPU General Counter") {
          //   this.gpu_general_counter_data = [];
          //   this.gpuShow = false;
          //   this.drawPieChartGPUGeneralCounter();
          // }
          if (data.label === "Memory") {
            this.MemoryCardshow = false;
            this.pss_line_data = [];
            this.memory_detail_data = [];

            this.memoryShow = false;
            this.pssShow = false;

            this.drawPieChartMemoryDetail();
            this.drawPieChartPSS();
          }
          if (data.label === "GPU") {
            this.GpuCardShow = false;
            this.gpu_memory_counter_data = [];
            this.gpu_general_counter_data = [];
            this.gpu_shader_counter_data = [];
            this.gpuShow = false;
            this.gpuShow1 = false;
            this.gpuShow2 = false;
            this.drawPieChartGPUMemoryCounter();
            this.drawPieChartGPUGeneralCounter();
            this.drawPieChartGPUShaderCounter();
          }
          if (data.label === "CPU") {
            this.cpuCardShow = false;
            this.cpu_usage_line_data = [];
            this.cpu_freq_line_data = [];
            this.cpu_core_usage_data = [];
            this.cpu_usage_normalized_data = [];
            this.cpu_clock_data = [];
            this.cpuShow = false;
            this.lableShow1 = false;
            this.cpuShow1 = false;
            this.cpuShow4 = false;
            this.cpuShow2 = false;
            this.drawPieChartCPUUsage();
            this.drawPieChartCPUUsageNormalized();
            this.cpu_usage_normalized_series();
            this.drawPieChartCPUClock();
            this.drawPieChartCPUCoreUsage();
            this.drawPieChartCPUFreq();
          }
        }
      } else {
        let data1 = data.is_check;
        let children_data = this.findNodeAndParentById(this.treeData, data.id); //查询整个children情况 查询父节点name
        let series = children_data[0].filter((v) => v.is_check == true); //获取有效数据
        if (children_data[1] === "GPU") {
          // let id = this.treeData.filter((v) => v.label == children_data[1])[0]
          //   .id;
          // if (
          //   series.length <
          //   this.treeData.filter((v) => v.label == children_data[1])[0]
          //     .children.length
          // ) {
          //   this.setParentChecked(id);
          // } else {
          //   this.setParentAddChecked(id);
          // }
          // this.setParentChecked(id)
          // this.fps_seris_data = [];

          if (data.label === "GPU General Counter") {
            if (data1) {
              this.GpuCardShow = true;
              await this.gpu_general_counter_series();
              this.drawPieChartGPUGeneralCounter();

              let m = this.gpu_general_counter_data
                .map((v) => v.data.every((item) => item == ""))
                .every((i) => i == true);
              this.gpuShow = !m;
              const targetElement = document.querySelector(
                "#gpu_general_counter"
              );

              targetElement.scrollIntoView();
            } else {
              this.gpu_general_counter_data = [];
              this.gpuShow = false;
              this.drawPieChartGPUGeneralCounter();
            }
          }
          if (data.label === "GPU Memory Counter") {
            if (data1) {
              this.GpuCardShow = true;
              await this.gpu_memory_counter_series();
              this.drawPieChartGPUMemoryCounter();
              let m = this.gpu_memory_counter_data
                .map((v) => v.data.every((item) => item == ""))
                .every((i) => i == true);
              this.gpuShow1 = !m;
              const targetElement = document.querySelector(
                "#gpu_memory_counter"
              );
              targetElement.scrollIntoView();
            } else {
              this.gpu_memory_counter_data = [];
              this.gpuShow1 = false;
              this.drawPieChartGPUMemoryCounter();
            }
          }
          if (data.label === "GPU Shader Counter") {
            if (data1) {
              this.GpuCardShow = true;
              await this.gpu_shader_counter_series();
              this.drawPieChartGPUShaderCounter();
              let m = this.gpu_shader_counter_data
                .map((v) => v.data.every((item) => item == ""))
                .every((i) => i == true);
              this.gpuShow2 = !m;
              const targetElement = document.querySelector(
                "#gpu_shader_counter"
              );
              targetElement.scrollIntoView();
            } else {
              this.gpu_shader_counter_data = [];
              this.gpuShow2 = false;
              this.drawPieChartGPUShaderCounter();
            }
          }
          if (
            series.length ==
            this.treeData.filter((v) => v.label == children_data[1])[0].children
              .length
          ) {
            this.treeData.filter(
              (v) => v.label == children_data[1]
            )[0].is_check = true;
          } else {
            this.treeData.filter(
              (v) => v.label == children_data[1]
            )[0].is_check = false;
          }
          if (series.length == 0) {
            this.GpuCardShow = false;
          }
        }
        if (children_data[1] === "Memory") {
          if (data.label === "MemoryDetail") {
            if (data1) {
              this.MemoryCardshow = true;
              await this.memory_detail_series();
              this.drawPieChartMemoryDetail();
              let m = this.memory_detail_data
                .map((v) => v.data.every((item) => item == ""))
                .every((i) => i == true);

              this.memoryShow = !m;
              const targetElement = document.querySelector("#memory_detail");
              targetElement.scrollIntoView();
            } else {
              this.memory_detail_data = [];
              this.memoryShow = false;
              this.drawPieChartMemoryDetail();
            }
          }
          if (data.label === "Memory Usage") {
            if (data1) {
              this.MemoryCardshow = true;
              await this.pss_line_series();
              this.drawPieChartPSS();
              let m = this.pss_line_data
                .map((v) => v.data.every((item) => item == ""))
                .every((i) => i == true);
              this.pssShow = !m;
              const targetElement = document.querySelector("#pss_line");
              targetElement.scrollIntoView();
            } else {
              this.pss_line_data = [];
              this.pssShow = false;
              this.drawPieChartPSS();
            }
          }
          if (
            series.length ==
            this.treeData.filter((v) => v.label == children_data[1])[0].children
              .length
          ) {
            this.treeData.filter(
              (v) => v.label == children_data[1]
            )[0].is_check = true;
          } else {
            this.treeData.filter(
              (v) => v.label == children_data[1]
            )[0].is_check = false;
          }
          if (series.length == 0) {
            this.MemoryCardshow = false;
          }
        }
        if (children_data[1] === "CPU") {
          if (data.label === "CPU Usage") {
            if (data1) {
              this.cpuCardShow = true;
              await this.cpu_usage_line_series();
              this.drawPieChartCPUUsage();
              let m = this.cpu_usage_line_data
                .map((v) => v.data.every((item) => item == ""))
                .every((i) => i == true);

              this.cpuShow = !m;
              const targetElement = document.querySelector("#cpu_usage_line");
              targetElement.scrollIntoView();
            } else {
              this.cpu_usage_line_data = [];
              this.cpuShow = false;
              this.drawPieChartCPUUsage();
            }
          }
          if (data.label === "CPU Core USage(Normalized)") {
            if (data1) {
              this.cpuCardShow = true;
              await this.cpu_freq_line_series();
              this.drawPieChartCPUFreq();
              let m = this.cpu_freq_line_data
                .map((v) => v.data.every((item) => item == ""))
                .every((i) => i == true);
              this.lableShow1 = !m;
              const targetElement = document.querySelector("#cpu_freq_line");
              targetElement.scrollIntoView();
            } else {
              this.cpu_freq_line_data = [];
              this.lableShow1 = false;
              this.drawPieChartCPUFreq();
            }
          }
          if (data.label === "CPU Core Usage") {
            if (data1) {
              this.cpuCardShow = true;
              await this.cpu_core_usage_series();
              this.drawPieChartCPUCoreUsage();
              let m = this.cpu_core_usage_data
                .map((v) => v.data.every((item) => item == ""))
                .every((i) => i == true);
              this.cpuShow1 = !m;
              const targetElement = document.querySelector("#cpu_core_usage");
              targetElement.scrollIntoView();
            } else {
              this.cpu_core_usage_data = [];
              this.cpuShow1 = false;
              this.drawPieChartCPUCoreUsage();
            }
          }
          if (data.label === "CPU Usage(Normalized)") {
            if (data1) {
              this.cpuCardShow = true;
              await this.cpu_usage_normalized_series();
              this.drawPieChartCPUUsageNormalized();
              let m = this.cpu_usage_normalized_data
                .map((v) => v.data.every((item) => item == ""))
                .every((i) => i == true);
              this.cpuShow4 = !m;
              const targetElement = document.querySelector(
                "#cpu_usage_normalized"
              );
              targetElement.scrollIntoView();
            } else {
              this.cpu_usage_normalized_data = [];
              this.cpuShow4 = false;
              this.drawPieChartCPUUsageNormalized();
            }
          }
          if (data.label === "CPU Clock") {
            if (data1) {
              this.cpuCardShow = true;
              await this.cpu_clock_series();
              this.drawPieChartCPUClock();
              let m = this.cpu_clock_data
                .map((v) => v.data.every((item) => item == ""))
                .every((i) => i == true);
              this.cpuShow2 = !m;
              const targetElement = document.querySelector("#cpu_clock");
              targetElement.scrollIntoView();
            } else {
              this.cpu_clock_data = [];
              this.cpuShow2 = false;
              this.drawPieChartCPUClock();
            }
          }
          if (
            series.length ==
            this.treeData.filter((v) => v.label == children_data[1])[0].children
              .length
          ) {
            this.treeData.filter(
              (v) => v.label == children_data[1]
            )[0].is_check = true;
          } else {
            this.treeData.filter(
              (v) => v.label == children_data[1]
            )[0].is_check = false;
          }
          if (series.length == 0) {
            this.cpuCardShow = false;
          }
        }
      }
    },
    // async handleCheckChange(data, data1, data2) {
    //   this.seies_num++;
    //   console.log(this.seies_num);
    //   if (!data.children) {
    //     this.changeNodeCheckStatus(data.id, data1); //查找check字段并改变
    //     if (data.id !== 8) {
    //       let children_data = this.findNodeAndParentById(
    //         this.treeData,
    //         data.id
    //       ); //查询整个children情况 查询父节点name

    //       let series = children_data[0].filter((v) => v.is_check == true); //获取有效数据

    //       if (children_data[1] === "GPU") {
    //         // let id = this.treeData.filter((v) => v.label == children_data[1])[0]
    //         //   .id;
    //         // if (
    //         //   series.length <
    //         //   this.treeData.filter((v) => v.label == children_data[1])[0]
    //         //     .children.length
    //         // ) {
    //         //   this.setParentChecked(id);
    //         // } else {
    //         //   this.setParentAddChecked(id);
    //         // }
    //         // this.setParentChecked(id)
    //         // this.fps_seris_data = [];

    //         if (data.label === "GPU General Counter") {
    //           if (data1) {
    //             await this.gpu_general_counter_series();
    //             this.drawPieChartGPUGeneralCounter();
    //             let m = this.gpu_general_counter_data
    //               .map((v) => v.data.every((item) => item == ""))
    //               .every((i) => i == true);
    //             this.gpuShow = !m;
    //             const targetElement = document.querySelector(
    //               "#gpu_general_counter"
    //             );
    //             targetElement.scrollIntoView();
    //           } else {
    //             this.gpu_general_counter_data = [];
    //             this.gpuShow = false;
    //             this.drawPieChartGPUGeneralCounter();
    //           }
    //         }
    //         if (data.label === "GPU Memory Counter") {
    //           if (data1) {
    //             await this.gpu_memory_counter_series();
    //             this.drawPieChartGPUMemoryCounter();
    //             let m = this.gpu_memory_counter_data
    //               .map((v) => v.data.every((item) => item == ""))
    //               .every((i) => i == true);
    //             this.gpuShow1 = !m;
    //             const targetElement = document.querySelector(
    //               "#gpu_memory_counter"
    //             );
    //             targetElement.scrollIntoView();
    //           } else {
    //             this.gpu_memory_counter_data = [];
    //             this.gpuShow1 = false;
    //             this.drawPieChartGPUMemoryCounter();
    //           }
    //         }
    //         if (data.label === "GPU Shader Counter") {
    //           if (data1) {
    //             await this.gpu_shader_counter_series();
    //             this.drawPieChartGPUShaderCounter();
    //             let m = this.gpu_shader_counter_data
    //               .map((v) => v.data.every((item) => item == ""))
    //               .every((i) => i == true);
    //             this.gpuShow2 = !m;
    //             const targetElement = document.querySelector(
    //               "#gpu_shader_counter"
    //             );
    //             targetElement.scrollIntoView();
    //           } else {
    //             this.gpu_shader_counter_data = [];
    //             this.gpuShow2 = false;
    //             this.drawPieChartGPUShaderCounter();
    //           }
    //         }
    //       }
    //       if (children_data[1] === "Memory") {
    //         if (data.label === "MemoryDetail") {
    //           if (data1) {
    //             await this.memory_detail_series();
    //             this.drawPieChartMemoryDetail();
    //             let m = this.memory_detail_data
    //               .map((v) => v.data.every((item) => item == ""))
    //               .every((i) => i == true);

    //             this.memoryShow = !m;
    //             const targetElement = document.querySelector("#memory_detail");
    //             targetElement.scrollIntoView();
    //           } else {
    //             this.memory_detail_data = [];
    //             this.memoryShow = false;
    //             this.drawPieChartMemoryDetail();
    //           }
    //         }
    //         if (data.label === "Memory Usage") {
    //           if (data1) {
    //             await this.pss_line_series();
    //             this.drawPieChartPSS();
    //             let m = this.pss_line_data
    //               .map((v) => v.data.every((item) => item == ""))
    //               .every((i) => i == true);
    //             this.pssShow = !m;
    //             const targetElement = document.querySelector("#pss_line");
    //             targetElement.scrollIntoView();
    //           } else {
    //             this.pss_line_data = [];
    //             this.pssShow = false;
    //             this.drawPieChartPSS();
    //           }
    //         }
    //       }
    //       if (children_data[1] === "CPU") {
    //         if (data.label === "CPU Usage") {
    //           if (data1) {
    //             await this.cpu_usage_line_series();
    //             this.drawPieChartCPUUsage();
    //             let m = this.cpu_usage_line_data
    //               .map((v) => v.data.every((item) => item == ""))
    //               .every((i) => i == true);

    //             this.cpuShow = !m;
    //             const targetElement = document.querySelector("#cpu_usage_line");
    //             targetElement.scrollIntoView();
    //           } else {
    //             this.cpu_usage_line_data = [];
    //             this.cpuShow = false;
    //             this.drawPieChartCPUUsage();
    //           }
    //         }
    //         if (data.label === "CPU Core USage(Normalized)") {
    //           if (data1) {
    //             await this.cpu_freq_line_series();
    //             this.drawPieChartCPUFreq();
    //             let m = this.cpu_freq_line_data
    //               .map((v) => v.data.every((item) => item == ""))
    //               .every((i) => i == true);
    //             this.lableShow1 = !m;
    //             const targetElement = document.querySelector("#cpu_freq_line");
    //             targetElement.scrollIntoView();
    //           } else {
    //             this.cpu_freq_line_data = [];
    //             this.lableShow1 = false;
    //             this.drawPieChartCPUFreq();
    //           }
    //         }
    //         if (data.label === "CPU Core Usage") {
    //           if (data1) {
    //             await this.cpu_core_usage_series();
    //             this.drawPieChartCPUCoreUsage();
    //             let m = this.cpu_core_usage_data
    //               .map((v) => v.data.every((item) => item == ""))
    //               .every((i) => i == true);
    //             this.cpuShow1 = !m;
    //             const targetElement = document.querySelector("#cpu_core_usage");
    //             targetElement.scrollIntoView();
    //           } else {
    //             this.cpu_core_usage_data = [];
    //             this.cpuShow1 = false;
    //             this.drawPieChartCPUCoreUsage();
    //           }
    //         }
    //         if (data.label === "CPU Usage(Normalized)") {
    //           if (data1) {
    //             await this.cpu_usage_normalized_series();
    //             this.drawPieChartCPUUsageNormalized();
    //             let m = this.cpu_usage_normalized_data
    //               .map((v) => v.data.every((item) => item == ""))
    //               .every((i) => i == true);
    //             this.cpuShow4 = !m;
    //             const targetElement = document.querySelector(
    //               "#cpu_usage_normalized"
    //             );
    //             targetElement.scrollIntoView();
    //           } else {
    //             this.cpu_usage_normalized_data = [];
    //             this.cpuShow4 = false;
    //             this.drawPieChartCPUUsageNormalized();
    //           }
    //         }
    //         if (data.label === "CPU Clock") {
    //           if (data1) {
    //             await this.cpu_clock_series();
    //             this.drawPieChartCPUClock();
    //             let m = this.cpu_clock_data
    //               .map((v) => v.data.every((item) => item == ""))
    //               .every((i) => i == true);
    //             this.cpuShow2 = !m;
    //             const targetElement = document.querySelector("#cpu_clock");
    //             targetElement.scrollIntoView();
    //           } else {
    //             this.cpu_clock_data = [];
    //             this.cpuShow2 = false;
    //             this.drawPieChartCPUClock();
    //           }
    //         }
    //       }
    //     }
    //     // else {
    //     //   if (data.label == "FrameTime") {
    //     //     if (data.is_check) {
    //     //       this.frametime_line_data = [];

    //     //       this.frametime_line_data = [
    //     //         {
    //     //           name: "frame_time",
    //     //           type: "line",
    //     //           showSymbol: false,
    //     //           data: this.chartDataFrame.rows.frame_time,
    //     //           itemStyle: this.chartSettings.itemStyle2,
    //     //         },
    //     //       ];

    //     //       if (this.frametime_line_data.length > 0) {
    //     //         this.frametime_line_data[0].markLine = {
    //     //           symbol: ["circle", "arrow"],
    //     //           data: [
    //     //             {
    //     //               silent: true,
    //     //               xAxis: this.month_new,
    //     //               label: {
    //     //                 position: "end",
    //     //                 show: true,
    //     //                 formatter: this.month_new,
    //     //                 color: "ED5664",
    //     //               },
    //     //               lineStyle: {
    //     //                 type: "solid",
    //     //                 color: "#ED5664",
    //     //                 width: "1",
    //     //                 opacity: this.opacity, // 设置为0，使标记线不可见
    //     //               },
    //     //             },
    //     //           ],
    //     //         };

    //     //         this.frameShow = true;
    //     //       }
    //     //     } else {
    //     //       this.frametime_line_data = [];
    //     //       this.frameShow = false;
    //     //     }

    //     //     this.drawPieChartFrameTime();
    //     //          const targetElement = document.querySelector('#frametime_line')
    //     //         targetElement.scrollIntoView();
    //     //   }
    //     // }
    //   } else {
    //     // 主要目的是因为出来默认点击会自动触发全部函数 this.seies_num大于10才进行触发
    //     if (this.seies_num > 11) {
    //       if (data1 == false) {
    //         if (data.children.every((v) => v.is_check == true)) {
    //           if (data.label === "温度") {
    //             this.lableShow3 = false;
    //             this.temp_line_data = [];
    //             this.drawPieChartTemp();
    //           }
    //           if (data.label === "FrameTime") {
    //             this.frameShow = false;
    //             this.frametime_line_data = [];
    //             this.drawPieChartFrameTime();
    //           }
    //           if (data.label === "Wakeups") {
    //             this.wakeupsShow = false;
    //             this.wakeups_data = [];
    //             this.drawPieChartWakeups();
    //           }
    //           if (data.label === "线程函数") {
    //             this.threadShow = false;
    //             this.analyse_data = [];
    //             this.drawAnalyseTrend();
    //           }
    //           if (data.label === "Energy") {
    //             this.EnergyShow = false;
    //             this.electric_line_data = [];
    //             this.drawPieChartElectric();
    //           }
    //           if (data.label === "CSwitch") {
    //             this.csWithchShow = false;
    //             this.cswitch_data = [];
    //             this.drawPieChartCsWitch();
    //           }
    //           if (data.label === "FPS") {
    //             this.fpsShow = false;
    //             this.fps_seris_data = [];
    //             this.drawPieChartFPS();
    //           }

    //           if (data.label === "NetWork") {
    //             this.flow_line_data = [];
    //             this.flowShow = false;
    //             this.drawPieChartFlow();
    //           }

    //           // if (data.label === "GPU General Counter") {
    //           //   this.gpu_general_counter_data = [];
    //           //   this.gpuShow = false;
    //           //   this.drawPieChartGPUGeneralCounter();
    //           // }
    //           if (data.label === "Memory") {
    //             this.pss_line_data = [];
    //             this.memory_detail_data = [];

    //             this.memoryShow = false;
    //             this.pssShow = false;

    //             this.drawPieChartMemoryDetail();
    //             this.drawPieChartPSS();
    //           }
    //           if (data.label === "GPU") {
    //             this.gpu_memory_counter_data = [];
    //             this.gpu_general_counter_data = [];
    //             this.gpu_shader_counter_data = [];
    //             this.gpuShow = false;
    //             this.gpuShow1 = false;
    //             this.gpuShow2 = false;
    //             this.drawPieChartGPUMemoryCounter();
    //             this.drawPieChartGPUGeneralCounter();
    //             this.drawPieChartGPUShaderCounter();
    //           }
    //           if (data.label === "CPU") {
    //             (this.cpu_usage_line_data = []), (this.cpu_freq_line_data = []);
    //             this.cpu_core_usage_data = [];
    //             this.cpu_usage_normalized_data = [];
    //             this.cpu_clock_data = [];
    //             this.cpuShow = false;
    //             this.lableShow1 = false;
    //             this.cpuShow1 = false;
    //             this.cpuShow4 = false;
    //             this.cpuShow2 = false;
    //             this.drawPieChartCPUUsage();
    //             this.drawPieChartCPUUsageNormalized();
    //             this.cpu_usage_normalized_series();
    //             this.drawPieChartCPUClock();
    //             this.drawPieChartCPUCoreUsage();
    //             this.drawPieChartCPUFreq();
    //           }
    //           // if (data.label === "GPU Shader Counter") {
    //           //   this.gpu_shader_counter_data = [];
    //           //   this.gpuShow2 = false;
    //           //   this.drawPieChartGPUShaderCounter();
    //           // }
    //         }
    //       } else {
    //         if (data.children.every((v) => v.is_check == true)) {
    //           if (data.label === "温度") {
    //             await this.temp_line_series();
    //             this.lableShow3 = !this.showBox(this.temp_line_data);
    //             this.drawPieChartTemp();
    //             const targetElement = document.querySelector("#status");
    //             targetElement.scrollIntoView();
    //           }
    //           if (data.label === "FrameTime") {
    //             this.frameShow = true;
    //             await this.frametime_line_series();
    //             this.drawPieChartFrameTime();
    //             const targetElement = document.querySelector("#frametime_line");
    //             targetElement.scrollIntoView();
    //           }
    //           if (data.label === "Wakeups") {
    //             await this.wakeups_data_series();
    //             this.wakeupsShow = !this.showBox(this.wakeups_data);
    //             this.drawPieChartWakeups();
    //             const targetElement = document.querySelector("#wakeupsBox");
    //             targetElement.scrollIntoView();
    //           }
    //           if (data.label === "CSwitch") {
    //             await this.cswitch_data_series();
    //             this.csWithchShow = !this.showBox(this.cswitch_data);
    //             this.drawPieChartCsWitch();
    //             const targetElement = document.querySelector("#CSwitchBox");
    //             targetElement.scrollIntoView();
    //           }
    //           if (data.label === "线程函数") {
    //             this.threadShow = true;
    //             await this.analyse_series();
    //             this.drawAnalyseTrend();
    //             const targetElement = document.querySelector("#analyse_box");
    //             targetElement.scrollIntoView();
    //           }
    //           if (data.label === "FPS") {
    //             this.fpsShow = true;
    //             await this.fps_series();
    //             this.drawPieChartFPS();
    //             const targetElement = document.querySelector("#fps_line");
    //             targetElement.scrollIntoView();
    //           }

    //           if (data.label === "NetWork") {
    //             await this.flow_line_series();
    //             this.flowShow = !this.showBox(this.flow_line_data);

    //             this.drawPieChartFlow();
    //             const targetElement = document.querySelector("#flow_line_box");
    //             targetElement.scrollIntoView();
    //           }
    //           if (data.label === "Memory") {
    //             await this.pss_line_series();
    //             await this.memory_detail_series();
    //             this.pssShow = !this.showBox(this.pss_line_data);
    //             this.memoryShow = !this.showBox(this.memory_detail_data);
    //             this.drawPieChartPSS();
    //             this.drawPieChartMemoryDetail();
    //             const targetElement = document.querySelector("#MemoryBox");
    //             targetElement.scrollIntoView();
    //           }
    //           if (data.label === "Energy") {
    //             await this.electric_line_series();
    //             this.EnergyShow = !this.showBox(this.electric_line_data);
    //             this.drawPieChartElectric();
    //             const targetElement = document.querySelector("#electric_line");
    //             targetElement.scrollIntoView();
    //           }
    //           if (data.label === "GPU") {
    //             await this.gpu_general_counter_series();
    //             await this.gpu_memory_counter_series();
    //             await this.gpu_shader_counter_series();
    //             // let m = this.gpu_general_counter_data
    //             //   .map((v) => v.data.every((item) => item == ""))
    //             //   .every((i) => i == true);
    //             this.gpuShow = !this.showBox(this.gpu_general_counter_data);
    //             this.gpuShow1 = !this.showBox(this.gpu_memory_counter_data);
    //             this.gpuShow2 = !this.showBox(this.gpu_shader_counter_data);
    //             this.drawPieChartGPUGeneralCounter();
    //             this.drawPieChartGPUShaderCounter();
    //             this.drawPieChartGPUMemoryCounter();
    //             const targetElement = document.querySelector("#gpuBox");
    //             targetElement.scrollIntoView();
    //           }
    //           if (data.label === "CPU") {
    //             await this.cpu_usage_line_series();
    //             await this.cpu_freq_line_series();
    //             await this.cpu_core_usage_series();
    //             await this.cpu_usage_normalized_series();
    //             await this.cpu_clock_series();
    //             this.cpuShow = !this.showBox(this.cpu_usage_line_data);
    //             this.lableShow1 = !this.showBox(this.cpu_freq_line_data);
    //             this.cpuShow1 = !this.showBox(this.cpu_core_usage_data);
    //             this.cpuShow4 = !this.showBox(this.cpu_usage_normalized_data);
    //             this.cpuShow2 = !this.showBox(this.cpu_clock_data);
    //             this.drawPieChartCPUUsage();
    //             this.drawPieChartCPUUsageNormalized();
    //             this.cpu_usage_normalized_series();
    //             this.drawPieChartCPUClock();
    //             this.drawPieChartCPUCoreUsage();
    //             this.drawPieChartCPUFreq();
    //             const targetElement = document.querySelector("#cpuBox");
    //             targetElement.scrollIntoView();
    //           }
    //         }
    //       }
    //     }
    //   }

    // },
    findNodeById(treeData, id) {
      for (let i = 0; i < treeData.length; i++) {
        const node = treeData[i];
        if (node.id === id) {
          return node;
        }
        if (node.children) {
          const foundNode = this.findNodeById(node.children, id);
          if (foundNode) {
            return foundNode;
          }
        }
      }
      return null;
    },
    changeNodeCheckStatus(id, newStatus) {
      const node = this.findNodeById(this.treeData, id);
      if (node) {
        node.is_check = newStatus;
      } else {
        console.log("Node not found for id:", id);
      }
    },
    // async handleSelect(value, row) {
    //   this.loading = true;
    //   this.loading1 = true;
    //   let arr3 = [];
    //   this.multipleSelection = value;
    //   //
    //   this.startValue = 0;
    //   this.endValue = 100;
    //   this.chartSettings.dataZoom[0].start = this.startValue;
    //   this.chartSettings.dataZoom[0].end = this.endValue;
    //   this.start_thread = 0;
    //   this.end_thread = 100;
    //   //

    //   let tableArr = [];
    //   let timeList = [];
    //   let tableSolt = [];
    //   let tableArr1 = [];
    //   //

    //   this.multipleSelection
    //     .filter((v) => v.id_label !== "all")
    //     .forEach(function (v) {
    //       tableArr.push(v.id_label);
    //     });

    //   // 排序
    //   this.testInfoList.forEach(function (v) {
    //     tableSolt.push(v.id_label);
    //   });

    //   tableSolt.forEach(function (v, i) {
    //     tableArr.forEach(function (j, k) {
    //       if (v === j) {
    //         tableArr1.push(v);
    //       }
    //     });
    //   });

    //   this.lteValue = "10";
    //   this.gteValue = "25";
    //   if (row.id_label === "all") {
    //     if (value.includes(row)) {
    //       this.$refs.dataTable.toggleAllSelection();
    //       this.lableShow = true;
    //       await dispatchGetPerfAvgdData(store, {
    //         project: this.project_id,
    //         id_test: this.id_test,
    //         id_label: ["all"],
    //       });
    //       await dispatchChangeFPSlte(store, {
    //         project: this.project_id,
    //         id_test: this.id_test,
    //         value: 10,
    //         labels: ["all"],
    //         mode: "lte",
    //       });
    //       await dispatchChangeFPSgte(store, {
    //         project: this.project_id,
    //         id_test: this.id_test,
    //         value: 25,
    //         labels: ["all"],
    //         mode: "gte",
    //       });
    //       await this.getTestInfo();
    //       await this.getLabelInfo();
    //       await this.getPerfInfo();
    //       await this.getperNewInfo();

    //       await this.getChangeFPS();
    //       await this.getFPSValue(this.testInfo3);
    //       await this.getOverview2(this.testInfo2, this.testInfo3, true);
    //       await this.getCPUValue(this.testInfo3);
    //       await this.getMemoryValue(this.testInfo3);
    //       await this.getGPUValue(this.testInfo3);
    //       await this.getNetWorkValue(this.testInfo3);
    //       await this.getCsWitch(this.testInfo3);
    //       await this.getWakeups(this.testInfo3);
    //       await this.getCustom(this.testInfo3);
    //       this.loading1 = false;
    //       await dispatchGetPerfSecondData(store, {
    //         project: this.project_id,
    //         id_test: this.id_test,
    //         id_label: ["all"],
    //       });

    //       this.lableList = this.lableList3;
    //     } else {
    //       this.$refs.dataTable.clearSelection();
    //       this.lableShow = false;
    //       await dispatchGetPerfAvgdData(store, {
    //         project: this.project_id,
    //         id_test: this.id_test,
    //         id_label: [],
    //       });
    //       await dispatchChangeFPSlte(store, {
    //         project: this.project_id,
    //         id_test: this.id_test,
    //         value: 10,
    //         labels: "",
    //         mode: "lte",
    //       });
    //       await dispatchChangeFPSgte(store, {
    //         project: this.project_id,
    //         id_test: this.id_test,
    //         value: 25,
    //         labels: "",
    //         mode: "gte",
    //       });
    //       await this.getTestInfo();
    //       await this.getLabelInfo();
    //       await this.getPerfInfo();
    //       await this.getperNewInfo();
    //       await this.getChangeFPS();
    //       await this.getFPSValue(this.testInfo3);
    //       await this.getOverview2(this.testInfo2, this.testInfo3, true);
    //       await this.getCPUValue(this.testInfo3);
    //       await this.getMemoryValue(this.testInfo3);
    //       await this.getGPUValue(this.testInfo3);
    //       await this.getNetWorkValue(this.testInfo3);
    //       await this.getCsWitch(this.testInfo3);
    //       await this.getWakeups(this.testInfo3);
    //       await this.getCustom(this.testInfo3);
    //       this.loading1 = false;
    //       await dispatchGetPerfSecondData(store, {
    //         project: this.project_id,
    //         id_test: this.id_test,
    //         id_label: [],
    //       });
    //     }
    //   } else {
    //     this.lableList3.forEach(function (v) {
    //       tableArr.forEach(function (j) {
    //         if (v.id_label == j) {
    //           arr3.push(v);
    //         }
    //       });
    //     });

    //     this.lableShow = true;
    //     this.allselecitonList = tableArr1;
    //     await dispatchGetPerfAvgdData(store, {
    //       project: this.project_id,
    //       id_test: this.id_test,
    //       id_label: Array(tableArr1),
    //     });
    //     await dispatchChangeFPSlte(store, {
    //       project: this.project_id,
    //       id_test: this.id_test,
    //       value: 10,
    //       labels: Array(tableArr1),
    //       mode: "lte",
    //     });
    //     await dispatchChangeFPSgte(store, {
    //       project: this.project_id,
    //       id_test: this.id_test,
    //       value: 25,
    //       labels: Array(tableArr1),
    //       mode: "gte",
    //     });
    //     await this.getTestInfo();
    //     await this.getLabelInfo();
    //     await this.getPerfInfo();
    //     await this.getChangeFPS();
    //     await this.getperNewInfo();
    //     await this.getFPSValue(this.testInfo3);
    //     await this.getOverview2(this.testInfo2, this.testInfo3, true);
    //     await this.getCPUValue(this.testInfo3);
    //     await this.getMemoryValue(this.testInfo3);
    //     await this.getGPUValue(this.testInfo3);
    //     await this.getNetWorkValue(this.testInfo3);
    //     await this.getCsWitch(this.testInfo3);
    //     await this.getWakeups(this.testInfo3);
    //     await this.getCustom(this.testInfo3);
    //     this.loading1 = false;
    //     await dispatchGetPerfSecondData(store, {
    //       project: this.project_id,
    //       id_test: this.id_test,
    //       id_label: Array(tableArr1),
    //     });
    //   }
    //   //  await this.getTestInfo();
    //   // await this.getLabelInfo();
    //   // await this.getPerfInfo();
    //   // await this.getChangeFPS();
    //   // await this.getFPSValue(this.testInfo);
    //   await this.getperNewInfo();
    //   await this.getData();
    //   //
    //   // function arrCheck(arr) {
    //   //   var newArr = [];
    //   //   for (let i = 0; i < arr.length; i++) {
    //   //     let temp = arr[i];
    //   //     let count = 0;
    //   //     for (let j = 0; j < arr.length; j++) {
    //   //       if (arr[j] == temp) {
    //   //         count++;
    //   //         arr[j] = -1;
    //   //       }
    //   //     }
    //   //     if (temp != -1) {
    //   //       newArr.push(count);
    //   //     }
    //   //   }
    //   //   return newArr;
    //   // }
    //   let labelWidthAll1 = [];

    //   let labelWidth1 = this.chartDataResult.rows.timeline.length;
    //   this.chartDataResult.rows.label.forEach(function (v) {
    //     labelWidthAll1.push((v.length / labelWidth1) * 100 + "%");
    //   });

    //   // let b = [];
    //   // let widthList = JSON.parse(
    //   //   JSON.stringify(this.chartDataResult.rows.label)
    //   // );
    //   // let c = this.chartDataResult.rows.label.length - 1;
    //   // arrCheck(widthList).forEach(function (v) {
    //   //
    //   //   b.push((v / c) * 100 + "%");
    //   // });
    //   //

    //   arr3.forEach(function (v, i) {
    //     labelWidthAll1.forEach(function (j, index) {
    //       if (i == index) {
    //         v.width = j;
    //       }
    //     });
    //   });

    //   for (let i = 0; i < arr3.length; i++) {
    //     if (arr3[i].width == undefined) {
    //       arr3[i].width = 0;
    //     }
    //   }
    //   if (row.id_label === "all") {
    //     this.lableList = this.lableList3;
    //   } else {
    //     this.lableList = arr3;
    //   }
    //   let req1 = RegExp(/_G_Battle/);
    //   let arr15 = JSON.parse(JSON.stringify(this.lableList));
    //   for (let i = 0; i < arr15.length; i++) {
    //     if (req1.test(arr15[i].id_label)) {
    //       arr15[i].id_label = arr15[i].id_label.replace("_G_Battle", "");
    //     }
    //   }
    //   this.lableList = arr15;
    //   // arrCheck(widthList);
    //   await this.fps_series();
    //   await this.cpu_usage_line_series();
    //   await this.electric_line_series();
    //   await this.cpu_usage_normalized_series();
    //   await this.temp_line_series();
    //   await this.pss_line_series();
    //   await this.gpu_memory_counter_series();
    //   await this.flow_line_series();
    //   await this.frametime_line_series();
    //   await this.gpu_general_counter_series();
    //   await this.gpu_shader_counter_series();
    //   await this.wakeups_data_series();
    //   await this.cswitch_data_series();
    //   await this.memory_detail_series();
    //   await this.cpu_freq_line_series();
    //   await this.cpu_core_usage_series();
    //   await this.cpu_clock_series();
    //   await this.analyse_series();
    //   this.getlableShow();
    //   this.drawPieChartFPS();
    //   this.drawPieChartFrameTime();
    //   this.drawPieChartCPUUsage();
    //   this.drawPieChartCPUFreq();
    //   this.drawPieChartPSS();
    //   this.drawPieChartMemoryDetail();
    //   this.drawPieChartGPUGeneralCounter();
    //   this.drawPieChartGPUMemoryCounter();
    //   this.drawPieChartGPUShaderCounter();
    //   this.drawPieChartFlow();
    //   this.drawAnalyseTrend();
    //   if (this.testInfo0.device.toUpperCase().indexOf("IPHONE") != -1) {
    //     this.drawPieChartCsWitch();
    //     this.drawPieChartWakeups();
    //   }
    //   if (this.chartDatacustom?.rows?.i?.length !== 0) {
    //     this.drawPieChartMonomem();
    //     this.drawPieChartVerts();
    //     this.drawPieChartTris();
    //     this.drawPieChartDc();
    //     this.drawPieChartGc();
    //   }
    //   if (this.chartDataMonoMem?.rows?.timeline?.length !== 0) {
    //     this.drawPieChartMono();
    //   }
    //   if (this.chartDataDrawCall?.rows?.timeline?.length !== 0) {
    //     this.drawPieChartDrawCall();
    //   }
    //   if (this.chartDataTriangle?.rows?.timeline?.length !== 0) {
    //     this.drawPieChartTriangle();
    //   }
    //   if (this.chartDataTemp?.rows?.timeline?.length !== 0) {
    //     this.drawPieChartTemp();
    //   }
    //   if (this.chartDataElectric?.rows?.timeline?.length !== 0) {
    //     this.drawPieChartElectric();
    //   }
    //   // this.getFPSValue(this.testInfo3);
    //   //  this.getOverview2(this.testInfo2,this.testInfo3,true);
    //   // this.getCPUValue(this.testInfo3);
    //   // this.getMemoryValue(this.testInfo3);
    //   // this.getGPUValue(this.testInfo3);
    //   // this.getNetWorkValue(this.testInfo3);
    //   // this.getCustom(this.testInfo3);
    //   this.getPictureData();
    //   this.drawPieChartCPUUsageNormalized();
    //   this.drawPieChartCPUCoreUsage();
    //   this.drawPieChartCPUClock();
    //   this.loading = false;
    // },

    btn(a) {
      this.displaylist = a;
      this.maskImg.img = this.pictureArr[a].img;
      this.showMask = true;
      this.closePictureBtn = true;
    },
    async lteclick(item) {
      if (this.allselecitonList == ["all"]) {
        await dispatchChangeFPSlte(store, {
          project: this.project_id,
          id_test: this.id_test,
          value: Number(item),
          labels: ["all"],
          mode: "lte",
        });
        await this.getChangeFPS();
        await this.getFPSValue(this.testInfo);
      } else {
        await dispatchChangeFPSlte(store, {
          project: this.project_id,
          id_test: this.id_test,
          value: Number(item),
          labels: this.allselecitonList,
          mode: "lte",
        });
        await this.getChangeFPS();
        await this.getFPSValue(this.testInfo3);
      }
    },
    async gteclick(item) {
      if (this.allselecitonList == ["all"]) {
        await dispatchChangeFPSgte(store, {
          project: this.project_id,
          id_test: this.id_test,
          value: Number(item),
          labels: ["all"],
          mode: "gte",
        });
        await this.getChangeFPS();
        await this.getFPSValue(this.testInfo);
      } else {
        await dispatchChangeFPSgte(store, {
          project: this.project_id,
          id_test: this.id_test,
          value: Number(item),
          labels: this.allselecitonList,
          mode: "gte",
        });
        await this.getChangeFPS();
        await this.getFPSValue(this.testInfo3);
      }
    },

    // 图片开关
    pictureSwitch() {
      if (this.flag) {
        this.innerwidth = 100 + "%";
        this.trans_time = 1 + "s";
        this.flag = false;
      } else {
        this.innerwidth = 40 + "px";
        this.flag = true;
      }
    },
    maskBtn(ev) {
      if (!this.$refs.mask.contains(ev.target)) {
        this.showMask = false;
        this.closePictureBtn = false;
      }
    },
    onSelectionChange(rows) {
      //
      //
      // let id_label = rows[0]['id_label']
    },
    getPictureData() {
      this.pictureArr = [];
      this.pictureList = this.pictureData.rows.screen_shot;
      this.timeList = this.pictureData.rows.timeline;
      // this.pictureList = [
      //   { img: require("../assets/test/6.jpg") },
      //   { img: require("../assets/test/10.jpg") },
      //   { img: require("../assets/test/8.jpg") },
      //   { img: require("../assets/test/24.jpg") },
      //   { img: require("../assets/test/9.jpg") },
      //   { img: require("../assets/test/22.jpg") },
      //   { img: require("../assets/test/14.jpg") },
      //   { img: require("../assets/test/15.jpg") },
      //   { img: require("../assets/test/16.jpg") },
      //   { img: require("../assets/test/17.jpg") },
      // ];
      // this.timeList = [
      //   "00:00",
      //   "00:01",
      //   "00:03",
      //   "00:05",
      //   "00:08",
      //   "00:10",
      //   11,
      //   13,
      //   15,
      //   17,
      //   19,
      // ];
      if (this.pictureList.length == 0 || this.timeList.length == 0) {
        this.rightBtn = false;
      } else {
        this.rightBtn = true;
      }
      for (let index in this.pictureList) {
        this.pictureArr.push({
          img: this.pictureList[index],
          time: this.timeList[index],
        });
      }

    },
    getData() {
      const perf_second_data = readPerfSecondData(store);
      this.chartDataResult = perf_second_data.result;
      this.chartDataSec = perf_second_data.custom_by_sec;
      this.chartDataFPS = perf_second_data.fps;
      this.chartDataFrame = perf_second_data.frame_time;
      this.chartDataCPU = perf_second_data.process_cpu_pcnt;
      this.chartDataCPUFreq = perf_second_data.cpu_freq;
      this.chartDataPSS = perf_second_data.pss;
      this.chartDataVSS = perf_second_data.vss;
      this.chartDataFlow = perf_second_data.flow;
      this.chartDataMonoMem = perf_second_data.mono;
      this.chartDataDrawCall = perf_second_data.drawcall;
      this.chartDataTriangle = perf_second_data.triangle;
      this.chartDataTemp = perf_second_data.temp;
      this.chartDataElectric = perf_second_data.electric;
      this.markArea.data = perf_second_data.markAreaDataSecond;
      this.markAreaFrame.data = perf_second_data.markAreaDataFrame;
      this.chartDatacustom = perf_second_data.custom;
      this.pictureData = perf_second_data.screen_shot;
    },
    // getFPSlte(){

    // },
    // getFPSgte(){

    // },
    getlableShow() {
      if (
        this.chartDataResult.rows["FPS"].every((v) => v == "") &&
        this.chartDataResult.rows["Jank"].every((v) => v == "") &&
        this.chartDataResult.rows["BigJank"].every((v) => v == "") &&
        this.chartDataResult.rows["Stutter[%]"].every((v) => v == "") &&
        this.chartDataResult.rows["InterFrame"].every((v) => v == "")
      ) {
        this.fpsShow = false;
      } else {
        this.fpsShow = true;
      }
      this.memoryShow = !this.showBox(this.memory_detail_data);
      this.lableShow3 = !this.showBox(this.temp_line_data);

      if (
        this.chartDataResult.rows["AppCPU[%]"].every((v) => v == "") &&
        this.chartDataResult.rows["TotalCPU[%]"].every((v) => v == "")
      ) {
        this.cpuShow = false;
      } else {
        this.cpuShow = true;
      }
      if (
        this.chartDataResult.rows["AppCPU[%](Normalized)"].every(
          (v) => v == ""
        ) &&
        this.chartDataResult.rows["TotalCPU[%](Normalized)"].every(
          (v) => v == ""
        )
      ) {
        this.cpuShow4 = false;
      } else {
        this.cpuShow4 = true;
      }
      if (
        this.chartDataResult.rows["CPUUsage0[%](Normalized)"].every(
          (v) => v == ""
        ) &&
        this.chartDataResult.rows["CPUUsage1[%](Normalized)"].every(
          (v) => v == ""
        ) &&
        this.chartDataResult.rows["CPUUsage2[%](Normalized)"].every(
          (v) => v == ""
        ) &&
        this.chartDataResult.rows["CPUUsage3[%](Normalized)"].every(
          (v) => v == ""
        ) &&
        this.chartDataResult.rows["CPUUsage4[%](Normalized)"].every(
          (v) => v == ""
        ) &&
        this.chartDataResult.rows["CPUUsage5[%](Normalized)"].every(
          (v) => v == ""
        ) &&
        this.chartDataResult.rows["CPUUsage6[%](Normalized)"].every(
          (v) => v == ""
        ) &&
        this.chartDataResult.rows["CPUUsage7[%](Normalized)"].every(
          (v) => v == ""
        )
      ) {
        this.lableShow1 = false;
      } else {
        this.lableShow1 = true;
      }
      if (
        this.chartDataResult.rows["CPUClock0[MHz]"].every((v) => v == "") &&
        this.chartDataResult.rows["CPUClock1[MHz]"].every((v) => v == "") &&
        this.chartDataResult.rows["CPUClock2[MHz]"].every((v) => v == "") &&
        this.chartDataResult.rows["CPUClock3[MHz]"].every((v) => v == "") &&
        this.chartDataResult.rows["CPUClock4[MHz]"].every((v) => v == "") &&
        this.chartDataResult.rows["CPUClock5[MHz]"].every((v) => v == "") &&
        this.chartDataResult.rows["CPUClock6[MHz]"].every((v) => v == "") &&
        this.chartDataResult.rows["CPUClock7[MHz]"].every((v) => v == "")
      ) {
        this.cpuShow2 = false;
      } else {
        this.cpuShow2 = true;
      }
      if (
        this.chartDataResult.rows["CPUUsage0[%]"].every((v) => v == "") &&
        this.chartDataResult.rows["CPUUsage1[%]"].every((v) => v == "") &&
        this.chartDataResult.rows["CPUUsage2[%]"].every((v) => v == "") &&
        this.chartDataResult.rows["CPUUsage3[%]"].every((v) => v == "") &&
        this.chartDataResult.rows["CPUUsage4[%]"].every((v) => v == "") &&
        this.chartDataResult.rows["CPUUsage5[%]"].every((v) => v == "") &&
        this.chartDataResult.rows["CPUUsage6[%]"].every((v) => v == "") &&
        this.chartDataResult.rows["CPUUsage7[%]"].every((v) => v == "")
      ) {
        this.cpuShow1 = false;
      } else {
        this.cpuShow1 = true;
      }
      if (
        this.chartDataResult.rows["Memory[MB]"].every((v) => v == "") &&
        this.chartDataResult.rows["SwapMemory[MB]"].every((v) => v == "") &&
        this.chartDataResult.rows["VirtualMemory[MB]"].every((v) => v == "") &&
        this.chartDataResult.rows["AvailableMemory[MB]"].every((v) => v == "")
      ) {
        this.pssShow = false;
      } else {
        this.pssShow = true;
      }

      // if (
      //   this.chartDataResult.rows["WriteTotal[MB]"].every((v) => v == "") ||
      //   this.chartDataResult.rows["WriteTotal[MB]"].every((v) => v == "") ||
      //   this.chartDataResult.rows["TextureL2Miss[%]"].every((v) => v == "") ||
      //   this.chartDataResult.rows["StalledOnSystemMemory[%]"].every(
      //     (v) => v == ""
      //   )
      // ) {
      //   this.lableShow1 = false;
      // } else {
      //   this.lableShow1 = true;
      // }

      if (
        this.chartDataResult.rows["GpuBusBusy[%]"].every((v) => v == "") &&
        this.chartDataResult.rows["ShadersBusy[%]"].every((v) => v == "") &&
        this.chartDataResult.rows["PreClippedPolygons[K]"].every((v) => v == "")
      ) {
        this.gpuShow = false;
      } else {
        this.gpuShow = true;
      }
      if (
        this.chartDataResult.rows["ReadTotal[MB]"].every((v) => v == "") &&
        this.chartDataResult.rows["WriteTotal[MB]"].every((v) => v == "") &&
        this.chartDataResult.rows["TextureL2Miss[%]"].every((v) => v == "") &&
        this.chartDataResult.rows["StalledOnSystemMemory[%]"].every(
          (v) => v == ""
        )
      ) {
        this.gpuShow1 = false;
      } else {
        this.gpuShow1 = true;
      }
      if (
        this.chartDataResult.rows["VerticesShaded[K]"].every((v) => v == "") &&
        this.chartDataResult.rows["FragmentsShaded[K]"].every((v) => v == "")
      ) {
        this.gpuShow2 = false;
      } else {
        this.gpuShow2 = true;
      }
      if (
        this.chartDataResult.rows["Send[KB/s]"].every((v) => v == "") &&
        this.chartDataResult.rows["Recv[KB/s]"].every((v) => v == "")
      ) {
        this.flowShow = false;
      } else {
        this.flowShow = true;
      }
      this.memoryShow = !this.showBox(this.temp_line_data);

      if (this.chartDataSec.rows["CSwitch"].every((v) => v == "")) {
        this.csWithchShow = false;
      } else {
        this.csWithchShow = true;
      }
      if (this.chartDataSec.rows["Wakeups"].every((v) => v == "")) {
        this.wakeupsShow = false;
      } else {
        this.wakeupsShow = true;
      }
      if (this.chartDataElectric.rows.electric_pcnt.every((v) => v == "")) {
        this.EnergyShow = false;
      } else {
        this.EnergyShow = true;
      }
    },
    downloadCsv() {
      const response_data = dispatchDownloadCsv(store, {
        project: this.project_id,
        id_test: this.id_test,
      });
      response_data.then((value) => {
        // 创建一个新的url，此url指向新建的Blob对象
        // let url = window.URL.createObjectURL(new Blob('\uFEFF' + [value]))
        let url = window.URL.createObjectURL(new Blob(["\uFEFF" + value]));
        // 创建a标签，并隐藏改a标签
        let link = document.createElement("a");
        link.style.display = "none";
        // a标签的href属性指定下载链接
        link.href = url;
        //setAttribute() 方法添加指定的属性，并为其赋指定的值。
        link.setAttribute(
          "download",
          "perf-data-" + String(this.id_test) + ".csv"
        );
        document.body.appendChild(link);
        link.click();

        // fileDownload(res.data, 'perf-data-' + String(this.$route.query.id_test) + '.csv')
      });
    },
    getTestInfo() {
      this.testInfo0 = readTestInfo(store)[0];
    },
    getTestIdTest() {
      this.id_test = readPerfReportIdTest(store).id_test;
      this.project_id = readPerfReportIdTest(store).project_id;
    },
    getlogDownload() {
      if (readLogDownload(store).length > 0) {
        this.logUrl = readLogDownload(store)[0].file_path;
      } else {
        this.logurl = "";
      }
    },
    getLableInfo() {
      let lableList1 = readLabelInfo(store).filter(
        (v) => v.id_label != "all" && v.is_group === false
      );

      let labelWidthAll = [];

      let labelWidth = this.chartDataResult.rows.timeline.length;
      this.chartDataResult.rows.label.forEach(function (v) {
        labelWidthAll.push((v.length / labelWidth) * 100 + "%");
      });

      for (let index in lableList1) {
        this.lableList3.push({
          id_label: lableList1[index].id_label,
          color: this.lableColorList[index],
          width: labelWidthAll[index],
        });
      }

      for (let i = 0; i < this.lableList3.length; i++) {
        if (this.lableList3[i].width == undefined) {
          this.lableList3[i].width = 0;
        }
      }

      this.lableList = this.lableList3;
      let req1 = RegExp(/_G_Battle/);
      let arr15 = JSON.parse(JSON.stringify(this.lableList));
      for (let i = 0; i < arr15.length; i++) {
        if (req1.test(arr15[i].id_label)) {
          arr15[i].id_label = arr15[i].id_label.replace("_G_Battle", "");
        }
      }
      this.lableList = arr15;
    },
    getLabelInfo() {
      // if (readPerfInfo(store).project === 27) {
      //   this.testInfo = readLabelInfo(store).filter(
      //     (item) => item.id_label === "Battle" && item.is_group === true
      //   )[0];
      // } else {
      //   this.testInfo = readLabelInfo(store).filter(
      //     (item) => item.is_group === false
      //   )[0];
      // }

      this.testInfoList = readLabelInfo(store);

      // this.testInfoList.push({ tagName: "我是", id_label: "我是" });
      // this.testInfoList.push({ tagName: "他", id_label: "他" });
      this.testInfoList.forEach((v) => {
        v.is_group = true;
      });

      for (let i = 0; i < this.testInfoList.length; i++) {
        for (let j in this.testInfoList[i]) {
          if (this.testInfoList[i][j] === null) {
            this.testInfoList[i][j] = "-";
          }
        }
      }
      // this.$nextTick(() => {
      //   for (let i = 0; i < this.testInfoList.length; i++) {
      //     this.$refs.dataTable.toggleRowSelection(this.testInfoList[i], true);
      //   }
      // });
    },
    getperNewInfo() {
      this.testInfo3 = readAvgData(store);

      for (let i in this.testInfo3) {
        if (this.testInfo3[i] === null) {
          this.testInfo3[i] = "-";
        }
      }
    },
    getPerfInfo() {
      this.testInfo2 = readPerfInfo(store);
      for (let i in this.testInfo2) {
        if (this.testInfo2[i] === null) {
          this.testInfo2[i] = "-";
        }
      }
    },
    judgNull(arr, node) {
      let count = 0;
      for (let i = 0; i < arr.length; i++) {
        for (let j = 0; j < arr[i]?.data?.length; j++) {
          if (
            arr[i].data.length > 0 &&
            arr[i].data[j] !== null &&
            arr[i].data[j] !== ""
          ) {
            count = count + 1;
          }
        }
      }
      if (count === 0) {
        node.setAttribute("style", "display:none");
        // node.parentNode.parentNode.setAttribute("style", "display:none");
      }
    },
    judgZero(arr, node) {
      let count = 0;
      for (let i = 0; i < arr.length; i++) {
        for (let j = 0; j < arr[i].data.length; j++) {
          if (arr[i].data[j] === 0) {
            count = count + 1;
          }
        }
        if (count === arr[i].data.length) {
          node.setAttribute("style", "display:none");
        }
      }
    },
    showTable() {
      dispatchGetPerfSecondData(store, {
        project: this.project_id,
        id_test: this.id_test,
        id_label: ["all"],
        // id_label: "all",
      });
    },
    drawAnalyseTrend() {
      let performance_line = document.getElementById("analyse");

      if (performance_line.getAttribute("style") === "display:none") {
        performance_line.setAttribute("style", "width: 100%; height: 400px");
      }
      echarts.dispose(performance_line);
      let xAxis = [];
      xAxis = this.cpu_by_frame.abs_times;

      var contrastChart = echarts.init(performance_line);
      contrastChart.getZr().on("click", async (params) => {
        var pointInPixel = [params.offsetX, params.offsetY];
        if (contrastChart.containPixel("grid", pointInPixel)) {
          /*此处添加具体执行代码*/
          // var infoBox = document.getElementById('info-box');
          //           infoBox.style.height =200 + 'px';
          //           infoBox.style.left = pointInPixel[0] + 'px';
          //           infoBox.style.bottom = '100px';
          //           infoBox.style.display = 'block';
          var pointInGrid = contrastChart.convertFromPixel(
            { seriesIndex: 0 },
            pointInPixel
          );
          //X轴序号
          var xIndex = pointInGrid[0];

          //获取当前图表的option
          var op = contrastChart.getOption();

          //获得图表中我们想要的数据

          let xaxis = this.cpu_by_frame.abs_times;
          xIndex = (xIndex + 1) / xaxis.length;
          var month = op.xAxis[0].data[xIndex];
          var value = op.series[0].data[xIndex];

          // var pointInGrid = FPSLineChart.convertFromPixel(
          //       { seriesIndex: 0 },
          //       pointInPixel
          //   );
          this.month_new = xIndex;
          this.opacity = 1;
          this.chartSettings.dataZoom[0].start = op.dataZoom[0].start;
          this.chartSettings.dataZoom[0].end = op.dataZoom[0].end;
          await this.drawAll();
          // await   this. fps_series()
          this.drawPieChartFPS();
          this.drawPieChartFrameTime();
          this.drawPieChartCPUUsage();
          this.drawPieChartCPUFreq();
          this.drawPieChartPSS();
          this.drawPieChartMemoryDetail();
          this.drawPieChartGPUGeneralCounter();
          this.drawPieChartGPUMemoryCounter();
          this.drawPieChartGPUShaderCounter();
          this.drawPieChartFlow();
          if (this.testInfo0.device.toUpperCase().indexOf("IPHONE") != -1) {
            this.drawPieChartCsWitch();
            this.drawPieChartWakeups();
          }

          if (this.chartDatacustom?.rows?.i?.length !== 0) {
            this.drawPieChartMonomem();
            this.drawPieChartVerts();
            this.drawPieChartTris();
            this.drawPieChartDc();
            this.drawPieChartGc();
          }

          //
          if (this.chartDataMonoMem?.rows?.timeline?.length !== 0) {
            this.drawPieChartMono();
          }
          if (this.chartDataDrawCall?.rows?.timeline?.length !== 0) {
            this.drawPieChartDrawCall();
          }
          if (this.chartDataTriangle?.rows?.timeline?.length !== 0) {
            this.drawPieChartTriangle();
          }
          if (this.chartDataTemp?.rows?.timeline?.length !== 0) {
            this.drawPieChartTemp();
          }
          if (this.chartDataElectric?.rows?.timeline?.length !== 0) {
            this.drawPieChartElectric();
          }

          this.getPictureData();
          this.drawPieChartCPUUsageNormalized();
          this.drawPieChartCPUCoreUsage();
          this.drawPieChartCPUClock();
          // this.drawAnalyseTrend()
          //   option.series[0].markLine.data[0].xAxis=month
          //  option.series[0].markLine.data[0].lineStyle.opacity=1
          //   console.log(this.opacity)
          // console.log(option.series)
          //             FPSLineChart.setOption(option);

          //
          //
        }
      });
      // for (let i = 0; i < this.cpu_by_frame?.frame_index?.length; i++) {
      //   xAxis.push(i);
      // }
      let option;
      option = {
        title: {
          text: "线程函数",
          textStyle: {
            fontSize: 16,
            fontWeight: 700,
            color: "#333",
          },
        },
        dataZoom: [
          //      {
          //   show: true,
          //   realtime: true,
          //   start: 0,
          //   //  left: 50, //左边的距离
          //   //     right: 40, //右边的距离
          //       bottom: 40, //右边的距离
          //          height: 14, //组件高度
          //   xAxisIndex: [0],
          //   handleColor: "#ddd", //h滑动图标的颜色
          //       handleStyle: {
          //         borderColor: "#cacaca",
          //         borderWidth: "1",
          //         shadowBlur: 2,
          //         background: "#ddd",
          //         shadowColor: "#ddd",
          //       },
          // },
          // {
          //   type: 'inside',
          //   realtime: true,
          //   start:0,
          //   disabled: true,
          // },
          //给x轴设置滚动条
          {
            start: this.startValue,
            end: this.endValue,
            // end: 100 - 1500 / 31, //默认为100
            type: "slider",
            yAxisIndex: "false",
            show: true,
            xAxisIndex: [0],
            // handleSize: 0, //滑动条的 左右2个滑动条的大小
            height: 14, //组件高度
            // left: 50, //左边的距离
            // right: 40, //右边的距离
            bottom: 40, //右边的距离
            handleColor: "#ddd", //h滑动图标的颜色
            handleStyle: {
              borderColor: "#cacaca",
              borderWidth: "1",
              shadowBlur: 2,
              background: "#ddd",
              shadowColor: "#ddd",
            },
            fillerColor: new echarts.graphic.LinearGradient(1, 0, 0, 0, [
              {
                //给颜色设置渐变色 前面4个参数，给第一个设置1，第四个设置0 ，就是水平渐变
                //给第一个设置0，第四个设置1，就是垂直渐变
                offset: 0,
                color: "#1eb5e5",
              },
              {
                offset: 1,
                color: "#5ccbb1",
              },
            ]),
            backgroundColor: "#ddd", //两边未选中的滑动条区域的颜色
            showDataShadow: false, //是否显示数据阴影 默认auto
            // showDetail: false, //即拖拽时候是否显示详细数值信息 默认true
            handleIcon:
              "M-292,322.2c-3.2,0-6.4-0.6-9.3-1.9c-2.9-1.2-5.4-2.9-7.6-5.1s-3.9-4.8-5.1-7.6c-1.3-3-1.9-6.1-1.9-9.3c0-3.2,0.6-6.4,1.9-9.3c1.2-2.9,2.9-5.4,5.1-7.6s4.8-3.9,7.6-5.1c3-1.3,6.1-1.9,9.3-1.9c3.2,0,6.4,0.6,9.3,1.9c2.9,1.2,5.4,2.9,7.6,5.1s3.9,4.8,5.1,7.6c1.3,3,1.9,6.1,1.9,9.3c0,3.2-0.6,6.4-1.9,9.3c-1.2,2.9-2.9,5.4-5.1,7.6s-4.8,3.9-7.6,5.1C-285.6,321.5-288.8,322.2-292,322.2z",
            filterMode: "filter",
          },
          //下面这个属性是里面拖到
          {
            type: "inside",
            show: true,
            xAxisIndex: [0],
            // zoomLock: false,
            disabled: true, // 禁用鼠标滚动缩放
            //  start: 0,//默认为1
            //  end: 100-1500/31,//默认为100
          },
        ],
        toolbox: this.chartSettings.toolbox,
        tooltip: {
          trigger: "axis",
          confine: true,
          axisPointer: {
            // 坐标轴指示器，坐标轴触发有效
            type: "line", // 默认为直线，可选为：'line' | 'shadow'
          },
          //       formatter: (params) => {
          //         {
          //           //  只粘贴formatter了
          // console.log(params)
          //           let relVal =
          //             Number(params[0].axisValueLabel) *10 +
          //             "-" +
          //             (Number(params[0].axisValueLabel) + 1) * 10;
          //           for (let i = 0; i < params.length; i++) {
          //             relVal +=
          //               "<div  style='display:flex;align-items:center;' ><div style='width:120px'>" +
          //               params[i].marker +
          //               params[i].seriesName +
          //               '</div><div style="font-weight:bold">' +
          //               (params[i].value == undefined ? "-" : params[i].value) + //   不同点
          //               "</div></div>";
          //           }

          //           return relVal;
          //         }
          //       },
          extraCssText: "white-space: normal; word-break: break-all;",

          //  formatter: function (params) {
          //   if (params instanceof Array) {
          //     let str = '';
          //     str += `${params[0].axisValue}<br/>`;
          //     params.forEach((m, index) => {

          //       str +=  `<span class="chart-tooltip-color" style="display: inline-block; margin-right: 10px; background-color: ${m.color}; width: 10px; height: 10px; border-radius:100%; margin-right: 5px"></span>`;
          //       str += `${m.seriesName}：${m.data==null?'--':m.data}`;
          //       str += `${index % 4 === 0 ? '<br/>' : ''}`; //一排放几个可根据实际情况改变
          //     });
          //     return str;
          //   }
          // },
        },
        legend: this.chartSettings.legend,
        grid: this.chartSettings.grid,
        yAxis: this.chartSettings.yAxis,
        xAxis: {
          type: "category",
          boundaryGap: false,
          data: xAxis,
          axisLabel: {
            // formatter: function (value, index) {
            //   return value * 10;
            // },
          },
        },
        series: this.analyse_data,
      };
      contrastChart.setOption(option);
      contrastChart.on("datazoom", (params) => {
        let start_rate = params.start;
        let end_rate = params.end;

        this.startValue = start_rate;
        this.endValue = end_rate;
        let start = contrastChart.getModel().option.dataZoom[0].startValue;
        let end = contrastChart.getModel().option.dataZoom[0].endValue;
        let arr = this.cpu_by_frame.frame_index.filter((v, i) => {
          if (start === this.cpu_by_frame.frame_index.length) {
            return i >= start - 1 && i < end;
          } else {
            return i >= start && i <= end;
          }
        });
        let newLabelName = this.cpu_by_frame_list.flat().filter((v, i) => {
          if (start === this.cpu_by_frame.frame_index.length) {
            return i >= start - 1 && i < end;
          } else {
            return i >= start && i <= end;
          }
        });

        var newArr = [],
          tempArr = [];
        for (var i = 0, j = newLabelName.length; i < j; i++) {
          if (newLabelName[i] == newLabelName[i + 1]) {
            tempArr.push(newLabelName[i]);
          } else {
            tempArr.push(newLabelName[i]);
            newArr.push(tempArr.slice(0));
            tempArr.length = 0;
          }
        }

        let c = newArr.flat();
        let n = Array.from(new Set(c));
        let nameArr = [];
        let name1Arr = [];
        this.labels1();
        this.list.forEach((v) => {
          n.forEach((j) => {
            if (v.label === j) {
              nameArr.push(v);
            }
          });
        });

        newArr.forEach((v) => {
          name1Arr.push({
            label: v[0],
            width: (v.length / arr.length) * 100 + "%",
          });
        });

        nameArr.forEach((v) => {
          name1Arr.forEach((j) => {
            if (v.label == j.label) {
              v.width = j.width;
            }
          });
        });
        this.list = nameArr;
        this.chartSettings.dataZoom[0].start = start_rate;
        this.chartSettings.dataZoom[0].end = end_rate;
        this.drawPieChartFPS();
        this.drawPieChartFrameTime();
        this.drawPieChartCPUUsage();
        this.drawPieChartCPUFreq();
        this.drawPieChartPSS();
        this.drawPieChartMemoryDetail();
        this.drawPieChartGPUGeneralCounter();
        this.drawPieChartGPUMemoryCounter();
        this.drawPieChartGPUShaderCounter();
        this.drawPieChartFlow();
        if (this.testInfo0.device.toUpperCase().indexOf("IPHONE") != -1) {
          this.drawPieChartCsWitch();
          this.drawPieChartWakeups();
        }

        if (this.chartDatacustom?.rows?.i?.length !== 0) {
          this.drawPieChartMonomem();
          this.drawPieChartVerts();
          this.drawPieChartTris();
          this.drawPieChartDc();
          this.drawPieChartGc();
        }

        //
        if (this.chartDataMonoMem?.rows?.timeline?.length !== 0) {
          this.drawPieChartMono();
        }
        if (this.chartDataDrawCall?.rows?.timeline?.length !== 0) {
          this.drawPieChartDrawCall();
        }
        if (this.chartDataTriangle?.rows?.timeline?.length !== 0) {
          this.drawPieChartTriangle();
        }
        if (this.chartDataTemp?.rows?.timeline?.length !== 0) {
          this.drawPieChartTemp();
        }
        if (this.chartDataElectric?.rows?.timeline?.length !== 0) {
          this.drawPieChartElectric();
        }

        this.getPictureData();
        this.drawPieChartCPUUsageNormalized();
        this.drawPieChartCPUCoreUsage();
        this.drawPieChartCPUClock();
      });
      this.judgNull(option.series, performance_line);
      return contrastChart;
    },
    drawPieChartFPS() {
      let fps_line = document.getElementById("fps_line");

      if (fps_line.getAttribute("style") === "display:none") {
        fps_line.setAttribute("style", "width: 100%; height: 400px");
      }

      // 用echarts时，如果存在DOM，就会报存在警告，处理方法删除DOM
      // echarts数据变动时, 数据正常，图标混乱，故以此解决
      echarts.dispose(fps_line);

      let FPSLineChart = echarts.init(fps_line);
      let option;

      //
      let file1 = this.file;
      // FPSLineChart.setOption(option,true);

      let time = this.chartDataResult.rows.timeline;
      let labelName = this.chartDataResult.rows.label;
      let lableList3 = this.lableList3;
      FPSLineChart.on("datazoom", (params) => {
        // 获取索引
        let start_rate = params.start;
        let end_rate = params.end;

        this.startValue = start_rate;
        this.endValue = end_rate;
        let start = FPSLineChart.getModel().option.dataZoom[0].startValue;
        let end = FPSLineChart.getModel().option.dataZoom[0].endValue;
        // if(Math.round(timeIndexEnd)===time.length){
        //   time.map((v,i)=>i>=Math.round(timeIndexStart)&& i<=Math.round(timeIndexEnd)-1)

        // }

        //
        let arr = time.filter((v, i) => {
          if (start === time.length) {
            return i >= start - 1 && i < end;
          } else {
            return i >= start && i <= end;
          }
        });

        // 获取labelName拉平数组

        let newLabelName = labelName.flat().filter((v, i) => {
          if (start === time.length) {
            return i >= start - 1 && i < end;
          } else {
            return i >= start && i <= end;
          }
        });

        // 获取新的lable
        var newArr = [],
          tempArr = [];
        for (var i = 0, j = newLabelName.length; i < j; i++) {
          if (newLabelName[i] == newLabelName[i + 1]) {
            tempArr.push(newLabelName[i]);
          } else {
            tempArr.push(newLabelName[i]);
            newArr.push(tempArr.slice(0));
            tempArr.length = 0;
          }
        }

        let labelWidthAll1 = [];
        let c = newArr.flat();
        let n = Array.from(new Set(c));
        let arr3 = [];

        lableList3.forEach(function (v) {
          n.forEach(function (j) {
            if (v.id_label == j) {
              arr3.push(v);
            }
          });
        });

        newArr.forEach(function (v) {
          labelWidthAll1.push((v.length / arr.length) * 100 + "%");
        });

        arr3.forEach(function (v, i) {
          labelWidthAll1.forEach(function (j, index) {
            if (i == index) {
              v.width = j;
            }
          });
        });

        this.lableList = arr3;
        this.chartSettings.dataZoom[0].start = start_rate;
        this.chartSettings.dataZoom[0].end = end_rate;

        this.drawPieChartFrameTime();
        this.drawPieChartCPUCoreUsage();
        this.drawPieChartCPUUsage();

        this.drawPieChartMemoryDetail();

        this.drawPieChartGPUGeneralCounter();
        // this.drawPieChartGPUMemoryCounter();
        this.drawPieChartGPUShaderCounter();
        this.drawPieChartWakeups();
        this.drawPieChartCPUUsageNormalized();
      });
      // this.lableList=arr4

      option = {
        title: {
          text: "FPS",
          textStyle: {
            fontSize: 16,
            fontWeight: 700,
            color: "#333",
          },
        },
        dataZoom: this.chartSettings.dataZoom,
        toolbox: this.chartSettings.toolbox,
        tooltip: this.chartSettings.tooltip,
        legend: this.chartSettings.legend,
        grid: this.chartSettings.grid,
        yAxis: this.chartSettings.yAxis,
        xAxis: {
          type: "category",
          boundaryGap: false,
          data:
            this.chartDataResult.rows.timeline.length !== 0
              ? this.chartDataResult.rows.timeline
              : this.chartDataFPS.rows.timeline,
        },
        series: this.fps_seris_data,
      };

      FPSLineChart.setOption(option);
      FPSLineChart.getZr().on("click", async (params) => {
        var pointInPixel = [params.offsetX, params.offsetY];

        if (FPSLineChart.containPixel("grid", pointInPixel)) {
          /*此处添加具体执行代码*/

          var pointInGrid = FPSLineChart.convertFromPixel(
            { seriesIndex: 0 },
            pointInPixel
          );
          //X轴序号
          var xIndex = pointInGrid[0];

          //获取当前图表的option
          var op = FPSLineChart.getOption();

          //获得图表中我们想要的数据
          var month = op.xAxis[0].data[xIndex];

          var value = op.series[0].data[xIndex];
          let xaxis =
            this.chartDataResult.rows.timeline.length !== 0
              ? this.chartDataResult.rows.timeline
              : this.chartDataFPS.rows.timeline;
          xIndex = (xIndex + 1) / xaxis.length;

          // var pointInGrid = FPSLineChart.convertFromPixel(
          //       { seriesIndex: 0 },
          //       pointInPixel
          //   );
          this.month_new = xIndex;
          this.opacity = 1;
          this.chartSettings.dataZoom[0].start = op.dataZoom[0].start;
          this.chartSettings.dataZoom[0].end = op.dataZoom[0].end;
          await this.drawAll();
          // await   this. fps_series()
          this.drawPieChartFPS();
          this.drawPieChartFrameTime();
          this.drawPieChartCPUCoreUsage();
          this.drawPieChartCPUUsage();

          this.drawPieChartMemoryDetail();

          this.drawPieChartGPUGeneralCounter();
          // this.drawPieChartGPUMemoryCounter();
          this.drawPieChartGPUShaderCounter();
          this.drawPieChartWakeups();
          this.drawPieChartCPUUsageNormalized();
        }
        let x = month;

        let boxWidth = document.getElementById(this.pictureArr[0].time)
          .offsetWidth;

        // 获取居中平移距离
        let ofwidth = document.getElementById("cs").offsetLeft + boxWidth;

        // 将每一次平移居中位置放置每一个对象中
        this.pictureArr.forEach(function (v) {
          //
          v.ofwidth = ofwidth -= boxWidth + 10;
          //
          //
        });

        let pictureObj = this.pictureArr.filter(function (v) {
          return v.time === x;
        });

        if (pictureObj.length > 0) {
          file1 = pictureObj[0].ofwidth + "px";
          document.getElementById(
            "scro"
          ).style.transform = `translateX(${file1})`;
          document.getElementById(pictureObj[0].time).firstChild.style.outline =
            "6px solid #4271fb";
          let po = this.sibling1(document.getElementById(pictureObj[0].time));
          //     var siblings = sibling(document.getElementById(pictureObj[0].time));
          po.forEach(function (v) {
            //
            v.firstChild.style.outline = 0;
          });
        } else {
          let pic = this.pictureArr.filter(
            (v) => v.time === this.subtractTwoSeconds(x)
          )[0];
          file1 = pic.ofwidth + "px";
          document.getElementById(
            "scro"
          ).style.transform = `translateX(${file1})`;
          document.getElementById(pic.time).firstChild.style.outline =
            "6px solid #4271fb";
          let po = this.sibling1(document.getElementById(pic.time));
          //     var siblings = sibling(document.getElementById(pictureObj[0].time));
          po.forEach(function (v) {
            //
            v.firstChild.style.outline = 0;
          });
        }

        // var siblings = sibling(document.getElementById(pictureObj[0].time));
        // siblings.forEach(function (v) {
        //   //
        //   v.firstChild.style.outline = 0;
        // });
      });
      this.judgNull(option.series, fps_line);
      // if (
      //   document.getElementById("frametime_line").getAttribute("style") ===
      //     "display:none" &&
      //   document.getElementById("fps_line").getAttribute("style") ===
      //     "display:none"
      // ) {
      //   document
      //     .getElementById("frametime_line")
      //     .parentNode.parentNode.setAttribute("style", "display:none");
      // }
      return FPSLineChart;
    },
    drawPieChartFrameTime() {
      let frametime_line = document.getElementById("frametime_line");
      if (frametime_line.getAttribute("style") === "display:none") {
        frametime_line.setAttribute("style", "width: 100%; height: 400px");
      }

      // 用echarts时，如果存在DOM，就会报存在警告，处理方法删除DOM
      // echarts数据变动时, 数据正常，图标混乱，故以此解决
      echarts.dispose(frametime_line);

      let FrameTimeLineChart = echarts.init(frametime_line);
      let list1 = [];
      list1 = this.pictureArr;
      //
      let file1 = this.file;
      let time = this.chartDataResult.rows.timeline;
      let labelName = this.chartDataResult.rows.label;
      let lableList3 = this.lableList3;
      FrameTimeLineChart.on("datazoom", async (params) => {
        // 获取索引
        let start_rate = params.start;
        let end_rate = params.end;
        let timeIndexStart = time.length * (params.start / 100);
        let timeIndexEnd = time.length * (params.end / 100);
        this.startValue = start_rate;
        this.endValue = end_rate;
        let start = FrameTimeLineChart.getModel().option.dataZoom[0].startValue;
        let end = FrameTimeLineChart.getModel().option.dataZoom[0].endValue;
        // if(Math.round(timeIndexEnd)===time.length){
        //   time.map((v,i)=>i>=Math.round(timeIndexStart)&& i<=Math.round(timeIndexEnd)-1)

        // }

        //
        let arr = time.filter((v, i) => {
          if (Math.round(timeIndexStart) === time.length) {
            return (
              i >= Math.round(timeIndexStart) - 1 &&
              i < Math.round(timeIndexEnd)
            );
          } else {
            return (
              i >= Math.round(timeIndexStart) && i <= Math.round(timeIndexEnd)
            );
          }
          // if (
          //   i >= Math.round(timeIndexStart) &&
          //   i < Math.round(timeIndexEnd)
          // ) {
          //   return v;
          // }
        });
        //
        // 返回新的timeline数组
        // let arr = indexList.filter((res) => {
        //   return res != undefined;
        // });

        // 获取labelName拉平数组

        let newLabelName = labelName.flat().filter((v, i) => {
          if (Math.round(timeIndexStart) === time.length) {
            return (
              i >= Math.round(timeIndexStart) - 1 &&
              i < Math.round(timeIndexEnd)
            );
          } else {
            return (
              i >= Math.round(timeIndexStart) && i <= Math.round(timeIndexEnd)
            );
          }
          // return (
          //   i >= Math.round(timeIndexStart) && i <Math.round(timeIndexEnd)
          // );
        });

        // 获取新的lable
        var newArr = [],
          tempArr = [];
        for (var i = 0, j = newLabelName.length; i < j; i++) {
          if (newLabelName[i] == newLabelName[i + 1]) {
            tempArr.push(newLabelName[i]);
          } else {
            tempArr.push(newLabelName[i]);
            newArr.push(tempArr.slice(0));
            tempArr.length = 0;
          }
        }

        let labelWidthAll1 = [];
        let c = newArr.flat();
        let n = Array.from(new Set(c));
        let arr3 = [];

        lableList3.forEach(function (v) {
          n.forEach(function (j) {
            if (v.id_label == j) {
              arr3.push(v);
            }
          });
        });

        newArr.forEach(function (v) {
          labelWidthAll1.push((v.length / arr.length) * 100 + "%");
        });

        arr3.forEach(function (v, i) {
          labelWidthAll1.forEach(function (j, index) {
            if (i == index) {
              v.width = j;
            }
          });
        });

        this.lableList = arr3;
        this.chartSettings.dataZoom[0].start = start_rate;
        this.chartSettings.dataZoom[0].end = end_rate;

        this.drawPieChartFPS();
        this.drawPieChartFPS();
        //  this.drawPieChartFrameTime();
        this.drawPieChartCPUCoreUsage();
        this.drawPieChartCPUUsage();

        this.drawPieChartMemoryDetail();

        this.drawPieChartGPUGeneralCounter();
        // this.drawPieChartGPUMemoryCounter();
        this.drawPieChartGPUShaderCounter();
        this.drawPieChartWakeups();
        this.drawPieChartCPUUsageNormalized();
      });
      FrameTimeLineChart.getZr().on("click", async (params) => {
        var pointInPixel = [params.offsetX, params.offsetY];
        if (FrameTimeLineChart.containPixel("grid", pointInPixel)) {
          /*此处添加具体执行代码*/

          var pointInGrid = FrameTimeLineChart.convertFromPixel(
            { seriesIndex: 0 },
            pointInPixel
          );
          //X轴序号
          var xIndex = pointInGrid[0];

          //获取当前图表的option
          var op = FrameTimeLineChart.getOption();

          //获得图表中我们想要的数据
          var month = op.xAxis[0].data[xIndex];
          var value = op.series[0].data[xIndex];
          let xaxis = this.chartDataFrame.rows.id_frame.map(
            (v, index) => v + "_" + String(index)
          );
          xIndex = (xIndex + 1) / xaxis.length;
          this.month_new = xIndex;

          this.opacity = 1;
          this.chartSettings.dataZoom[0].start = op.dataZoom[0].start;
          this.chartSettings.dataZoom[0].end = op.dataZoom[0].end;
          await this.drawAll();
          this.drawPieChartFPS();
          this.drawPieChartFrameTime();
          this.drawPieChartCPUCoreUsage();
          this.drawPieChartCPUUsage();

          this.drawPieChartMemoryDetail();

          this.drawPieChartGPUGeneralCounter();
          // this.drawPieChartGPUMemoryCounter();
          this.drawPieChartGPUShaderCounter();
          this.drawPieChartWakeups();
          this.drawPieChartCPUUsageNormalized();
          //
          //
        }
        let boxWidth = document.getElementById(this.pictureArr[0].time)
          .offsetWidth;

        // 获取居中平移距离
        let ofwidth = document.getElementById("cs").offsetLeft + boxWidth;

        // 将每一次平移居中位置放置每一个对象中
        this.pictureArr.forEach(function (v) {
          v.ofwidth = ofwidth -= boxWidth + 10;
          //
          //
        });
        let x = month;
        let pictureObj = this.pictureArr.filter(function (v) {
          return v.time === x;
        });

        if (pictureObj.length > 0) {
          file1 = pictureObj[0].ofwidth + "px";
          document.getElementById(
            "scro"
          ).style.transform = `translateX(${file1})`;
          document.getElementById(pictureObj[0].time).firstChild.style.outline =
            "6px solid #4271fb";
          let po = this.sibling1(document.getElementById(pictureObj[0].time));
          //     var siblings = sibling(document.getElementById(pictureObj[0].time));
          po.forEach(function (v) {
            //
            v.firstChild.style.outline = 0;
          });
        } else {
          let pic = this.pictureArr.filter(
            (v) => v.time === this.subtractTwoSeconds(x)
          )[0];
          file1 = pic.ofwidth + "px";
          document.getElementById(
            "scro"
          ).style.transform = `translateX(${file1})`;
          document.getElementById(pic.time).firstChild.style.outline =
            "6px solid #4271fb";
          let po = this.sibling1(document.getElementById(pic.time));
          //     var siblings = sibling(document.getElementById(pictureObj[0].time));
          po.forEach(function (v) {
            //
            v.firstChild.style.outline = 0;
          });
        }
      });

      let option;

      option = {
        title: {
          text: "Frame Time",
          textStyle: {
            fontSize: 16,
            fontWeight: 700,
            color: "#333",
          },
        },
        dataZoom: this.chartSettings.dataZoom,
        tooltip: {
          trigger: "axis",
          confine: true,
          axisPointer: {
            // 坐标轴指示器，坐标轴触发有效
            type: "line", // 默认为直线，可选为：'line' | 'shadow'
          },
          formatter: (params) => {
            {
              //  只粘贴formatter了

              let relVal = params[0].axisValueLabel.split("_")[0];

              for (let i = 0; i < params.length; i++) {
                relVal +=
                  "<div  style='display:flex;align-items:center;' ><div style='width:120px'>" +
                  params[i].marker +
                  params[i].seriesName +
                  '</div><div style="font-weight:bold">' +
                  (params[i].value == undefined ? "-" : params[i].value) + //   不同点
                  "</div></div>";
              }

              return relVal;
            }
          },
        },
        toolbox: this.chartSettings.toolbox,
        legend: this.chartSettings.legend,
        grid: this.chartSettings.grid,
        yAxis: this.chartSettings.yAxis,
        xAxis: {
          type: "category",
          boundaryGap: false,
          data: this.chartDataFrame.rows.id_frame.map(
            (v, index) => v + "_" + String(index)
          ),
          axisLabel: {
            formatter: function (value, index) {
              return value.split("_")[0];
            },
          },
        },
        series: this.frametime_line_data,
      };
      FrameTimeLineChart.setOption(option);
      this.judgNull(option.series, frametime_line);
      // if (
      //   document.getElementById("frametime_line").getAttribute("style") ===
      //     "display:none" &&
      //   document.getElementById("fps_line").getAttribute("style") ===
      //     "display:none"
      // ) {
      //   document
      //     .getElementById("frametime_line")
      //     .parentNode.parentNode.setAttribute("style", "display:none");
      // }
      return FrameTimeLineChart;
    },
    subtractTwoSeconds(timeString) {
      // 将分秒数据转换为秒数
      const [minutes, seconds] = timeString.split(":");
      const totalSeconds = parseInt(minutes) * 60 + parseInt(seconds);
      // 减去 1 秒
      const newTotalSeconds = totalSeconds - 1;
      // 转换为分秒格式
      const resultMinutes = Math.floor(newTotalSeconds / 60);
      const resultSeconds = newTotalSeconds % 60;
      const result = `${resultMinutes < 10 ? "0" : ""}${resultMinutes}:${
        resultSeconds < 10 ? "0" : ""
      }${resultSeconds}`;
      return result;
    },
    drawPieChartCPUUsage() {
      let cpu_usage_line = document.getElementById("Handle");
      if (cpu_usage_line.getAttribute("style") === "display:none") {
        cpu_usage_line.setAttribute("style", "width: 100%; height: 400px");
      }

      // 用echarts时，如果存在DOM，就会报存在警告，处理方法删除DOM
      // echarts数据变动时, 数据正常，图标混乱，故以此解决
      echarts.dispose(cpu_usage_line);

      let CPUUsageLineChart = echarts.init(cpu_usage_line);
      let list1 = [];
      list1 = this.pictureArr;

      let file1 = this.file;
      let time = this.chartDataResult.rows.timeline;
      let labelName = this.chartDataResult.rows.label;
      let lableList3 = this.lableList3;
      CPUUsageLineChart.on("datazoom", async (params) => {
        // 获取索引
        let start_rate = params.start;
        let end_rate = params.end;

        this.startValue = start_rate;
        this.endValue = end_rate;

        let start = CPUUsageLineChart.getModel().option.dataZoom[0].startValue;
        let end = CPUUsageLineChart.getModel().option.dataZoom[0].endValue;

        let arr = time.filter((v, i) => {
          if (start === time.length) {
            return i >= start - 1 && i < end;
          } else {
            return i >= start && i <= end;
          }
        });

        let newLabelName = labelName.flat().filter((v, i) => {
          if (start === time.length) {
            return i >= start - 1 && i < end;
          } else {
            return i >= start && i <= end;
          }
        });

        // 获取新的lable
        var newArr = [],
          tempArr = [];
        for (var i = 0, j = newLabelName.length; i < j; i++) {
          if (newLabelName[i] == newLabelName[i + 1]) {
            tempArr.push(newLabelName[i]);
          } else {
            tempArr.push(newLabelName[i]);
            newArr.push(tempArr.slice(0));
            tempArr.length = 0;
          }
        }

        let labelWidthAll1 = [];
        let c = newArr.flat();
        let n = Array.from(new Set(c));
        let arr3 = [];

        lableList3.forEach(function (v) {
          n.forEach(function (j) {
            if (v.id_label == j) {
              arr3.push(v);
            }
          });
        });

        newArr.forEach(function (v) {
          labelWidthAll1.push((v.length / arr.length) * 100 + "%");
        });

        arr3.forEach(function (v, i) {
          labelWidthAll1.forEach(function (j, index) {
            if (i == index) {
              v.width = j;
            }
          });
        });

        this.lableList = arr3;
        this.chartSettings.dataZoom[0].start = start_rate;
        this.chartSettings.dataZoom[0].end = end_rate;

        this.drawPieChartFPS();
        this.drawPieChartFrameTime();
        this.drawPieChartCPUCoreUsage();
        // this.drawPieChartCPUUsage();

        this.drawPieChartMemoryDetail();

        this.drawPieChartGPUGeneralCounter();
        // this.drawPieChartGPUMemoryCounter();
        this.drawPieChartGPUShaderCounter();
        this.drawPieChartWakeups();
        this.drawPieChartCPUUsageNormalized();
      });
      CPUUsageLineChart.getZr().on("click", async (params) => {
        var pointInPixel = [params.offsetX, params.offsetY];
        if (CPUUsageLineChart.containPixel("grid", pointInPixel)) {
          /*此处添加具体执行代码*/

          var pointInGrid = CPUUsageLineChart.convertFromPixel(
            { seriesIndex: 0 },
            pointInPixel
          );
          //X轴序号
          var xIndex = pointInGrid[0];

          //获取当前图表的option
          var op = CPUUsageLineChart.getOption();

          //获得图表中我们想要的数据
          var month = op.xAxis[0].data[xIndex];
          var value = op.series[0].data[xIndex];
          let xaxis = this.chartDataResult.rows.timeline;
          xIndex = (xIndex + 1) / xaxis.length;
          this.month_new = xIndex;

          this.opacity = 1;
          this.chartSettings.dataZoom[0].start = op.dataZoom[0].start;
          this.chartSettings.dataZoom[0].end = op.dataZoom[0].end;
          await this.drawAll();
          this.drawPieChartFPS();
          this.drawPieChartFrameTime();
          this.drawPieChartCPUCoreUsage();
          this.drawPieChartCPUUsage();

          this.drawPieChartMemoryDetail();

          this.drawPieChartGPUGeneralCounter();
          // this.drawPieChartGPUMemoryCounter();
          this.drawPieChartGPUShaderCounter();
          this.drawPieChartWakeups();
          this.drawPieChartCPUUsageNormalized();
        }
        let boxWidth = document.getElementById(this.pictureArr[0].time)
          .offsetWidth;

        // 获取居中平移距离
        let ofwidth = document.getElementById("cs").offsetLeft + boxWidth;

        // 将每一次平移居中位置放置每一个对象中
        this.pictureArr.forEach(function (v) {
          v.ofwidth = ofwidth -= boxWidth + 10;
          //
          //
        });
        let x = month;
        let pictureObj = this.pictureArr.filter(function (v) {
          return v.time === x;
        });

        if (pictureObj.length > 0) {
          file1 = pictureObj[0].ofwidth + "px";
          document.getElementById(
            "scro"
          ).style.transform = `translateX(${file1})`;
          document.getElementById(pictureObj[0].time).firstChild.style.outline =
            "6px solid #4271fb";
          let po = this.sibling1(document.getElementById(pictureObj[0].time));
          //     var siblings = sibling(document.getElementById(pictureObj[0].time));
          po.forEach(function (v) {
            //
            v.firstChild.style.outline = 0;
          });
        } else {
          let pic = this.pictureArr.filter(
            (v) => v.time === this.subtractTwoSeconds(x)
          )[0];
          file1 = pic.ofwidth + "px";
          document.getElementById(
            "scro"
          ).style.transform = `translateX(${file1})`;
          document.getElementById(pic.time).firstChild.style.outline =
            "6px solid #4271fb";
          let po = this.sibling1(document.getElementById(pic.time));
          //     var siblings = sibling(document.getElementById(pictureObj[0].time));
          po.forEach(function (v) {
            //
            v.firstChild.style.outline = 0;
          });
        }
      });
      let option;

      option = {
        title: {
          text: "Handle",
          textStyle: {
            fontSize: 16,
            fontWeight: 700,
            color: "#333",
          },
        },
        dataZoom: this.chartSettings.dataZoom,
        toolbox: this.chartSettings.toolbox,
        tooltip: this.chartSettings.tooltip,
        legend: this.chartSettings.legend,
        grid: this.chartSettings.grid,
        yAxis: this.chartSettings.yAxis,
        xAxis: {
          type: "category",
          boundaryGap: false,
          data: this.chartDataResult.rows.timeline,
        },
        series: this.cpu_usage_line_data,
      };
      CPUUsageLineChart.setOption(option);
      this.judgNull(option.series, cpu_usage_line);
      // if (
      //   document.getElementById("cpu_usage_line").getAttribute("style") ===
      //     "display:none" &&
      //   document.getElementById("cpu_freq_line").getAttribute("style") ===
      //     "display:none"
      // ) {
      //   document
      //     .getElementById("cpu_usage_line")
      //     .parentNode.parentNode.setAttribute("style", "display:none");
      // }
      return CPUUsageLineChart;
    },
    drawAll() {
      if (this.fps_seris_data.length > 0) {
        let xaxis =
          this.chartDataResult.rows.timeline.length !== 0
            ? this.chartDataResult.rows.timeline
            : this.chartDataFPS.rows.timeline;
        this.fps_seris_data[0].markLine = {
          symbol: ["circle", "arrow"],
          data: [
            {
              silent: true,
              xAxis: Math.round(this.month_new * xaxis.length) - 1,
              label: {
                position: "end",
                show: true,
                formatter: xaxis[Math.round(this.month_new * xaxis.length) - 1],
                color: "ED5664",
              },
              lineStyle: {
                type: "solid",
                color: "#ED5664",
                width: "1",
                opacity: this.opacity, // 设置为0，使标记线不可见
              },
            },
          ],
        };
      }
      if (this.cpu_usage_line_data.length > 0) {
        let xaxis = this.chartDataResult.rows.timeline;
        this.cpu_usage_line_data[0].markLine = {
          symbol: ["circle", "arrow"],
          data: [
            {
              silent: true,
              xAxis: Math.round(this.month_new * xaxis.length) - 1,
              label: {
                position: "end",
                show: true,
                formatter: xaxis[Math.round(this.month_new * xaxis.length) - 1],
                color: "ED5664",
              },
              lineStyle: {
                type: "solid",
                color: "#ED5664",
                width: "1",
                opacity: this.opacity, // 设置为0，使标记线不可见
              },
            },
          ],
        };
      }

      if (this.cswitch_data.length > 0) {
        let xaxis = this.chartDataResult.rows.timeline;
        this.cswitch_data[0].markLine = {
          symbol: ["circle", "arrow"],
          data: [
            {
              silent: true,
              xAxis: Math.round(this.month_new * xaxis.length) - 1,
              label: {
                position: "end",
                show: true,
                formatter: xaxis[Math.round(this.month_new * xaxis.length) - 1],
                color: "ED5664",
              },
              lineStyle: {
                type: "solid",
                color: "#ED5664",
                width: "1",
                opacity: this.opacity, // 设置为0，使标记线不可见
              },
            },
          ],
        };
      }
      if (this.cpu_usage_normalized_data.length > 0) {
        let xaxis = this.chartDataResult.rows.timeline;
        this.cpu_usage_normalized_data[0].markLine = {
          symbol: ["circle", "arrow"],
          data: [
            {
              silent: true,
              xAxis: Math.round(this.month_new * xaxis.length) - 1,
              label: {
                position: "end",
                show: true,
                formatter: xaxis[Math.round(this.month_new * xaxis.length) - 1],
                color: "ED5664",
              },
              lineStyle: {
                type: "solid",
                color: "#ED5664",
                width: "1",
                opacity: this.opacity, // 设置为0，使标记线不可见
              },
            },
          ],
        };
      }

      if (this.gpu_general_counter_data.length > 0) {
        let xaxis = this.chartDataResult.rows.timeline;
        this.gpu_general_counter_data[0].markLine = {
          symbol: ["circle", "arrow"],
          data: [
            {
              silent: true,
              xAxis: Math.round(this.month_new * xaxis.length) - 1,
              label: {
                position: "end",
                show: true,
                formatter: xaxis[Math.round(this.month_new * xaxis.length) - 1],
                color: "ED5664",
              },
              lineStyle: {
                type: "solid",
                color: "#ED5664",
                width: "1",
                opacity: this.opacity, // 设置为0，使标记线不可见
              },
            },
          ],
        };
      }

      if (this.frametime_line_data.length > 0) {
        let xaxis = this.chartDataFrame.rows.id_frame.map(
          (v, index) => v + "_" + String(index)
        );
        this.frametime_line_data[0].markLine = {
          symbol: ["circle", "arrow"],
          data: [
            {
              silent: true,
              xAxis: Math.round(this.month_new * xaxis.length) - 1,
              label: {
                position: "end",
                show: true,
                formatter: xaxis[
                  Math.round(this.month_new * xaxis.length) - 1
                ]?.split("_")[0],
                color: "ED5664",
              },
              lineStyle: {
                type: "solid",
                color: "#ED5664",
                width: "1",
                opacity: this.opacity, // 设置为0，使标记线不可见
              },
            },
          ],
        };
      }

      if (this.gpu_memory_counter_data.length > 0) {
        let xaxis = this.chartDataResult.rows.timeline;
        this.gpu_memory_counter_data[0].markLine = {
          symbol: ["circle", "arrow"],
          data: [
            {
              silent: true,
              xAxis: Math.round(this.month_new * xaxis.length) - 1,
              label: {
                position: "end",
                show: true,
                formatter: xaxis[Math.round(this.month_new * xaxis.length) - 1],
                color: "ED5664",
              },
              lineStyle: {
                type: "solid",
                color: "#ED5664",
                width: "1",
                opacity: this.opacity, // 设置为0，使标记线不可见
              },
            },
          ],
        };
      }
      if (this.gpu_shader_counter_data.length > 0) {
        let xaxis = this.chartDataResult.rows.timeline;
        this.gpu_shader_counter_data[0].markLine = {
          symbol: ["circle", "arrow"],
          data: [
            {
              silent: true,
              xAxis: Math.round(this.month_new * xaxis.length) - 1,
              label: {
                position: "end",
                show: true,
                formatter: xaxis[Math.round(this.month_new * xaxis.length) - 1],
                color: "ED5664",
              },
              lineStyle: {
                type: "solid",
                color: "#ED5664",
                width: "1",
                opacity: this.opacity, // 设置为0，使标记线不可见
              },
            },
          ],
        };
      }

      if (this.wakeups_data.length > 0) {
        let xaxis = this.chartDataResult.rows.timeline;
        this.wakeups_data[0].markLine = {
          symbol: ["circle", "arrow"],
          data: [
            {
              silent: true,
              xAxis: Math.round(this.month_new * xaxis.length) - 1,
              label: {
                position: "end",
                show: true,
                formatter: xaxis[Math.round(this.month_new * xaxis.length) - 1],
                color: "ED5664",
              },
              lineStyle: {
                type: "solid",
                color: "#ED5664",
                width: "1",
                opacity: this.opacity, // 设置为0，使标记线不可见
              },
            },
          ],
        };
      }

      if (this.memory_detail_data.length > 0) {
        let xaxis = this.chartDataResult.rows.timeline;
        this.memory_detail_data[0].markLine = {
          symbol: ["circle", "arrow"],
          data: [
            {
              silent: true,
              xAxis: Math.round(this.month_new * xaxis.length) - 1,
              label: {
                position: "end",
                show: true,
                formatter: xaxis[Math.round(this.month_new * xaxis.length) - 1],
                color: "ED5664",
              },
              lineStyle: {
                type: "solid",
                color: "#ED5664",
                width: "1",
                opacity: this.opacity, // 设置为0，使标记线不可见
              },
            },
          ],
        };
      }

      if (this.cpu_core_usage_data.length > 0) {
        let xaxis = this.chartDataResult.rows.timeline;
        this.cpu_core_usage_data[0].markLine = {
          symbol: ["circle", "arrow"],
          data: [
            {
              silent: true,
              xAxis: Math.round(this.month_new * xaxis.length) - 1,
              label: {
                position: "end",
                show: true,
                formatter: xaxis[Math.round(this.month_new * xaxis.length) - 1],
                color: "ED5664",
              },
              lineStyle: {
                type: "solid",
                color: "#ED5664",
                width: "1",
                opacity: this.opacity, // 设置为0，使标记线不可见
              },
            },
          ],
        };
      }

      if (this.analyse_data.length > 0) {
        let xaxis = this.cpu_by_frame.abs_times;
        if (xaxis) {
          this.analyse_data[0].markLine = {
            symbol: ["circle", "arrow"],
            data: [
              {
                silent: true,
                xAxis: Math.round(this.month_new * xaxis?.length) - 1,
                label: {
                  position: "end",
                  show: true,
                  formatter:
                    xaxis[Math.round(this.month_new * xaxis.length) - 1],
                  color: "ED5664",
                },
                lineStyle: {
                  type: "solid",
                  color: "#ED5664",
                  width: "1",
                  opacity: this.opacity, // 设置为0，使标记线不可见
                },
              },
            ],
          };
        }
      }
    },
    drawPieChartCPUUsageNormalized() {
      let cpu_usage_line = document.getElementById("thread");
      if (cpu_usage_line.getAttribute("style") === "display:none") {
        cpu_usage_line.setAttribute("style", "width: 100%; height: 400px");
      }

      // 用echarts时，如果存在DOM，就会报存在警告，处理方法删除DOM
      // echarts数据变动时, 数据正常，图标混乱，故以此解决
      echarts.dispose(cpu_usage_line);

      let CPUUsageLineChart = echarts.init(cpu_usage_line);
      let list1 = [];
      list1 = this.pictureArr;

      let file1 = this.file;
      let time = this.chartDataResult.rows.timeline;
      let labelName = this.chartDataResult.rows.label;
      let lableList3 = this.lableList3;
      CPUUsageLineChart.on("datazoom", (params) => {
        // 获取索引
        let start_rate = params.start;
        let end_rate = params.end;

        this.startValue = start_rate;
        this.endValue = end_rate;

        let start = CPUUsageLineChart.getModel().option.dataZoom[0].startValue;
        let end = CPUUsageLineChart.getModel().option.dataZoom[0].endValue;

        let arr = time.filter((v, i) => {
          if (start === time.length) {
            return i >= start - 1 && i < end;
          } else {
            return i >= start && i <= end;
          }
        });

        let newLabelName = labelName.flat().filter((v, i) => {
          if (start === time.length) {
            return i >= start - 1 && i < end;
          } else {
            return i >= start && i <= end;
          }
        });

        // 获取新的lable
        var newArr = [],
          tempArr = [];
        for (var i = 0, j = newLabelName.length; i < j; i++) {
          if (newLabelName[i] == newLabelName[i + 1]) {
            tempArr.push(newLabelName[i]);
          } else {
            tempArr.push(newLabelName[i]);
            newArr.push(tempArr.slice(0));
            tempArr.length = 0;
          }
        }

        let labelWidthAll1 = [];
        let c = newArr.flat();
        let n = Array.from(new Set(c));
        let arr3 = [];

        lableList3.forEach(function (v) {
          n.forEach(function (j) {
            if (v.id_label == j) {
              arr3.push(v);
            }
          });
        });

        newArr.forEach(function (v) {
          labelWidthAll1.push((v.length / arr.length) * 100 + "%");
        });

        arr3.forEach(function (v, i) {
          labelWidthAll1.forEach(function (j, index) {
            if (i == index) {
              v.width = j;
            }
          });
        });

        this.lableList = arr3;
        this.chartSettings.dataZoom[0].start = start_rate;
        this.chartSettings.dataZoom[0].end = end_rate;
        //  this.drawPieChartCPUUsage();
        this.drawPieChartFPS();
        this.drawPieChartFrameTime();
        this.drawPieChartCPUCoreUsage();
        this.drawPieChartCPUUsage();

        this.drawPieChartMemoryDetail();

        this.drawPieChartGPUGeneralCounter();
        // this.drawPieChartGPUMemoryCounter();
        this.drawPieChartGPUShaderCounter();
        this.drawPieChartWakeups();
        // this.drawPieChartCPUUsageNormalized();
      });
      CPUUsageLineChart.getZr().on("click", async (params) => {
        var pointInPixel = [params.offsetX, params.offsetY];
        if (CPUUsageLineChart.containPixel("grid", pointInPixel)) {
          /*此处添加具体执行代码*/

          var pointInGrid = CPUUsageLineChart.convertFromPixel(
            { seriesIndex: 0 },
            pointInPixel
          );
          //X轴序号
          var xIndex = pointInGrid[0];

          //获取当前图表的option
          var op = CPUUsageLineChart.getOption();

          //获得图表中我们想要的数据
          var month = op.xAxis[0].data[xIndex];
          var value = op.series[0].data[xIndex];
          let xaxis = this.chartDataResult.rows.timeline;
          xIndex = (xIndex + 1) / xaxis.length;
          this.month_new = xIndex;
          this.opacity = 1;
          this.chartSettings.dataZoom[0].start = op.dataZoom[0].start;
          this.chartSettings.dataZoom[0].end = op.dataZoom[0].end;
          await this.drawAll();
          this.drawPieChartFPS();
          this.drawPieChartFrameTime();
          this.drawPieChartCPUCoreUsage();
          this.drawPieChartCPUUsage();

          this.drawPieChartMemoryDetail();

          this.drawPieChartGPUGeneralCounter();
          // this.drawPieChartGPUMemoryCounter();
          this.drawPieChartGPUShaderCounter();
          this.drawPieChartWakeups();
          this.drawPieChartCPUUsageNormalized();
        }
        let boxWidth = document.getElementById(this.pictureArr[0].time)
          .offsetWidth;

        // 获取居中平移距离
        let ofwidth = document.getElementById("cs").offsetLeft + boxWidth;

        // 将每一次平移居中位置放置每一个对象中
        this.pictureArr.forEach(function (v) {
          v.ofwidth = ofwidth -= boxWidth + 10;
          //
          //
        });
        let x = month;

        let pictureObj = this.pictureArr.filter(function (v) {
          return v.time === x;
        });

        if (pictureObj.length > 0) {
          file1 = pictureObj[0].ofwidth + "px";
          document.getElementById(
            "scro"
          ).style.transform = `translateX(${file1})`;
          document.getElementById(pictureObj[0].time).firstChild.style.outline =
            "6px solid #4271fb";
          let po = this.sibling1(document.getElementById(pictureObj[0].time));
          //     var siblings = sibling(document.getElementById(pictureObj[0].time));
          po.forEach(function (v) {
            //
            v.firstChild.style.outline = 0;
          });
        } else {
          let pic = this.pictureArr.filter(
            (v) => v.time === this.subtractTwoSeconds(x)
          )[0];
          file1 = pic.ofwidth + "px";
          document.getElementById(
            "scro"
          ).style.transform = `translateX(${file1})`;
          document.getElementById(pic.time).firstChild.style.outline =
            "6px solid #4271fb";
          let po = this.sibling1(document.getElementById(pic.time));
          //     var siblings = sibling(document.getElementById(pictureObj[0].time));
          po.forEach(function (v) {
            //
            v.firstChild.style.outline = 0;
          });
        }
      });
      let option;

      option = {
        title: {
          text: "Thread",
          textStyle: {
            fontSize: 16,
            fontWeight: 700,
            color: "#333",
          },
        },
        dataZoom: this.chartSettings.dataZoom,
        toolbox: this.chartSettings.toolbox,
        tooltip: this.chartSettings.tooltip,
        legend: this.chartSettings.legend,
        grid: this.chartSettings.grid,
        yAxis: this.chartSettings.yAxis,
        xAxis: {
          type: "category",
          boundaryGap: false,
          data: this.chartDataResult.rows.timeline,
        },
        series: this.cpu_usage_normalized_data,
      };
      CPUUsageLineChart.setOption(option);
      this.judgNull(option.series, cpu_usage_line);
      // if (
      //   document.getElementById("cpu_usage_line").getAttribute("style") ===
      //     "display:none" &&
      //   document.getElementById("cpu_freq_line").getAttribute("style") ===
      //     "display:none"
      // ) {
      //   document
      //     .getElementById("cpu_usage_line")
      //     .parentNode.parentNode.setAttribute("style", "display:none");
      // }
      return CPUUsageLineChart;
    },
    drawPieChartCPUFreq() {
      let cpu_freq_line = document.getElementById("cpu_freq_line");
      if (cpu_freq_line.getAttribute("style") === "display:none") {
        cpu_freq_line.setAttribute("style", "width: 100%; height: 400px");
      }

      // 用echarts时，如果存在DOM，就会报存在警告，处理方法删除DOM
      // echarts数据变动时, 数据正常，图标混乱，故以此解决
      echarts.dispose(cpu_freq_line);

      let CPUFreqLineChart = echarts.init(cpu_freq_line);
      let list1 = [];
      list1 = this.pictureArr;

      let file1 = this.file;
      let time = this.chartDataResult.rows.timeline;
      let labelName = this.chartDataResult.rows.label;
      let lableList3 = this.lableList3;
      CPUFreqLineChart.on("datazoom", (params) => {
        // 获取索引
        let start_rate = params.start;
        let end_rate = params.end;

        this.startValue = start_rate;
        this.endValue = end_rate;
        let start = CPUFreqLineChart.getModel().option.dataZoom[0].startValue;
        let end = CPUFreqLineChart.getModel().option.dataZoom[0].endValue;
        let arr = time.filter((v, i) => {
          if (start === time.length) {
            return i >= start - 1 && i < end;
          } else {
            return i >= start && i <= end;
          }
        });

        let newLabelName = labelName.flat().filter((v, i) => {
          if (start === time.length) {
            return i >= start - 1 && i < end;
          } else {
            return i >= start && i <= end;
          }
        });

        // 获取新的lable
        var newArr = [],
          tempArr = [];
        for (var i = 0, j = newLabelName.length; i < j; i++) {
          if (newLabelName[i] == newLabelName[i + 1]) {
            tempArr.push(newLabelName[i]);
          } else {
            tempArr.push(newLabelName[i]);
            newArr.push(tempArr.slice(0));
            tempArr.length = 0;
          }
        }

        let labelWidthAll1 = [];
        let c = newArr.flat();
        let n = Array.from(new Set(c));
        let arr3 = [];

        lableList3.forEach(function (v) {
          n.forEach(function (j) {
            if (v.id_label == j) {
              arr3.push(v);
            }
          });
        });

        newArr.forEach(function (v) {
          labelWidthAll1.push((v.length / arr.length) * 100 + "%");
        });

        arr3.forEach(function (v, i) {
          labelWidthAll1.forEach(function (j, index) {
            if (i == index) {
              v.width = j;
            }
          });
        });

        this.lableList = arr3;
        this.chartSettings.dataZoom[0].start = start_rate;
        this.chartSettings.dataZoom[0].end = end_rate;
        //  this.drawPieChartCPUUsage();
        this.drawPieChartFPS();
        this.drawPieChartFrameTime();
        this.drawPieChartCPUUsage();
        // this.drawPieChartCPUFreq();
        this.drawPieChartPSS();
        this.drawPieChartMemoryDetail();
        this.drawPieChartGPUGeneralCounter();
        this.drawPieChartGPUMemoryCounter();
        this.drawPieChartGPUShaderCounter();
        this.drawPieChartFlow();
        if (this.testInfo0.device.toUpperCase().indexOf("IPHONE") != -1) {
          this.drawPieChartCsWitch();
          this.drawPieChartWakeups();
        }

        if (this.chartDatacustom?.rows?.i?.length !== 0) {
          this.drawPieChartMonomem();
          this.drawPieChartVerts();
          this.drawPieChartTris();
          this.drawPieChartDc();
          this.drawPieChartGc();
        }

        //
        if (this.chartDataMonoMem?.rows?.timeline?.length !== 0) {
          this.drawPieChartMono();
        }
        if (this.chartDataDrawCall?.rows?.timeline?.length !== 0) {
          this.drawPieChartDrawCall();
        }
        if (this.chartDataTriangle?.rows?.timeline?.length !== 0) {
          this.drawPieChartTriangle();
        }
        if (this.chartDataTemp?.rows?.timeline?.length !== 0) {
          this.drawPieChartTemp();
        }
        if (this.chartDataElectric?.rows?.timeline?.length !== 0) {
          this.drawPieChartElectric();
        }

        this.getPictureData();
        this.drawAnalyseTrend();
        this.drawPieChartCPUUsageNormalized();
        this.drawPieChartCPUCoreUsage();
        this.drawPieChartCPUClock();
      });
      CPUFreqLineChart.getZr().on("click", async (params) => {
        var pointInPixel = [params.offsetX, params.offsetY];
        if (CPUFreqLineChart.containPixel("grid", pointInPixel)) {
          /*此处添加具体执行代码*/

          var pointInGrid = CPUFreqLineChart.convertFromPixel(
            { seriesIndex: 0 },
            pointInPixel
          );
          //X轴序号
          var xIndex = pointInGrid[0];

          //获取当前图表的option
          var op = CPUFreqLineChart.getOption();

          //获得图表中我们想要的数据
          var month = op.xAxis[0].data[xIndex];
          var value = op.series[0].data[xIndex];
          let xaxis = this.chartDataResult.rows.timeline;
          xIndex = (xIndex + 1) / xaxis.length;
          this.month_new = xIndex;
          this.opacity = 1;
          this.chartSettings.dataZoom[0].start = op.dataZoom[0].start;
          this.chartSettings.dataZoom[0].end = op.dataZoom[0].end;
          await this.drawAll();
          this.drawPieChartFPS();
          this.drawPieChartFrameTime();
          this.drawPieChartCPUUsage();
          this.drawPieChartCPUFreq();
          this.drawPieChartPSS();
          this.drawPieChartMemoryDetail();
          this.drawPieChartGPUGeneralCounter();
          this.drawPieChartGPUMemoryCounter();
          this.drawPieChartGPUShaderCounter();
          this.drawPieChartFlow();
          if (this.testInfo0.device.toUpperCase().indexOf("IPHONE") != -1) {
            this.drawPieChartCsWitch();
            this.drawPieChartWakeups();
          }

          if (this.chartDatacustom?.rows?.i?.length !== 0) {
            this.drawPieChartMonomem();
            this.drawPieChartVerts();
            this.drawPieChartTris();
            this.drawPieChartDc();
            this.drawPieChartGc();
          }

          //
          if (this.chartDataMonoMem?.rows?.timeline?.length !== 0) {
            this.drawPieChartMono();
          }
          if (this.chartDataDrawCall?.rows?.timeline?.length !== 0) {
            this.drawPieChartDrawCall();
          }
          if (this.chartDataTriangle?.rows?.timeline?.length !== 0) {
            this.drawPieChartTriangle();
          }
          if (this.chartDataTemp?.rows?.timeline?.length !== 0) {
            this.drawPieChartTemp();
          }
          if (this.chartDataElectric?.rows?.timeline?.length !== 0) {
            this.drawPieChartElectric();
          }

          this.getPictureData();
          this.drawAnalyseTrend();
          this.drawPieChartCPUUsageNormalized();
          this.drawPieChartCPUCoreUsage();
          this.drawPieChartCPUClock();
        }
        let boxWidth = document.getElementById(this.pictureArr[0].time)
          .offsetWidth;

        // 获取居中平移距离
        let ofwidth = document.getElementById("cs").offsetLeft + boxWidth;

        // 将每一次平移居中位置放置每一个对象中
        this.pictureArr.forEach(function (v) {
          v.ofwidth = ofwidth -= boxWidth + 10;
          //
          //
        });
        let x = month;
        let pictureObj = this.pictureArr.filter(function (v) {
          return v.time === x;
        });

        if (pictureObj.length > 0) {
          file1 = pictureObj[0].ofwidth + "px";
          document.getElementById(
            "scro"
          ).style.transform = `translateX(${file1})`;
          document.getElementById(pictureObj[0].time).firstChild.style.outline =
            "6px solid #4271fb";
          let po = this.sibling1(document.getElementById(pictureObj[0].time));
          //     var siblings = sibling(document.getElementById(pictureObj[0].time));
          po.forEach(function (v) {
            //
            v.firstChild.style.outline = 0;
          });
        } else {
          let pic = this.pictureArr.filter(
            (v) => v.time === this.subtractTwoSeconds(x)
          )[0];
          file1 = pic.ofwidth + "px";
          document.getElementById(
            "scro"
          ).style.transform = `translateX(${file1})`;
          document.getElementById(pic.time).firstChild.style.outline =
            "6px solid #4271fb";
          let po = this.sibling1(document.getElementById(pic.time));
          //     var siblings = sibling(document.getElementById(pictureObj[0].time));
          po.forEach(function (v) {
            //
            v.firstChild.style.outline = 0;
          });
        }
      });
      let option;

      option = {
        title: {
          text: "CPU Core USage(Normalized)",
          textStyle: {
            fontSize: 16,
            fontWeight: 700,
            color: "#333",
          },
        },
        dataZoom: this.chartSettings.dataZoom,
        toolbox: this.chartSettings.toolbox,
        tooltip: this.chartSettings.tooltip,
        legend: this.chartSettings.legend,
        grid: this.chartSettings.grid,
        yAxis: this.chartSettings.yAxis,
        xAxis: {
          type: "category",
          boundaryGap: false,
          data: this.chartDataResult.rows.timeline,
        },
        series: this.cpu_freq_line_data,
      };
      CPUFreqLineChart.setOption(option);
      this.judgNull(option.series, cpu_freq_line);
      // if (
      //   document.getElementById("cpu_usage_line").getAttribute("style") ===
      //     "display:none" &&
      //   document.getElementById("cpu_freq_line").getAttribute("style") ===
      //     "display:none"
      // ) {
      //   document
      //     .getElementById("cpu_usage_line")
      //     .parentNode.parentNode.setAttribute("style", "display:none");
      // }
      return CPUFreqLineChart;
    },
    drawPieChartCPUCoreUsage() {
      let cpu_freq_line = document.getElementById("cpu_core_usage");
      if (cpu_freq_line.getAttribute("style") === "display:none") {
        cpu_freq_line.setAttribute("style", "width: 100%; height: 400px");
      }

      // 用echarts时，如果存在DOM，就会报存在警告，处理方法删除DOM
      // echarts数据变动时, 数据正常，图标混乱，故以此解决
      echarts.dispose(cpu_freq_line);

      let CPUFreqLineChart = echarts.init(cpu_freq_line);
      let list1 = [];
      list1 = this.pictureArr;

      let file1 = this.file;
      let time = this.chartDataResult.rows.timeline;
      let labelName = this.chartDataResult.rows.label;
      let lableList3 = this.lableList3;
      CPUFreqLineChart.on("datazoom", (params) => {
        // 获取索引
        let start_rate = params.start;
        let end_rate = params.end;

        this.startValue = start_rate;
        this.endValue = end_rate;

        let start = CPUFreqLineChart.getModel().option.dataZoom[0].startValue;
        let end = CPUFreqLineChart.getModel().option.dataZoom[0].endValue;

        let arr = time.filter((v, i) => {
          if (start === time.length) {
            return i >= start - 1 && i < end;
          } else {
            return i >= start && i <= end;
          }
        });

        let newLabelName = labelName.flat().filter((v, i) => {
          if (start === time.length) {
            return i >= start - 1 && i < end;
          } else {
            return i >= start && i <= end;
          }
        });

        // 获取新的lable
        var newArr = [],
          tempArr = [];
        for (var i = 0, j = newLabelName.length; i < j; i++) {
          if (newLabelName[i] == newLabelName[i + 1]) {
            tempArr.push(newLabelName[i]);
          } else {
            tempArr.push(newLabelName[i]);
            newArr.push(tempArr.slice(0));
            tempArr.length = 0;
          }
        }

        let labelWidthAll1 = [];
        let c = newArr.flat();
        let n = Array.from(new Set(c));
        let arr3 = [];

        lableList3.forEach(function (v) {
          n.forEach(function (j) {
            if (v.id_label == j) {
              arr3.push(v);
            }
          });
        });

        newArr.forEach(function (v) {
          labelWidthAll1.push((v.length / arr.length) * 100 + "%");
        });

        arr3.forEach(function (v, i) {
          labelWidthAll1.forEach(function (j, index) {
            if (i == index) {
              v.width = j;
            }
          });
        });

        this.lableList = arr3;
        this.chartSettings.dataZoom[0].start = start_rate;
        this.chartSettings.dataZoom[0].end = end_rate;
        //  this.drawPieChartCPUUsage();
        this.drawPieChartFPS();
        this.drawPieChartFrameTime();
        // this.drawPieChartCPUCoreUsage();
        this.drawPieChartCPUUsage();

        this.drawPieChartMemoryDetail();

        this.drawPieChartGPUGeneralCounter();
        // this.drawPieChartGPUMemoryCounter();
        this.drawPieChartGPUShaderCounter();
        this.drawPieChartWakeups();
        this.drawPieChartCPUUsageNormalized();
      });
      CPUFreqLineChart.getZr().on("click", async (params) => {
        var pointInPixel = [params.offsetX, params.offsetY];
        if (CPUFreqLineChart.containPixel("grid", pointInPixel)) {
          /*此处添加具体执行代码*/

          var pointInGrid = CPUFreqLineChart.convertFromPixel(
            { seriesIndex: 0 },
            pointInPixel
          );
          //X轴序号
          var xIndex = pointInGrid[0];

          //获取当前图表的option
          var op = CPUFreqLineChart.getOption();

          //获得图表中我们想要的数据
          var month = op.xAxis[0].data[xIndex];
          var value = op.series[0].data[xIndex];
          let xaxis = this.chartDataResult.rows.timeline;
          xIndex = (xIndex + 1) / xaxis.length;
          this.month_new = xIndex;
          this.opacity = 1;
          this.chartSettings.dataZoom[0].start = op.dataZoom[0].start;
          this.chartSettings.dataZoom[0].end = op.dataZoom[0].end;
          await this.drawAll();
          this.drawPieChartFPS();
          this.drawPieChartFrameTime();
          this.drawPieChartCPUCoreUsage();
          this.drawPieChartCPUUsage();

          this.drawPieChartMemoryDetail();

          this.drawPieChartGPUGeneralCounter();
          // this.drawPieChartGPUMemoryCounter();
          this.drawPieChartGPUShaderCounter();
          this.drawPieChartWakeups();
          this.drawPieChartCPUUsageNormalized();
        }
        let boxWidth = document.getElementById(this.pictureArr[0].time)
          .offsetWidth;

        // 获取居中平移距离
        let ofwidth = document.getElementById("cs").offsetLeft + boxWidth;

        // 将每一次平移居中位置放置每一个对象中
        this.pictureArr.forEach(function (v) {
          v.ofwidth = ofwidth -= boxWidth + 10;
          //
          //
        });
        let x = month;
        let pictureObj = this.pictureArr.filter(function (v) {
          return v.time === x;
        });

        if (pictureObj.length > 0) {
          file1 = pictureObj[0].ofwidth + "px";
          document.getElementById(
            "scro"
          ).style.transform = `translateX(${file1})`;
          document.getElementById(pictureObj[0].time).firstChild.style.outline =
            "6px solid #4271fb";
          let po = this.sibling1(document.getElementById(pictureObj[0].time));
          //     var siblings = sibling(document.getElementById(pictureObj[0].time));
          po.forEach(function (v) {
            //
            v.firstChild.style.outline = 0;
          });
        } else {
          let pic = this.pictureArr.filter(
            (v) => v.time === this.subtractTwoSeconds(x)
          )[0];
          file1 = pic.ofwidth + "px";
          document.getElementById(
            "scro"
          ).style.transform = `translateX(${file1})`;
          document.getElementById(pic.time).firstChild.style.outline =
            "6px solid #4271fb";
          let po = this.sibling1(document.getElementById(pic.time));
          //     var siblings = sibling(document.getElementById(pictureObj[0].time));
          po.forEach(function (v) {
            //
            v.firstChild.style.outline = 0;
          });
        }
      });
      let option;

      option = {
        title: {
          text: "CPU USage",
          textStyle: {
            fontSize: 16,
            fontWeight: 700,
            color: "#333",
          },
        },
        dataZoom: this.chartSettings.dataZoom,
        toolbox: this.chartSettings.toolbox,
        tooltip: this.chartSettings.tooltip,
        legend: this.chartSettings.legend,
        grid: this.chartSettings.grid,
        yAxis: this.chartSettings.yAxis,
        xAxis: {
          type: "category",
          boundaryGap: false,
          data: this.chartDataResult.rows.timeline,
        },
        series: this.cpu_core_usage_data,
      };
      CPUFreqLineChart.setOption(option);
      this.judgNull(option.series, cpu_freq_line);
      // if (
      //   document.getElementById("cpu_usage_line").getAttribute("style") ===
      //     "display:none" &&
      //   document.getElementById("cpu_freq_line").getAttribute("style") ===
      //     "display:none"
      // ) {
      //   document
      //     .getElementById("cpu_usage_line")
      //     .parentNode.parentNode.setAttribute("style", "display:none");
      // }
      return CPUFreqLineChart;
    },
    drawPieChartCPUClock() {
      let cpu_freq_line = document.getElementById("cpu_clock");

      if (cpu_freq_line.getAttribute("style") === "display:none") {
        cpu_freq_line.setAttribute("style", "width: 100%; height: 400px");
      }

      // 用echarts时，如果存在DOM，就会报存在警告，处理方法删除DOM
      // echarts数据变动时, 数据正常，图标混乱，故以此解决
      echarts.dispose(cpu_freq_line);

      let CPUFreqLineChart = echarts.init(cpu_freq_line);
      let list1 = [];
      list1 = this.pictureArr;

      let file1 = this.file;
      let time = this.chartDataResult.rows.timeline;
      let labelName = this.chartDataResult.rows.label;
      let lableList3 = this.lableList3;
      CPUFreqLineChart.on("datazoom", (params) => {
        // 获取索引
        let start_rate = params.start;
        let end_rate = params.end;

        this.startValue = start_rate;
        this.endValue = end_rate;

        let start = CPUFreqLineChart.getModel().option.dataZoom[0].startValue;
        let end = CPUFreqLineChart.getModel().option.dataZoom[0].endValue;

        let arr = time.filter((v, i) => {
          if (start === time.length) {
            return i >= start - 1 && i < end;
          } else {
            return i >= start && i <= end;
          }
        });

        let newLabelName = labelName.flat().filter((v, i) => {
          if (start === time.length) {
            return i >= start - 1 && i < end;
          } else {
            return i >= start && i <= end;
          }
        });

        // 获取新的lable
        var newArr = [],
          tempArr = [];
        for (var i = 0, j = newLabelName.length; i < j; i++) {
          if (newLabelName[i] == newLabelName[i + 1]) {
            tempArr.push(newLabelName[i]);
          } else {
            tempArr.push(newLabelName[i]);
            newArr.push(tempArr.slice(0));
            tempArr.length = 0;
          }
        }

        let labelWidthAll1 = [];
        let c = newArr.flat();
        let n = Array.from(new Set(c));
        let arr3 = [];

        lableList3.forEach(function (v) {
          n.forEach(function (j) {
            if (v.id_label == j) {
              arr3.push(v);
            }
          });
        });

        newArr.forEach(function (v) {
          labelWidthAll1.push((v.length / arr.length) * 100 + "%");
        });

        arr3.forEach(function (v, i) {
          labelWidthAll1.forEach(function (j, index) {
            if (i == index) {
              v.width = j;
            }
          });
        });

        this.lableList = arr3;
        this.chartSettings.dataZoom[0].start = start_rate;
        this.chartSettings.dataZoom[0].end = end_rate;
        //  this.drawPieChartCPUUsage();
        this.drawPieChartFPS();
        this.drawPieChartFrameTime();
        this.drawPieChartCPUUsage();
        this.drawPieChartCPUFreq();
        this.drawPieChartPSS();
        this.drawPieChartMemoryDetail();
        this.drawPieChartGPUGeneralCounter();
        this.drawPieChartGPUMemoryCounter();
        this.drawPieChartGPUShaderCounter();
        this.drawPieChartFlow();
        if (this.testInfo0.device.toUpperCase().indexOf("IPHONE") != -1) {
          this.drawPieChartCsWitch();
          this.drawPieChartWakeups();
        }

        if (this.chartDatacustom?.rows?.i?.length !== 0) {
          this.drawPieChartMonomem();
          this.drawPieChartVerts();
          this.drawPieChartTris();
          this.drawPieChartDc();
          this.drawPieChartGc();
        }

        //
        if (this.chartDataMonoMem?.rows?.timeline?.length !== 0) {
          this.drawPieChartMono();
        }
        if (this.chartDataDrawCall?.rows?.timeline?.length !== 0) {
          this.drawPieChartDrawCall();
        }
        if (this.chartDataTriangle?.rows?.timeline?.length !== 0) {
          this.drawPieChartTriangle();
        }
        if (this.chartDataTemp?.rows?.timeline?.length !== 0) {
          this.drawPieChartTemp();
        }
        if (this.chartDataElectric?.rows?.timeline?.length !== 0) {
          this.drawPieChartElectric();
        }

        this.getPictureData();
        this.drawAnalyseTrend();
        this.drawPieChartCPUUsageNormalized();
        this.drawPieChartCPUCoreUsage();
        // this.drawPieChartCPUClock();
      });
      CPUFreqLineChart.getZr().on("click", async (params) => {
        var pointInPixel = [params.offsetX, params.offsetY];
        if (CPUFreqLineChart.containPixel("grid", pointInPixel)) {
          /*此处添加具体执行代码*/

          var pointInGrid = CPUFreqLineChart.convertFromPixel(
            { seriesIndex: 0 },
            pointInPixel
          );
          //X轴序号
          var xIndex = pointInGrid[0];

          //获取当前图表的option
          var op = CPUFreqLineChart.getOption();

          //获得图表中我们想要的数据
          var month = op.xAxis[0].data[xIndex];
          var value = op.series[0].data[xIndex];
          let xaxis = this.chartDataResult.rows.timeline;
          xIndex = (xIndex + 1) / xaxis.length;
          this.month_new = xIndex;
          this.opacity = 1;
          this.chartSettings.dataZoom[0].start = op.dataZoom[0].start;
          this.chartSettings.dataZoom[0].end = op.dataZoom[0].end;
          await this.drawAll();
          this.drawPieChartFPS();
          this.drawPieChartFrameTime();
          this.drawPieChartCPUUsage();
          this.drawPieChartCPUFreq();
          this.drawPieChartPSS();
          this.drawPieChartMemoryDetail();
          this.drawPieChartGPUGeneralCounter();
          this.drawPieChartGPUMemoryCounter();
          this.drawPieChartGPUShaderCounter();
          this.drawPieChartFlow();
          if (this.testInfo0.device.toUpperCase().indexOf("IPHONE") != -1) {
            this.drawPieChartCsWitch();
            this.drawPieChartWakeups();
          }

          if (this.chartDatacustom?.rows?.i?.length !== 0) {
            this.drawPieChartMonomem();
            this.drawPieChartVerts();
            this.drawPieChartTris();
            this.drawPieChartDc();
            this.drawPieChartGc();
          }

          //
          if (this.chartDataMonoMem?.rows?.timeline?.length !== 0) {
            this.drawPieChartMono();
          }
          if (this.chartDataDrawCall?.rows?.timeline?.length !== 0) {
            this.drawPieChartDrawCall();
          }
          if (this.chartDataTriangle?.rows?.timeline?.length !== 0) {
            this.drawPieChartTriangle();
          }
          if (this.chartDataTemp?.rows?.timeline?.length !== 0) {
            this.drawPieChartTemp();
          }
          if (this.chartDataElectric?.rows?.timeline?.length !== 0) {
            this.drawPieChartElectric();
          }

          this.getPictureData();
          this.drawAnalyseTrend();
          this.drawPieChartCPUUsageNormalized();
          this.drawPieChartCPUCoreUsage();
          this.drawPieChartCPUClock();
        }
        let boxWidth = document.getElementById(this.pictureArr[0].time)
          .offsetWidth;

        // 获取居中平移距离
        let ofwidth = document.getElementById("cs").offsetLeft + boxWidth;

        // 将每一次平移居中位置放置每一个对象中
        this.pictureArr.forEach(function (v) {
          v.ofwidth = ofwidth -= boxWidth + 10;
          //
          //
        });
        let x = month;
        let pictureObj = this.pictureArr.filter(function (v) {
          return v.time === x;
        });

        if (pictureObj.length > 0) {
          file1 = pictureObj[0].ofwidth + "px";
          document.getElementById(
            "scro"
          ).style.transform = `translateX(${file1})`;
          document.getElementById(pictureObj[0].time).firstChild.style.outline =
            "6px solid #4271fb";
          let po = this.sibling1(document.getElementById(pictureObj[0].time));
          //     var siblings = sibling(document.getElementById(pictureObj[0].time));
          po.forEach(function (v) {
            //
            v.firstChild.style.outline = 0;
          });
        } else {
          let pic = this.pictureArr.filter(
            (v) => v.time === this.subtractTwoSeconds(x)
          )[0];
          file1 = pic.ofwidth + "px";
          document.getElementById(
            "scro"
          ).style.transform = `translateX(${file1})`;
          document.getElementById(pic.time).firstChild.style.outline =
            "6px solid #4271fb";
          let po = this.sibling1(document.getElementById(pic.time));
          //     var siblings = sibling(document.getElementById(pictureObj[0].time));
          po.forEach(function (v) {
            //
            v.firstChild.style.outline = 0;
          });
        }
      });
      let option;

      option = {
        title: {
          text: "CPU Clock",
          textStyle: {
            fontSize: 16,
            fontWeight: 700,
            color: "#333",
          },
        },
        dataZoom: this.chartSettings.dataZoom,
        toolbox: this.chartSettings.toolbox,
        tooltip: this.chartSettings.tooltip,
        legend: this.chartSettings.legend,
        grid: this.chartSettings.grid,
        yAxis: this.chartSettings.yAxis,
        xAxis: {
          type: "category",
          boundaryGap: false,
          data: this.chartDataResult.rows.timeline,
        },
        series: this.cpu_clock_data,
      };
      CPUFreqLineChart.setOption(option);
      this.judgNull(option.series, cpu_freq_line);
      // if (
      //   document.getElementById("cpu_usage_line").getAttribute("style") ===
      //     "display:none" &&
      //   document.getElementById("cpu_freq_line").getAttribute("style") ===
      //     "display:none"
      // ) {
      //   document
      //     .getElementById("cpu_usage_line")
      //     .parentNode.parentNode.setAttribute("style", "display:none");
      // }
      return CPUFreqLineChart;
    },
    getChangeFPS() {
      this.ChangeFPS.lteFPS =
        readChangeFPSlte(store).fps == "" ? "-" : readChangeFPSlte(store).fps;
      this.ChangeFPS.gteFPS =
        readChangeFPSgte(store).fps == "" ? "-" : readChangeFPSgte(store).fps;
    },
    drawPieChartPSS() {
      let pss_line = document.getElementById("pss_line");
      if (pss_line.getAttribute("style") === "display:none") {
        pss_line.setAttribute("style", "width: 100%; height: 400px");
      }

      // 用echarts时，如果存在DOM，就会报存在警告，处理方法删除DOM
      // echarts数据变动时, 数据正常，图标混乱，故以此解决
      echarts.dispose(pss_line);

      let PSSLineChart = echarts.init(pss_line);
      let option;
      let list1 = [];
      list1 = this.pictureArr;

      let file1 = this.file;
      let time = this.chartDataResult.rows.timeline;
      let labelName = this.chartDataResult.rows.label;
      let lableList3 = this.lableList3;
      PSSLineChart.on("datazoom", (params) => {
        // 获取索引
        let start_rate = params.start;
        let end_rate = params.end;

        this.startValue = start_rate;
        this.endValue = end_rate;

        let start = PSSLineChart.getModel().option.dataZoom[0].startValue;
        let end = PSSLineChart.getModel().option.dataZoom[0].endValue;

        let arr = time.filter((v, i) => {
          if (start === time.length) {
            return i >= start - 1 && i < end;
          } else {
            return i >= start && i <= end;
          }
        });

        let newLabelName = labelName.flat().filter((v, i) => {
          if (start === time.length) {
            return i >= start - 1 && i < end;
          } else {
            return i >= start && i <= end;
          }
        });

        // 获取新的lable
        var newArr = [],
          tempArr = [];
        for (var i = 0, j = newLabelName.length; i < j; i++) {
          if (newLabelName[i] == newLabelName[i + 1]) {
            tempArr.push(newLabelName[i]);
          } else {
            tempArr.push(newLabelName[i]);
            newArr.push(tempArr.slice(0));
            tempArr.length = 0;
          }
        }

        let labelWidthAll1 = [];
        let c = newArr.flat();
        let n = Array.from(new Set(c));
        let arr3 = [];

        lableList3.forEach(function (v) {
          n.forEach(function (j) {
            if (v.id_label == j) {
              arr3.push(v);
            }
          });
        });

        newArr.forEach(function (v) {
          labelWidthAll1.push((v.length / arr.length) * 100 + "%");
        });

        arr3.forEach(function (v, i) {
          labelWidthAll1.forEach(function (j, index) {
            if (i == index) {
              v.width = j;
            }
          });
        });

        this.lableList = arr3;
        this.chartSettings.dataZoom[0].start = start_rate;
        this.chartSettings.dataZoom[0].end = end_rate;

        this.drawPieChartFPS();
        this.drawPieChartFrameTime();
        this.drawPieChartCPUUsage();
        this.drawPieChartCPUFreq();
        // this.drawPieChartPSS();
        this.drawPieChartMemoryDetail();
        this.drawPieChartGPUGeneralCounter();
        this.drawPieChartGPUMemoryCounter();
        this.drawPieChartGPUShaderCounter();
        this.drawPieChartFlow();
        if (this.testInfo0.device.toUpperCase().indexOf("IPHONE") != -1) {
          this.drawPieChartCsWitch();
          this.drawPieChartWakeups();
        }

        if (this.chartDatacustom?.rows?.i?.length !== 0) {
          this.drawPieChartMonomem();
          this.drawPieChartVerts();
          this.drawPieChartTris();
          this.drawPieChartDc();
          this.drawPieChartGc();
        }

        //
        if (this.chartDataMonoMem?.rows?.timeline?.length !== 0) {
          this.drawPieChartMono();
        }
        if (this.chartDataDrawCall?.rows?.timeline?.length !== 0) {
          this.drawPieChartDrawCall();
        }
        if (this.chartDataTriangle?.rows?.timeline?.length !== 0) {
          this.drawPieChartTriangle();
        }
        if (this.chartDataTemp?.rows?.timeline?.length !== 0) {
          this.drawPieChartTemp();
        }
        if (this.chartDataElectric?.rows?.timeline?.length !== 0) {
          this.drawPieChartElectric();
        }

        this.getPictureData();
        this.drawAnalyseTrend();
        this.drawPieChartCPUUsageNormalized();
        this.drawPieChartCPUCoreUsage();
        this.drawPieChartCPUClock();
      });
      PSSLineChart.getZr().on("click", async (params) => {
        var pointInPixel = [params.offsetX, params.offsetY];
        if (PSSLineChart.containPixel("grid", pointInPixel)) {
          /*此处添加具体执行代码*/

          var pointInGrid = PSSLineChart.convertFromPixel(
            { seriesIndex: 0 },
            pointInPixel
          );
          //X轴序号
          var xIndex = pointInGrid[0];

          //获取当前图表的option
          var op = PSSLineChart.getOption();

          //获得图表中我们想要的数据
          var month = op.xAxis[0].data[xIndex];
          var value = op.series[0].data[xIndex];
          let xaxis = this.chartDataResult.rows.timeline;
          xIndex = (xIndex + 1) / xaxis.length;
          this.month_new = xIndex;

          this.opacity = 1;
          this.chartSettings.dataZoom[0].start = op.dataZoom[0].start;
          this.chartSettings.dataZoom[0].end = op.dataZoom[0].end;
          await this.drawAll();
          this.drawPieChartFPS();
          this.drawPieChartFrameTime();
          this.drawPieChartCPUUsage();
          this.drawPieChartCPUFreq();
          this.drawPieChartPSS();
          this.drawPieChartMemoryDetail();
          this.drawPieChartGPUGeneralCounter();
          this.drawPieChartGPUMemoryCounter();
          this.drawPieChartGPUShaderCounter();

          this.drawPieChartFlow();
          if (this.testInfo0.device.toUpperCase().indexOf("IPHONE") != -1) {
            this.drawPieChartCsWitch();
            this.drawPieChartWakeups();
          }

          if (this.chartDatacustom?.rows?.i?.length !== 0) {
            this.drawPieChartMonomem();
            this.drawPieChartVerts();
            this.drawPieChartTris();
            this.drawPieChartDc();
            this.drawPieChartGc();
          }

          //
          if (this.chartDataMonoMem?.rows?.timeline?.length !== 0) {
            this.drawPieChartMono();
          }
          if (this.chartDataDrawCall?.rows?.timeline?.length !== 0) {
            this.drawPieChartDrawCall();
          }
          if (this.chartDataTriangle?.rows?.timeline?.length !== 0) {
            this.drawPieChartTriangle();
          }
          if (this.chartDataTemp?.rows?.timeline?.length !== 0) {
            this.drawPieChartTemp();
          }
          if (this.chartDataElectric?.rows?.timeline?.length !== 0) {
            this.drawPieChartElectric();
          }

          this.getPictureData();
          this.drawAnalyseTrend();
          this.drawPieChartCPUUsageNormalized();
          this.drawPieChartCPUCoreUsage();
          this.drawPieChartCPUClock();
        }
        let boxWidth = document.getElementById(this.pictureArr[0].time)
          .offsetWidth;

        // 获取居中平移距离
        let ofwidth = document.getElementById("cs").offsetLeft + boxWidth;

        // 将每一次平移居中位置放置每一个对象中
        this.pictureArr.forEach(function (v) {
          v.ofwidth = ofwidth -= boxWidth + 10;
          //
          //
        });
        let x = month;
        let pictureObj = this.pictureArr.filter(function (v) {
          return v.time === x;
        });

        if (pictureObj.length > 0) {
          file1 = pictureObj[0].ofwidth + "px";
          document.getElementById(
            "scro"
          ).style.transform = `translateX(${file1})`;
          document.getElementById(pictureObj[0].time).firstChild.style.outline =
            "6px solid #4271fb";
          let po = this.sibling1(document.getElementById(pictureObj[0].time));
          //     var siblings = sibling(document.getElementById(pictureObj[0].time));
          po.forEach(function (v) {
            //
            v.firstChild.style.outline = 0;
          });
        } else {
          let pic = this.pictureArr.filter(
            (v) => v.time === this.subtractTwoSeconds(x)
          )[0];
          file1 = pic.ofwidth + "px";
          document.getElementById(
            "scro"
          ).style.transform = `translateX(${file1})`;
          document.getElementById(pic.time).firstChild.style.outline =
            "6px solid #4271fb";
          let po = this.sibling1(document.getElementById(pic.time));
          //     var siblings = sibling(document.getElementById(pictureObj[0].time));
          po.forEach(function (v) {
            //
            v.firstChild.style.outline = 0;
          });
        }
      });
      option = {
        title: {
          text: "Memory Usage",
          textStyle: {
            fontSize: 16,
            fontWeight: 700,
            color: "#333",
          },
        },
        dataZoom: this.chartSettings.dataZoom,
        toolbox: this.chartSettings.toolbox,
        tooltip: this.chartSettings.tooltip,
        legend: this.chartSettings.legend,
        grid: this.chartSettings.grid,
        yAxis: this.chartSettings.yAxis,
        xAxis: {
          type: "category",
          boundaryGap: false,
          data: this.chartDataResult.rows.timeline,
        },
        series: this.pss_line_data,
      };
      PSSLineChart.setOption(option);
      this.judgNull(option.series, pss_line);
      // if (
      //   document.getElementById("pss_line").getAttribute("style") ===
      //   "display:none"
      // ) {
      //   document
      //     .getElementById("pss_line")
      //     .parentNode.parentNode.setAttribute("style", "display:none");
      // }
      return PSSLineChart;
    },
    textScroll(data) {
      if (data === "温度") {
        const targetElement = document.querySelector("#status");
        targetElement.scrollIntoView();
      }
      if (data === "FrameTime") {
        const targetElement = document.querySelector("#frametime_line");
        targetElement.scrollIntoView();
      }
      if (data === "Wakeups") {
        const targetElement = document.querySelector("#wakeupsBox");
        targetElement.scrollIntoView();
      }
      if (data === "CSwitch") {
        const targetElement = document.querySelector("#CSwitchBox");
        targetElement.scrollIntoView();
      }
      if (data === "线程函数") {
        const targetElement = document.querySelector("#analyse_box");
        targetElement.scrollIntoView();
      }
      if (data === "FPS") {
        const targetElement = document.querySelector("#fps_line_scroll");
        targetElement.scrollIntoView();
      }
      if (data === "NetWork") {
        const targetElement = document.querySelector("#flow_line_box");
        targetElement.scrollIntoView();
      }
      if (data === "Memory") {
        const targetElement = document.querySelector("#MemoryBox");
        targetElement.scrollIntoView();
      }
      if (data === "Energy") {
        const targetElement = document.querySelector("#electric_line");
        targetElement.scrollIntoView();
      }
      if (data === "GPU") {
        const targetElement = document.querySelector("#gpuBox");
        targetElement.scrollIntoView();
      }
      if (data === "CPU") {
        const targetElement = document.querySelector("#cpuBox");
        targetElement.scrollIntoView();
      }
      if (data === "GPU General Counter") {
        const targetElement = document.querySelector("#gpu_general_counter");

        targetElement.scrollIntoView();
      }
      if (data === "GPU Memory Counter") {
        const targetElement = document.querySelector("#gpu_memory_counter");
        targetElement.scrollIntoView();
      }
      if (data === "GPU Shader Counter") {
        const targetElement = document.querySelector("#gpu_shader_counter");
        targetElement.scrollIntoView();
      }
      if (data === "MemoryDetail") {
        const targetElement = document.querySelector("#memory_detail");
        targetElement.scrollIntoView();
      }
      if (data === "Memory Usage") {
        const targetElement = document.querySelector("#pss_line");
        targetElement.scrollIntoView();
      }
      if (data === "CPU Usage") {
        const targetElement = document.querySelector("#cpu_usage_line");
        targetElement.scrollIntoView();
      }
      if (data === "CPU Core USage(Normalized)") {
        const targetElement = document.querySelector("#cpu_freq_line");
        targetElement.scrollIntoView();
      }
      if (data === "CPU Core Usage") {
        const targetElement = document.querySelector("#cpu_core_usage");
        targetElement.scrollIntoView();
      }
      if (data === "CPU Usage(Normalized)") {
        const targetElement = document.querySelector("#cpu_usage_normalized");
        targetElement.scrollIntoView();
      }
      if (data === "CPU Clock") {
        const targetElement = document.querySelector("#cpu_clock");
        targetElement.scrollIntoView();
      }
    },
    drawPieChartMemoryDetail() {
      let pss_line = document.getElementById("memory_detail");
      if (pss_line.getAttribute("style") === "display:none") {
        pss_line.setAttribute("style", "width: 100%; height: 400px");
      }

      // 用echarts时，如果存在DOM，就会报存在警告，处理方法删除DOM
      // echarts数据变动时, 数据正常，图标混乱，故以此解决
      echarts.dispose(pss_line);

      let PSSLineChart = echarts.init(pss_line);
      let option;
      let list1 = [];
      list1 = this.pictureArr;

      let file1 = this.file;
      let time = this.chartDataResult.rows.timeline;
      let labelName = this.chartDataResult.rows.label;
      let lableList3 = this.lableList3;
      PSSLineChart.on("datazoom", (params) => {
        // 获取索引
        let start_rate = params.start;
        let end_rate = params.end;

        this.startValue = start_rate;
        this.endValue = end_rate;

        let start = PSSLineChart.getModel().option.dataZoom[0].startValue;
        let end = PSSLineChart.getModel().option.dataZoom[0].endValue;

        let arr = time.filter((v, i) => {
          if (start === time.length) {
            return i >= start - 1 && i < end;
          } else {
            return i >= start && i <= end;
          }
        });

        let newLabelName = labelName.flat().filter((v, i) => {
          if (start === time.length) {
            return i >= start - 1 && i < end;
          } else {
            return i >= start && i <= end;
          }
        });

        // 获取新的lable
        var newArr = [],
          tempArr = [];
        for (var i = 0, j = newLabelName.length; i < j; i++) {
          if (newLabelName[i] == newLabelName[i + 1]) {
            tempArr.push(newLabelName[i]);
          } else {
            tempArr.push(newLabelName[i]);
            newArr.push(tempArr.slice(0));
            tempArr.length = 0;
          }
        }

        let labelWidthAll1 = [];
        let c = newArr.flat();
        let n = Array.from(new Set(c));
        let arr3 = [];

        lableList3.forEach(function (v) {
          n.forEach(function (j) {
            if (v.id_label == j) {
              arr3.push(v);
            }
          });
        });

        newArr.forEach(function (v) {
          labelWidthAll1.push((v.length / arr.length) * 100 + "%");
        });

        arr3.forEach(function (v, i) {
          labelWidthAll1.forEach(function (j, index) {
            if (i == index) {
              v.width = j;
            }
          });
        });

        this.lableList = arr3;
        this.chartSettings.dataZoom[0].start = start_rate;
        this.chartSettings.dataZoom[0].end = end_rate;

        this.drawPieChartFPS();
        this.drawPieChartFrameTime();
        this.drawPieChartCPUCoreUsage();
        this.drawPieChartCPUUsage();

        // this.drawPieChartMemoryDetail();

        this.drawPieChartGPUGeneralCounter();
        // this.drawPieChartGPUMemoryCounter();
        this.drawPieChartGPUShaderCounter();
        this.drawPieChartWakeups();
        this.drawPieChartCPUUsageNormalized();
      });
      PSSLineChart.getZr().on("click", async (params) => {
        var pointInPixel = [params.offsetX, params.offsetY];
        if (PSSLineChart.containPixel("grid", pointInPixel)) {
          /*此处添加具体执行代码*/

          var pointInGrid = PSSLineChart.convertFromPixel(
            { seriesIndex: 0 },
            pointInPixel
          );
          //X轴序号
          var xIndex = pointInGrid[0];

          //获取当前图表的option
          var op = PSSLineChart.getOption();

          //获得图表中我们想要的数据
          var month = op.xAxis[0].data[xIndex];
          var value = op.series[0].data[xIndex];
          let xaxis = this.chartDataResult.rows.timeline;
          xIndex = (xIndex + 1) / xaxis.length;
          this.month_new = xIndex;
          this.opacity = 1;
          this.chartSettings.dataZoom[0].start = op.dataZoom[0].start;
          this.chartSettings.dataZoom[0].end = op.dataZoom[0].end;
          await this.drawAll();
          this.drawPieChartFPS();
          this.drawPieChartFrameTime();
          this.drawPieChartCPUCoreUsage();
          this.drawPieChartCPUUsage();

          this.drawPieChartMemoryDetail();

          this.drawPieChartGPUGeneralCounter();
          // this.drawPieChartGPUMemoryCounter();
          this.drawPieChartGPUShaderCounter();
          this.drawPieChartWakeups();
          this.drawPieChartCPUUsageNormalized();
        }
        let boxWidth = document.getElementById(this.pictureArr[0].time)
          .offsetWidth;

        // 获取居中平移距离
        let ofwidth = document.getElementById("cs").offsetLeft + boxWidth;

        // 将每一次平移居中位置放置每一个对象中
        this.pictureArr.forEach(function (v) {
          v.ofwidth = ofwidth -= boxWidth + 10;
          //
          //
        });
        let x = month;
        let pictureObj = this.pictureArr.filter(function (v) {
          return v.time === x;
        });

        if (pictureObj.length > 0) {
          file1 = pictureObj[0].ofwidth + "px";
          document.getElementById(
            "scro"
          ).style.transform = `translateX(${file1})`;
          document.getElementById(pictureObj[0].time).firstChild.style.outline =
            "6px solid #4271fb";
          let po = this.sibling1(document.getElementById(pictureObj[0].time));
          //     var siblings = sibling(document.getElementById(pictureObj[0].time));
          po.forEach(function (v) {
            //
            v.firstChild.style.outline = 0;
          });
        } else {
          let pic = this.pictureArr.filter(
            (v) => v.time === this.subtractTwoSeconds(x)
          )[0];
          file1 = pic.ofwidth + "px";
          document.getElementById(
            "scro"
          ).style.transform = `translateX(${file1})`;
          document.getElementById(pic.time).firstChild.style.outline =
            "6px solid #4271fb";
          let po = this.sibling1(document.getElementById(pic.time));
          //     var siblings = sibling(document.getElementById(pictureObj[0].time));
          po.forEach(function (v) {
            //
            v.firstChild.style.outline = 0;
          });
        }
      });
      // let all_series = [];
      // this.memory_detail.forEach((item, index) => {
      //   if (index == 0) {
      //     all_series.push({
      //       name: item,
      //       type: "line",
      //       showSymbol: false,
      //       data: this.chartDataResult.rows[item],
      //       itemStyle: this.chartSettings.itemStyle2,
      //       markLine: {
      //         symbol: ["circle", "arrow"],
      //         data: [
      //           {
      //             silent: true,
      //             xAxis: this.month_new,
      //             label: {
      //               position: "end",
      //               show: true,
      //               formatter: this.month_new,
      //               color: "ED5664",
      //             },
      //             lineStyle: {
      //               type: "solid",
      //               color: "#ED5664",
      //               width: "1",
      //               opacity: this.opacity, // 设置为0，使标记线不可见
      //             },
      //           },
      //         ],
      //       },
      //     });
      //   } else {
      //     all_series.push({
      //       name: item,
      //       type: "line",
      //       showSymbol: false,
      //       data: this.chartDataResult.rows[item],
      //       itemStyle: this.chartSettings.itemStyle2,
      //     });
      //   }
      // });
      option = {
        title: {
          text: "Memory Usage",
          textStyle: {
            fontSize: 16,
            fontWeight: 700,
            color: "#333",
          },
        },
        dataZoom: this.chartSettings.dataZoom,
        toolbox: this.chartSettings.toolbox,
        tooltip: this.chartSettings.tooltip,
        legend: this.chartSettings.legend,
        grid: this.chartSettings.grid,
        yAxis: this.chartSettings.yAxis,
        xAxis: {
          type: "category",
          boundaryGap: false,
          data: this.chartDataResult.rows.timeline,
        },
        series: this.memory_detail_data,
      };
      PSSLineChart.setOption(option);
      this.judgNull(option.series, pss_line);
      // if (
      //   document.getElementById("pss_line").getAttribute("style") ===
      //   "display:none"
      // ) {
      //   document
      //     .getElementById("pss_line")
      //     .parentNode.parentNode.setAttribute("style", "display:none");
      // }
      return PSSLineChart;
    },
    drawPieChartGPUGeneralCounter() {
      let pss_line = document.getElementById("gpu_memory");
      if (pss_line.getAttribute("style") === "display:none") {
        pss_line.setAttribute("style", "width: 100%; height: 400px");
      }

      // 用echarts时，如果存在DOM，就会报存在警告，处理方法删除DOM
      // echarts数据变动时, 数据正常，图标混乱，故以此解决
      echarts.dispose(pss_line);

      let PSSLineChart = echarts.init(pss_line);
      let option;
      let list1 = [];
      list1 = this.pictureArr;

      let file1 = this.file;
      let time = this.chartDataResult.rows.timeline;
      let labelName = this.chartDataResult.rows.label;
      let lableList3 = this.lableList3;
      PSSLineChart.on("datazoom", (params) => {
        // 获取索引
        let start_rate = params.start;
        let end_rate = params.end;

        this.startValue = start_rate;
        this.endValue = end_rate;

        let start = PSSLineChart.getModel().option.dataZoom[0].startValue;
        let end = PSSLineChart.getModel().option.dataZoom[0].endValue;

        let arr = time.filter((v, i) => {
          if (start === time.length) {
            return i >= start - 1 && i < end;
          } else {
            return i >= start && i <= end;
          }
        });

        let newLabelName = labelName.flat().filter((v, i) => {
          if (start === time.length) {
            return i >= start - 1 && i < end;
          } else {
            return i >= start && i <= end;
          }
        });

        // 获取新的lable
        var newArr = [],
          tempArr = [];
        for (var i = 0, j = newLabelName.length; i < j; i++) {
          if (newLabelName[i] == newLabelName[i + 1]) {
            tempArr.push(newLabelName[i]);
          } else {
            tempArr.push(newLabelName[i]);
            newArr.push(tempArr.slice(0));
            tempArr.length = 0;
          }
        }

        let labelWidthAll1 = [];
        let c = newArr.flat();
        let n = Array.from(new Set(c));
        let arr3 = [];

        lableList3.forEach(function (v) {
          n.forEach(function (j) {
            if (v.id_label == j) {
              arr3.push(v);
            }
          });
        });

        newArr.forEach(function (v) {
          labelWidthAll1.push((v.length / arr.length) * 100 + "%");
        });

        arr3.forEach(function (v, i) {
          labelWidthAll1.forEach(function (j, index) {
            if (i == index) {
              v.width = j;
            }
          });
        });

        this.lableList = arr3;
        this.chartSettings.dataZoom[0].start = start_rate;
        this.chartSettings.dataZoom[0].end = end_rate;

        this.drawPieChartFPS();
        this.drawPieChartFrameTime();
        this.drawPieChartCPUCoreUsage();
        this.drawPieChartCPUUsage();

        this.drawPieChartMemoryDetail();

        // this.drawPieChartGPUGeneralCounter();
        // this.drawPieChartGPUMemoryCounter();
        this.drawPieChartGPUShaderCounter();
        this.drawPieChartWakeups();
        this.drawPieChartCPUUsageNormalized();
      });
      PSSLineChart.getZr().on("click", async (params) => {
        var pointInPixel = [params.offsetX, params.offsetY];
        if (PSSLineChart.containPixel("grid", pointInPixel)) {
          /*此处添加具体执行代码*/

          var pointInGrid = PSSLineChart.convertFromPixel(
            { seriesIndex: 0 },
            pointInPixel
          );
          //X轴序号
          var xIndex = pointInGrid[0];

          //获取当前图表的option
          var op = PSSLineChart.getOption();

          //获得图表中我们想要的数据
          var month = op.xAxis[0].data[xIndex];
          var value = op.series[0].data[xIndex];
          let xaxis = this.chartDataResult.rows.timeline;
          xIndex = (xIndex + 1) / xaxis.length;
          this.month_new = xIndex;
          this.opacity = 1;
          this.chartSettings.dataZoom[0].start = op.dataZoom[0].start;
          this.chartSettings.dataZoom[0].end = op.dataZoom[0].end;
          await this.drawAll();
          this.drawPieChartFPS();
          this.drawPieChartFrameTime();
          this.drawPieChartCPUCoreUsage();
          this.drawPieChartCPUUsage();

          this.drawPieChartMemoryDetail();

          this.drawPieChartGPUGeneralCounter();
          // this.drawPieChartGPUMemoryCounter();
          this.drawPieChartGPUShaderCounter();
          this.drawPieChartWakeups();
          this.drawPieChartCPUUsageNormalized();
        }
        let boxWidth = document.getElementById(this.pictureArr[0].time)
          .offsetWidth;

        // 获取居中平移距离
        let ofwidth = document.getElementById("cs").offsetLeft + boxWidth;

        // 将每一次平移居中位置放置每一个对象中
        this.pictureArr.forEach(function (v) {
          v.ofwidth = ofwidth -= boxWidth + 10;
          //
          //
        });
        let x = month;
        let pictureObj = this.pictureArr.filter(function (v) {
          return v.time === x;
        });

        if (pictureObj.length > 0) {
          file1 = pictureObj[0].ofwidth + "px";
          document.getElementById(
            "scro"
          ).style.transform = `translateX(${file1})`;
          document.getElementById(pictureObj[0].time).firstChild.style.outline =
            "6px solid #4271fb";
          let po = this.sibling1(document.getElementById(pictureObj[0].time));
          //     var siblings = sibling(document.getElementById(pictureObj[0].time));
          po.forEach(function (v) {
            //
            v.firstChild.style.outline = 0;
          });
        } else {
          let pic = this.pictureArr.filter(
            (v) => v.time === this.subtractTwoSeconds(x)
          )[0];
          file1 = pic.ofwidth + "px";
          document.getElementById(
            "scro"
          ).style.transform = `translateX(${file1})`;
          document.getElementById(pic.time).firstChild.style.outline =
            "6px solid #4271fb";
          let po = this.sibling1(document.getElementById(pic.time));
          //     var siblings = sibling(document.getElementById(pictureObj[0].time));
          po.forEach(function (v) {
            //
            v.firstChild.style.outline = 0;
          });
        }
      });
      option = {
        title: {
          text: "GPU Memory Usage",
          textStyle: {
            fontSize: 16,
            fontWeight: 700,
            color: "#333",
          },
        },
        dataZoom: this.chartSettings.dataZoom,
        toolbox: this.chartSettings.toolbox,
        tooltip: this.chartSettings.tooltip,
        legend: this.chartSettings.legend,
        grid: this.chartSettings.grid,
        yAxis: this.chartSettings.yAxis,
        xAxis: {
          type: "category",
          boundaryGap: false,
          data: this.chartDataResult.rows.timeline,
        },
        series: this.gpu_general_counter_data,
      };
      PSSLineChart.setOption(option);
      this.judgNull(option.series, pss_line);
      // if (
      //   document.getElementById("pss_line").getAttribute("style") ===
      //   "display:none"
      // ) {
      //   document
      //     .getElementById("pss_line")
      //     .parentNode.parentNode.setAttribute("style", "display:none");
      // }
      return PSSLineChart;
    },
    drawPieChartGPUMemoryCounter() {
      let pss_line = document.getElementById("gpu_memory_counter");
      if (pss_line.getAttribute("style") === "display:none") {
        pss_line.setAttribute("style", "width: 100%; height: 400px");
      }

      // 用echarts时，如果存在DOM，就会报存在警告，处理方法删除DOM
      // echarts数据变动时, 数据正常，图标混乱，故以此解决
      echarts.dispose(pss_line);

      let PSSLineChart = echarts.init(pss_line);
      let option;
      let list1 = [];
      list1 = this.pictureArr;

      let file1 = this.file;
      let time = this.chartDataResult.rows.timeline;
      let labelName = this.chartDataResult.rows.label;
      let lableList3 = this.lableList3;
      PSSLineChart.on("datazoom", (params) => {
        // 获取索引
        let start_rate = params.start;
        let end_rate = params.end;

        this.startValue = start_rate;
        this.endValue = end_rate;

        let start = PSSLineChart.getModel().option.dataZoom[0].startValue;
        let end = PSSLineChart.getModel().option.dataZoom[0].endValue;

        let arr = time.filter((v, i) => {
          if (start === time.length) {
            return i >= start - 1 && i < end;
          } else {
            return i >= start && i <= end;
          }
        });

        let newLabelName = labelName.flat().filter((v, i) => {
          if (start === time.length) {
            return i >= start - 1 && i < end;
          } else {
            return i >= start && i <= end;
          }
        });

        // 获取新的lable
        var newArr = [],
          tempArr = [];
        for (var i = 0, j = newLabelName.length; i < j; i++) {
          if (newLabelName[i] == newLabelName[i + 1]) {
            tempArr.push(newLabelName[i]);
          } else {
            tempArr.push(newLabelName[i]);
            newArr.push(tempArr.slice(0));
            tempArr.length = 0;
          }
        }

        let labelWidthAll1 = [];
        let c = newArr.flat();
        let n = Array.from(new Set(c));
        let arr3 = [];

        lableList3.forEach(function (v) {
          n.forEach(function (j) {
            if (v.id_label == j) {
              arr3.push(v);
            }
          });
        });

        newArr.forEach(function (v) {
          labelWidthAll1.push((v.length / arr.length) * 100 + "%");
        });

        arr3.forEach(function (v, i) {
          labelWidthAll1.forEach(function (j, index) {
            if (i == index) {
              v.width = j;
            }
          });
        });

        this.lableList = arr3;
        this.chartSettings.dataZoom[0].start = start_rate;
        this.chartSettings.dataZoom[0].end = end_rate;

        this.drawPieChartFPS();
        this.drawPieChartFrameTime();
        this.drawPieChartCPUUsage();
        this.drawPieChartCPUFreq();
        this.drawPieChartPSS();
        this.drawPieChartMemoryDetail();
        this.drawPieChartGPUGeneralCounter();
        // this.drawPieChartGPUMemoryCounter();
        this.drawPieChartGPUShaderCounter();
        this.drawPieChartFlow();
        if (this.testInfo0.device.toUpperCase().indexOf("IPHONE") != -1) {
          this.drawPieChartCsWitch();
          this.drawPieChartWakeups();
        }

        if (this.chartDatacustom?.rows?.i?.length !== 0) {
          this.drawPieChartMonomem();
          this.drawPieChartVerts();
          this.drawPieChartTris();
          this.drawPieChartDc();
          this.drawPieChartGc();
        }

        //
        if (this.chartDataMonoMem?.rows?.timeline?.length !== 0) {
          this.drawPieChartMono();
        }
        if (this.chartDataDrawCall?.rows?.timeline?.length !== 0) {
          this.drawPieChartDrawCall();
        }
        if (this.chartDataTriangle?.rows?.timeline?.length !== 0) {
          this.drawPieChartTriangle();
        }
        if (this.chartDataTemp?.rows?.timeline?.length !== 0) {
          this.drawPieChartTemp();
        }
        if (this.chartDataElectric?.rows?.timeline?.length !== 0) {
          this.drawPieChartElectric();
        }

        this.getPictureData();
        this.drawAnalyseTrend();
        this.drawPieChartCPUUsageNormalized();
        this.drawPieChartCPUCoreUsage();
        this.drawPieChartCPUClock();
      });
      PSSLineChart.getZr().on("click", async (params) => {
        var pointInPixel = [params.offsetX, params.offsetY];
        if (PSSLineChart.containPixel("grid", pointInPixel)) {
          /*此处添加具体执行代码*/

          var pointInGrid = PSSLineChart.convertFromPixel(
            { seriesIndex: 0 },
            pointInPixel
          );
          //X轴序号
          var xIndex = pointInGrid[0];

          //获取当前图表的option
          var op = PSSLineChart.getOption();

          //获得图表中我们想要的数据
          var month = op.xAxis[0].data[xIndex];
          var value = op.series[0].data[xIndex];
          let xaxis = this.chartDataResult.rows.timeline;
          xIndex = (xIndex + 1) / xaxis.length;
          this.month_new = xIndex;
          this.opacity = 1;
          this.chartSettings.dataZoom[0].start = op.dataZoom[0].start;
          this.chartSettings.dataZoom[0].end = op.dataZoom[0].end;
          await this.drawAll();
          this.drawPieChartFPS();
          this.drawPieChartFrameTime();
          this.drawPieChartCPUUsage();
          this.drawPieChartCPUFreq();
          this.drawPieChartPSS();
          this.drawPieChartMemoryDetail();
          this.drawPieChartGPUGeneralCounter();
          this.drawPieChartGPUMemoryCounter();
          this.drawPieChartGPUShaderCounter();
          this.drawPieChartFlow();
          if (this.testInfo0.device.toUpperCase().indexOf("IPHONE") != -1) {
            this.drawPieChartCsWitch();
            this.drawPieChartWakeups();
          }

          if (this.chartDatacustom?.rows?.i?.length !== 0) {
            this.drawPieChartMonomem();
            this.drawPieChartVerts();
            this.drawPieChartTris();
            this.drawPieChartDc();
            this.drawPieChartGc();
          }

          //
          if (this.chartDataMonoMem?.rows?.timeline?.length !== 0) {
            this.drawPieChartMono();
          }
          if (this.chartDataDrawCall?.rows?.timeline?.length !== 0) {
            this.drawPieChartDrawCall();
          }
          if (this.chartDataTriangle?.rows?.timeline?.length !== 0) {
            this.drawPieChartTriangle();
          }
          if (this.chartDataTemp?.rows?.timeline?.length !== 0) {
            this.drawPieChartTemp();
          }
          if (this.chartDataElectric?.rows?.timeline?.length !== 0) {
            this.drawPieChartElectric();
          }

          this.getPictureData();
          this.drawPieChartCPUUsageNormalized();
          this.drawPieChartCPUCoreUsage();
          this.drawPieChartCPUClock();
          this.drawAnalyseTrend();
        }
        let boxWidth = document.getElementById(this.pictureArr[0].time)
          .offsetWidth;

        // 获取居中平移距离
        let ofwidth = document.getElementById("cs").offsetLeft + boxWidth;

        // 将每一次平移居中位置放置每一个对象中
        this.pictureArr.forEach(function (v) {
          v.ofwidth = ofwidth -= boxWidth + 10;
          //
          //
        });
        let x = month;
        let pictureObj = this.pictureArr.filter(function (v) {
          return v.time === x;
        });

        if (pictureObj.length > 0) {
          file1 = pictureObj[0].ofwidth + "px";
          document.getElementById(
            "scro"
          ).style.transform = `translateX(${file1})`;
          document.getElementById(pictureObj[0].time).firstChild.style.outline =
            "6px solid #4271fb";
          let po = this.sibling1(document.getElementById(pictureObj[0].time));
          //     var siblings = sibling(document.getElementById(pictureObj[0].time));
          po.forEach(function (v) {
            //
            v.firstChild.style.outline = 0;
          });
        } else {
          let pic = this.pictureArr.filter(
            (v) => v.time === this.subtractTwoSeconds(x)
          )[0];
          file1 = pic.ofwidth + "px";
          document.getElementById(
            "scro"
          ).style.transform = `translateX(${file1})`;
          document.getElementById(pic.time).firstChild.style.outline =
            "6px solid #4271fb";
          let po = this.sibling1(document.getElementById(pic.time));
          //     var siblings = sibling(document.getElementById(pictureObj[0].time));
          po.forEach(function (v) {
            //
            v.firstChild.style.outline = 0;
          });
        }
      });
      option = {
        title: {
          text: "GPU Memory Counter",
          textStyle: {
            fontSize: 16,
            fontWeight: 700,
            color: "#333",
          },
        },
        dataZoom: this.chartSettings.dataZoom,
        toolbox: this.chartSettings.toolbox,
        tooltip: this.chartSettings.tooltip,
        legend: this.chartSettings.legend,
        grid: this.chartSettings.grid,
        yAxis: this.chartSettings.yAxis,
        timeline: this.chartSettings.timeline,
        xAxis: {
          type: "category",
          boundaryGap: false,
          data: this.chartDataResult.rows.timeline,
        },
        series: this.gpu_memory_counter_data,
      };
      PSSLineChart.setOption(option);
      this.judgNull(option.series, pss_line);
      // if (
      //   document.getElementById("pss_line").getAttribute("style") ===
      //   "display:none"
      // ) {
      //   document
      //     .getElementById("pss_line")
      //     .parentNode.parentNode.setAttribute("style", "display:none");
      // }
      return PSSLineChart;
    },
    drawPieChartFlow() {
      let pss_line = document.getElementById("flow_line");
      if (pss_line.getAttribute("style") === "display:none") {
        pss_line.setAttribute("style", "width: 100%; height: 400px");
      }

      // 用echarts时，如果存在DOM，就会报存在警告，处理方法删除DOM
      // echarts数据变动时, 数据正常，图标混乱，故以此解决
      echarts.dispose(pss_line);

      let PSSLineChart = echarts.init(pss_line);
      let option;
      let list1 = [];
      list1 = this.pictureArr;

      let file1 = this.file;
      let time = this.chartDataResult.rows.timeline;
      let labelName = this.chartDataResult.rows.label;
      let lableList3 = this.lableList3;
      PSSLineChart.on("datazoom", (params) => {
        // 获取索引
        let start_rate = params.start;
        let end_rate = params.end;

        this.startValue = start_rate;
        this.endValue = end_rate;

        let start = PSSLineChart.getModel().option.dataZoom[0].startValue;
        let end = PSSLineChart.getModel().option.dataZoom[0].endValue;

        let arr = time.filter((v, i) => {
          if (start === time.length) {
            return i >= start - 1 && i < end;
          } else {
            return i >= start && i <= end;
          }
        });

        let newLabelName = labelName.flat().filter((v, i) => {
          if (start === time.length) {
            return i >= start - 1 && i < end;
          } else {
            return i >= start && i <= end;
          }
        });

        // 获取新的lable
        var newArr = [],
          tempArr = [];
        for (var i = 0, j = newLabelName.length; i < j; i++) {
          if (newLabelName[i] == newLabelName[i + 1]) {
            tempArr.push(newLabelName[i]);
          } else {
            tempArr.push(newLabelName[i]);
            newArr.push(tempArr.slice(0));
            tempArr.length = 0;
          }
        }

        let labelWidthAll1 = [];
        let c = newArr.flat();
        let n = Array.from(new Set(c));
        let arr3 = [];

        lableList3.forEach(function (v) {
          n.forEach(function (j) {
            if (v.id_label == j) {
              arr3.push(v);
            }
          });
        });

        newArr.forEach(function (v) {
          labelWidthAll1.push((v.length / arr.length) * 100 + "%");
        });

        arr3.forEach(function (v, i) {
          labelWidthAll1.forEach(function (j, index) {
            if (i == index) {
              v.width = j;
            }
          });
        });

        this.lableList = arr3;
        this.chartSettings.dataZoom[0].start = start_rate;
        this.chartSettings.dataZoom[0].end = end_rate;

        this.drawPieChartFPS();
        this.drawPieChartFrameTime();
        this.drawPieChartCPUUsage();
        this.drawPieChartCPUFreq();
        this.drawPieChartPSS();
        this.drawPieChartMemoryDetail();
        this.drawPieChartGPUGeneralCounter();
        this.drawPieChartGPUMemoryCounter();
        this.drawPieChartGPUShaderCounter();
        // this.drawPieChartFlow();
        if (this.testInfo0.device.toUpperCase().indexOf("IPHONE") != -1) {
          this.drawPieChartCsWitch();
          this.drawPieChartWakeups();
        }

        if (this.chartDatacustom?.rows?.i?.length !== 0) {
          this.drawPieChartMonomem();
          this.drawPieChartVerts();
          this.drawPieChartTris();
          this.drawPieChartDc();
          this.drawPieChartGc();
        }

        //
        if (this.chartDataMonoMem?.rows?.timeline?.length !== 0) {
          this.drawPieChartMono();
        }
        if (this.chartDataDrawCall?.rows?.timeline?.length !== 0) {
          this.drawPieChartDrawCall();
        }
        if (this.chartDataTriangle?.rows?.timeline?.length !== 0) {
          this.drawPieChartTriangle();
        }
        if (this.chartDataTemp?.rows?.timeline?.length !== 0) {
          this.drawPieChartTemp();
        }
        if (this.chartDataElectric?.rows?.timeline?.length !== 0) {
          this.drawPieChartElectric();
        }

        this.getPictureData();
        this.drawAnalyseTrend();
        this.drawPieChartCPUUsageNormalized();
        this.drawPieChartCPUCoreUsage();
        this.drawPieChartCPUClock();
      });
      PSSLineChart.getZr().on("click", async (params) => {
        var pointInPixel = [params.offsetX, params.offsetY];
        if (PSSLineChart.containPixel("grid", pointInPixel)) {
          /*此处添加具体执行代码*/

          var pointInGrid = PSSLineChart.convertFromPixel(
            { seriesIndex: 0 },
            pointInPixel
          );
          //X轴序号
          var xIndex = pointInGrid[0];

          //获取当前图表的option
          var op = PSSLineChart.getOption();

          //获得图表中我们想要的数据
          var month = op.xAxis[0].data[xIndex];
          var value = op.series[0].data[xIndex];
          let xaxis = this.chartDataResult.rows.timeline;
          xIndex = (xIndex + 1) / xaxis.length;
          this.month_new = xIndex;
          this.opacity = 1;
          this.chartSettings.dataZoom[0].start = op.dataZoom[0].start;
          this.chartSettings.dataZoom[0].end = op.dataZoom[0].end;
          await this.drawAll();
          this.drawPieChartFPS();
          this.drawPieChartFrameTime();
          this.drawPieChartCPUUsage();
          this.drawPieChartCPUFreq();
          this.drawPieChartPSS();
          this.drawPieChartMemoryDetail();
          this.drawPieChartGPUGeneralCounter();
          this.drawPieChartGPUMemoryCounter();
          this.drawPieChartGPUShaderCounter();
          this.drawPieChartFlow();
          if (this.testInfo0.device.toUpperCase().indexOf("IPHONE") != -1) {
            this.drawPieChartCsWitch();
            this.drawPieChartWakeups();
          }

          if (this.chartDatacustom?.rows?.i?.length !== 0) {
            this.drawPieChartMonomem();
            this.drawPieChartVerts();
            this.drawPieChartTris();
            this.drawPieChartDc();
            this.drawPieChartGc();
          }

          //
          if (this.chartDataMonoMem?.rows?.timeline?.length !== 0) {
            this.drawPieChartMono();
          }
          if (this.chartDataDrawCall?.rows?.timeline?.length !== 0) {
            this.drawPieChartDrawCall();
          }
          if (this.chartDataTriangle?.rows?.timeline?.length !== 0) {
            this.drawPieChartTriangle();
          }
          if (this.chartDataTemp?.rows?.timeline?.length !== 0) {
            this.drawPieChartTemp();
          }
          if (this.chartDataElectric?.rows?.timeline?.length !== 0) {
            this.drawPieChartElectric();
          }

          this.getPictureData();
          this.drawPieChartCPUUsageNormalized();
          this.drawPieChartCPUCoreUsage();
          this.drawPieChartCPUClock();
          this.drawAnalyseTrend();
        }
        let boxWidth = document.getElementById(this.pictureArr[0].time)
          .offsetWidth;

        // 获取居中平移距离
        let ofwidth = document.getElementById("cs").offsetLeft + boxWidth;

        // 将每一次平移居中位置放置每一个对象中
        this.pictureArr.forEach(function (v) {
          v.ofwidth = ofwidth -= boxWidth + 10;
          //
          //
        });
        let x = month;
        let pictureObj = this.pictureArr.filter(function (v) {
          return v.time === x;
        });

        if (pictureObj.length > 0) {
          file1 = pictureObj[0].ofwidth + "px";
          document.getElementById(
            "scro"
          ).style.transform = `translateX(${file1})`;
          document.getElementById(pictureObj[0].time).firstChild.style.outline =
            "6px solid #4271fb";
          let po = this.sibling1(document.getElementById(pictureObj[0].time));
          //     var siblings = sibling(document.getElementById(pictureObj[0].time));
          po.forEach(function (v) {
            //
            v.firstChild.style.outline = 0;
          });
        } else {
          let pic = this.pictureArr.filter(
            (v) => v.time === this.subtractTwoSeconds(x)
          )[0];
          file1 = pic.ofwidth + "px";
          document.getElementById(
            "scro"
          ).style.transform = `translateX(${file1})`;
          document.getElementById(pic.time).firstChild.style.outline =
            "6px solid #4271fb";
          let po = this.sibling1(document.getElementById(pic.time));
          //     var siblings = sibling(document.getElementById(pictureObj[0].time));
          po.forEach(function (v) {
            //
            v.firstChild.style.outline = 0;
          });
        }
      });
      option = {
        title: {
          text: "Network",
          textStyle: {
            fontSize: 16,
            fontWeight: 700,
            color: "#333",
          },
        },
        dataZoom: this.chartSettings.dataZoom,
        toolbox: this.chartSettings.toolbox,
        tooltip: this.chartSettings.tooltip,
        legend: this.chartSettings.legend,
        grid: this.chartSettings.grid,
        yAxis: this.chartSettings.yAxis,
        xAxis: {
          type: "category",
          boundaryGap: false,
          data: this.chartDataResult.rows.timeline,
        },
        series: this.flow_line_data,
      };
      PSSLineChart.setOption(option);
      this.judgNull(option.series, pss_line);
      // if (
      //   document.getElementById("pss_line").getAttribute("style") ===
      //   "display:none"
      // ) {
      //   document
      //     .getElementById("pss_line")
      //     .parentNode.parentNode.setAttribute("style", "display:none");
      // }
      return PSSLineChart;
    },
    drawPieChartCsWitch() {
      let pss_line = document.getElementById("cswitch");
      if (pss_line.getAttribute("style") === "display:none") {
        pss_line.setAttribute("style", "width: 100%; height: 400px");
      }

      // 用echarts时，如果存在DOM，就会报存在警告，处理方法删除DOM
      // echarts数据变动时, 数据正常，图标混乱，故以此解决
      echarts.dispose(pss_line);

      let PSSLineChart = echarts.init(pss_line);
      let option;
      let list1 = [];
      list1 = this.pictureArr;

      let file1 = this.file;
      let time = this.chartDataResult.rows.timeline;
      let labelName = this.chartDataResult.rows.label;
      let lableList3 = this.lableList3;
      PSSLineChart.on("datazoom", (params) => {
        // 获取索引
        let start_rate = params.start;
        let end_rate = params.end;

        this.startValue = start_rate;
        this.endValue = end_rate;

        let start = PSSLineChart.getModel().option.dataZoom[0].startValue;
        let end = PSSLineChart.getModel().option.dataZoom[0].endValue;

        let arr = time.filter((v, i) => {
          if (start === time.length) {
            return i >= start - 1 && i < end;
          } else {
            return i >= start && i <= end;
          }
        });

        let newLabelName = labelName.flat().filter((v, i) => {
          if (start === time.length) {
            return i >= start - 1 && i < end;
          } else {
            return i >= start && i <= end;
          }
        });

        // 获取新的lable
        var newArr = [],
          tempArr = [];
        for (var i = 0, j = newLabelName.length; i < j; i++) {
          if (newLabelName[i] == newLabelName[i + 1]) {
            tempArr.push(newLabelName[i]);
          } else {
            tempArr.push(newLabelName[i]);
            newArr.push(tempArr.slice(0));
            tempArr.length = 0;
          }
        }

        let labelWidthAll1 = [];
        let c = newArr.flat();
        let n = Array.from(new Set(c));
        let arr3 = [];

        lableList3.forEach(function (v) {
          n.forEach(function (j) {
            if (v.id_label == j) {
              arr3.push(v);
            }
          });
        });

        newArr.forEach(function (v) {
          labelWidthAll1.push((v.length / arr.length) * 100 + "%");
        });

        arr3.forEach(function (v, i) {
          labelWidthAll1.forEach(function (j, index) {
            if (i == index) {
              v.width = j;
            }
          });
        });

        this.lableList = arr3;
        this.chartSettings.dataZoom[0].start = start_rate;
        this.chartSettings.dataZoom[0].end = end_rate;

        this.drawPieChartFPS();
        this.drawPieChartFrameTime();
        this.drawPieChartCPUUsage();
        this.drawPieChartCPUFreq();
        this.drawPieChartPSS();
        this.drawPieChartMemoryDetail();
        this.drawPieChartGPUGeneralCounter();
        this.drawPieChartGPUMemoryCounter();
        this.drawPieChartGPUShaderCounter();
        this.drawPieChartFlow();
        if (this.testInfo0.device.toUpperCase().indexOf("IPHONE") != -1) {
          // this.drawPieChartCsWitch();
          this.drawPieChartWakeups();
        }

        if (this.chartDatacustom?.rows?.i?.length !== 0) {
          this.drawPieChartMonomem();
          this.drawPieChartVerts();
          this.drawPieChartTris();
          this.drawPieChartDc();
          this.drawPieChartGc();
        }

        //
        if (this.chartDataMonoMem?.rows?.timeline?.length !== 0) {
          this.drawPieChartMono();
        }
        if (this.chartDataDrawCall?.rows?.timeline?.length !== 0) {
          this.drawPieChartDrawCall();
        }
        if (this.chartDataTriangle?.rows?.timeline?.length !== 0) {
          this.drawPieChartTriangle();
        }
        if (this.chartDataTemp?.rows?.timeline?.length !== 0) {
          this.drawPieChartTemp();
        }
        if (this.chartDataElectric?.rows?.timeline?.length !== 0) {
          this.drawPieChartElectric();
        }

        this.getPictureData();
        this.drawAnalyseTrend();
        this.drawPieChartCPUUsageNormalized();
        this.drawPieChartCPUCoreUsage();
        this.drawPieChartCPUClock();
      });
      PSSLineChart.getZr().on("click", async (params) => {
        var pointInPixel = [params.offsetX, params.offsetY];
        if (PSSLineChart.containPixel("grid", pointInPixel)) {
          /*此处添加具体执行代码*/

          var pointInGrid = PSSLineChart.convertFromPixel(
            { seriesIndex: 0 },
            pointInPixel
          );
          //X轴序号
          var xIndex = pointInGrid[0];

          //获取当前图表的option
          var op = PSSLineChart.getOption();

          //获得图表中我们想要的数据
          var month = op.xAxis[0].data[xIndex];
          var value = op.series[0].data[xIndex];
          let xaxis = this.chartDataResult.rows.timeline;
          xIndex = (xIndex + 1) / xaxis.length;
          this.month_new = xIndex;
          this.opacity = 1;
          this.chartSettings.dataZoom[0].start = op.dataZoom[0].start;
          this.chartSettings.dataZoom[0].end = op.dataZoom[0].end;
          await this.drawAll();
          this.drawPieChartFPS();
          this.drawPieChartFrameTime();
          this.drawPieChartCPUUsage();
          this.drawPieChartCPUFreq();
          this.drawPieChartPSS();
          this.drawPieChartMemoryDetail();
          this.drawPieChartGPUGeneralCounter();
          this.drawPieChartGPUMemoryCounter();
          this.drawPieChartGPUShaderCounter();
          this.drawPieChartFlow();
          if (this.testInfo0.device.toUpperCase().indexOf("IPHONE") != -1) {
            this.drawPieChartCsWitch();
            this.drawPieChartWakeups();
          }

          if (this.chartDatacustom?.rows?.i?.length !== 0) {
            this.drawPieChartMonomem();
            this.drawPieChartVerts();
            this.drawPieChartTris();
            this.drawPieChartDc();
            this.drawPieChartGc();
          }

          //
          if (this.chartDataMonoMem?.rows?.timeline?.length !== 0) {
            this.drawPieChartMono();
          }
          if (this.chartDataDrawCall?.rows?.timeline?.length !== 0) {
            this.drawPieChartDrawCall();
          }
          if (this.chartDataTriangle?.rows?.timeline?.length !== 0) {
            this.drawPieChartTriangle();
          }
          if (this.chartDataTemp?.rows?.timeline?.length !== 0) {
            this.drawPieChartTemp();
          }
          if (this.chartDataElectric?.rows?.timeline?.length !== 0) {
            this.drawPieChartElectric();
          }

          this.getPictureData();
          this.drawPieChartCPUUsageNormalized();
          this.drawPieChartCPUCoreUsage();
          this.drawPieChartCPUClock();
          this.drawAnalyseTrend();
        }
        let boxWidth = document.getElementById(this.pictureArr[0].time)
          .offsetWidth;

        // 获取居中平移距离
        let ofwidth = document.getElementById("cs").offsetLeft + boxWidth;

        // 将每一次平移居中位置放置每一个对象中
        this.pictureArr.forEach(function (v) {
          v.ofwidth = ofwidth -= boxWidth + 10;
          //
          //
        });
        let x = month;
        let pictureObj = this.pictureArr.filter(function (v) {
          return v.time === x;
        });

        if (pictureObj.length > 0) {
          file1 = pictureObj[0].ofwidth + "px";
          document.getElementById(
            "scro"
          ).style.transform = `translateX(${file1})`;
          document.getElementById(pictureObj[0].time).firstChild.style.outline =
            "6px solid #4271fb";
          let po = this.sibling1(document.getElementById(pictureObj[0].time));
          //     var siblings = sibling(document.getElementById(pictureObj[0].time));
          po.forEach(function (v) {
            //
            v.firstChild.style.outline = 0;
          });
        } else {
          let pic = this.pictureArr.filter(
            (v) => v.time === this.subtractTwoSeconds(x)
          )[0];
          file1 = pic.ofwidth + "px";
          document.getElementById(
            "scro"
          ).style.transform = `translateX(${file1})`;
          document.getElementById(pic.time).firstChild.style.outline =
            "6px solid #4271fb";
          let po = this.sibling1(document.getElementById(pic.time));
          //     var siblings = sibling(document.getElementById(pictureObj[0].time));
          po.forEach(function (v) {
            //
            v.firstChild.style.outline = 0;
          });
        }
      });
      option = {
        title: {
          text: "CSwitch",
          textStyle: {
            fontSize: 16,
            fontWeight: 700,
            color: "#333",
          },
        },
        dataZoom: this.chartSettings.dataZoom,
        toolbox: this.chartSettings.toolbox,
        tooltip: this.chartSettings.tooltip,
        legend: this.chartSettings.legend,
        grid: this.chartSettings.grid,
        yAxis: this.chartSettings.yAxis,
        xAxis: {
          type: "category",
          boundaryGap: false,
          data: this.chartDataSec.rows.timeline,
        },
        series: this.cswitch_data,
      };
      PSSLineChart.setOption(option);
      this.judgNull(option.series, pss_line);
      // if (
      //   document.getElementById("pss_line").getAttribute("style") ===
      //   "display:none"
      // ) {
      //   document
      //     .getElementById("pss_line")
      //     .parentNode.parentNode.setAttribute("style", "display:none");
      // }
      return PSSLineChart;
    },
    drawPieChartWakeups() {
      let pss_line = document.getElementById("io");
      if (pss_line.getAttribute("style") === "display:none") {
        pss_line.setAttribute("style", "width: 100%; height: 400px");
      }

      // 用echarts时，如果存在DOM，就会报存在警告，处理方法删除DOM
      // echarts数据变动时, 数据正常，图标混乱，故以此解决
      echarts.dispose(pss_line);

      let PSSLineChart = echarts.init(pss_line);
      let option;
      let list1 = [];
      list1 = this.pictureArr;

      let file1 = this.file;
      let time = this.chartDataResult.rows.timeline;
      let labelName = this.chartDataResult.rows.label;
      let lableList3 = this.lableList3;
      PSSLineChart.on("datazoom", (params) => {
        // 获取索引
        let start_rate = params.start;
        let end_rate = params.end;

        this.startValue = start_rate;
        this.endValue = end_rate;

        let start = PSSLineChart.getModel().option.dataZoom[0].startValue;
        let end = PSSLineChart.getModel().option.dataZoom[0].endValue;

        let arr = time.filter((v, i) => {
          if (start === time.length) {
            return i >= start - 1 && i < end;
          } else {
            return i >= start && i <= end;
          }
        });

        let newLabelName = labelName.flat().filter((v, i) => {
          if (start === time.length) {
            return i >= start - 1 && i < end;
          } else {
            return i >= start && i <= end;
          }
        });

        // 获取新的lable
        var newArr = [],
          tempArr = [];
        for (var i = 0, j = newLabelName.length; i < j; i++) {
          if (newLabelName[i] == newLabelName[i + 1]) {
            tempArr.push(newLabelName[i]);
          } else {
            tempArr.push(newLabelName[i]);
            newArr.push(tempArr.slice(0));
            tempArr.length = 0;
          }
        }

        let labelWidthAll1 = [];
        let c = newArr.flat();
        let n = Array.from(new Set(c));
        let arr3 = [];

        lableList3.forEach(function (v) {
          n.forEach(function (j) {
            if (v.id_label == j) {
              arr3.push(v);
            }
          });
        });

        newArr.forEach(function (v) {
          labelWidthAll1.push((v.length / arr.length) * 100 + "%");
        });

        arr3.forEach(function (v, i) {
          labelWidthAll1.forEach(function (j, index) {
            if (i == index) {
              v.width = j;
            }
          });
        });

        this.lableList = arr3;
        this.chartSettings.dataZoom[0].start = start_rate;
        this.chartSettings.dataZoom[0].end = end_rate;

        this.drawPieChartFPS();
        this.drawPieChartFrameTime();
        this.drawPieChartCPUCoreUsage();
        this.drawPieChartCPUUsage();

        this.drawPieChartMemoryDetail();

        this.drawPieChartGPUGeneralCounter();
        // this.drawPieChartGPUMemoryCounter();
        this.drawPieChartGPUShaderCounter();
        // this.drawPieChartWakeups();
        this.drawPieChartCPUUsageNormalized();
      });
      PSSLineChart.getZr().on("click", async (params) => {
        var pointInPixel = [params.offsetX, params.offsetY];
        if (PSSLineChart.containPixel("grid", pointInPixel)) {
          /*此处添加具体执行代码*/

          var pointInGrid = PSSLineChart.convertFromPixel(
            { seriesIndex: 0 },
            pointInPixel
          );
          //X轴序号
          var xIndex = pointInGrid[0];

          //获取当前图表的option
          var op = PSSLineChart.getOption();

          //获得图表中我们想要的数据
          var month = op.xAxis[0].data[xIndex];
          var value = op.series[0].data[xIndex];
          let xaxis = this.chartDataSec.rows.timeline;
          xIndex = (xIndex + 1) / xaxis.length;
          this.month_new = xIndex;
          this.opacity = 1;
          this.chartSettings.dataZoom[0].start = op.dataZoom[0].start;
          this.chartSettings.dataZoom[0].end = op.dataZoom[0].end;
          await this.drawAll();
          this.drawPieChartFPS();
          this.drawPieChartFrameTime();
          this.drawPieChartCPUCoreUsage();
          this.drawPieChartCPUUsage();

          this.drawPieChartMemoryDetail();

          this.drawPieChartGPUGeneralCounter();
          // this.drawPieChartGPUMemoryCounter();
          this.drawPieChartGPUShaderCounter();
          this.drawPieChartWakeups();
          this.drawPieChartCPUUsageNormalized();
        }
        let boxWidth = document.getElementById(this.pictureArr[0].time)
          .offsetWidth;

        // 获取居中平移距离
        let ofwidth = document.getElementById("cs").offsetLeft + boxWidth;

        // 将每一次平移居中位置放置每一个对象中
        this.pictureArr.forEach(function (v) {
          v.ofwidth = ofwidth -= boxWidth + 10;
          //
          //
        });
        let x = month;
        let pictureObj = this.pictureArr.filter(function (v) {
          return v.time === x;
        });

        if (pictureObj.length > 0) {
          file1 = pictureObj[0].ofwidth + "px";
          document.getElementById(
            "scro"
          ).style.transform = `translateX(${file1})`;
          document.getElementById(pictureObj[0].time).firstChild.style.outline =
            "6px solid #4271fb";
          let po = this.sibling1(document.getElementById(pictureObj[0].time));
          //     var siblings = sibling(document.getElementById(pictureObj[0].time));
          po.forEach(function (v) {
            //
            v.firstChild.style.outline = 0;
          });
        } else {
          let pic = this.pictureArr.filter(
            (v) => v.time === this.subtractTwoSeconds(x)
          )[0];
          file1 = pic.ofwidth + "px";
          document.getElementById(
            "scro"
          ).style.transform = `translateX(${file1})`;
          document.getElementById(pic.time).firstChild.style.outline =
            "6px solid #4271fb";
          let po = this.sibling1(document.getElementById(pic.time));
          //     var siblings = sibling(document.getElementById(pictureObj[0].time));
          po.forEach(function (v) {
            //
            v.firstChild.style.outline = 0;
          });
        }
      });
      option = {
        title: {
          text: "IO Usage",
          textStyle: {
            fontSize: 16,
            fontWeight: 700,
            color: "#333",
          },
        },
        dataZoom: this.chartSettings.dataZoom,
        toolbox: this.chartSettings.toolbox,
        tooltip: this.chartSettings.tooltip,
        legend: this.chartSettings.legend,
        grid: this.chartSettings.grid,
        yAxis: this.chartSettings.yAxis,
        xAxis: {
          type: "category",
          boundaryGap: false,
          data: this.chartDataResult.rows.timeline,
        },
        series: this.wakeups_data,
      };
      PSSLineChart.setOption(option);

      this.judgNull(option.series, pss_line);
      // if (
      //   document.getElementById("pss_line").getAttribute("style") ===
      //   "display:none"
      // ) {
      //   document
      //     .getElementById("pss_line")
      //     .parentNode.parentNode.setAttribute("style", "display:none");
      // }
      return PSSLineChart;
    },

    drawPieChartGPUShaderCounter() {
      let pss_line = document.getElementById("gpu_usage");
      if (pss_line.getAttribute("style") === "display:none") {
        pss_line.setAttribute("style", "width: 100%; height: 400px");
      }

      // 用echarts时，如果存在DOM，就会报存在警告，处理方法删除DOM
      // echarts数据变动时, 数据正常，图标混乱，故以此解决
      echarts.dispose(pss_line);

      let PSSLineChart = echarts.init(pss_line);
      let option;
      let list1 = [];
      list1 = this.pictureArr;

      let file1 = this.file;
      let time = this.chartDataResult.rows.timeline;
      let labelName = this.chartDataResult.rows.label;
      let lableList3 = this.lableList3;
      PSSLineChart.on("datazoom", (params) => {
        // 获取索引
        let start_rate = params.start;
        let end_rate = params.end;

        this.startValue = start_rate;
        this.endValue = end_rate;

        let start = PSSLineChart.getModel().option.dataZoom[0].startValue;
        let end = PSSLineChart.getModel().option.dataZoom[0].endValue;

        let arr = time.filter((v, i) => {
          if (start === time.length) {
            return i >= start - 1 && i < end;
          } else {
            return i >= start && i <= end;
          }
        });

        let newLabelName = labelName.flat().filter((v, i) => {
          if (start === time.length) {
            return i >= start - 1 && i < end;
          } else {
            return i >= start && i <= end;
          }
        });

        // 获取新的lable
        var newArr = [],
          tempArr = [];
        for (var i = 0, j = newLabelName.length; i < j; i++) {
          if (newLabelName[i] == newLabelName[i + 1]) {
            tempArr.push(newLabelName[i]);
          } else {
            tempArr.push(newLabelName[i]);
            newArr.push(tempArr.slice(0));
            tempArr.length = 0;
          }
        }

        let labelWidthAll1 = [];
        let c = newArr.flat();
        let n = Array.from(new Set(c));
        let arr3 = [];

        lableList3.forEach(function (v) {
          n.forEach(function (j) {
            if (v.id_label == j) {
              arr3.push(v);
            }
          });
        });

        newArr.forEach(function (v) {
          labelWidthAll1.push((v.length / arr.length) * 100 + "%");
        });

        arr3.forEach(function (v, i) {
          labelWidthAll1.forEach(function (j, index) {
            if (i == index) {
              v.width = j;
            }
          });
        });

        this.lableList = arr3;
        this.chartSettings.dataZoom[0].start = start_rate;
        this.chartSettings.dataZoom[0].end = end_rate;

        this.drawPieChartFPS();
        this.drawPieChartFrameTime();
        this.drawPieChartCPUCoreUsage();
        this.drawPieChartCPUUsage();

        this.drawPieChartMemoryDetail();

        this.drawPieChartGPUGeneralCounter();
        // this.drawPieChartGPUMemoryCounter();
        // this.drawPieChartGPUShaderCounter();
        this.drawPieChartWakeups();
        this.drawPieChartCPUUsageNormalized();
      });
      PSSLineChart.getZr().on("click", async (params) => {
        var pointInPixel = [params.offsetX, params.offsetY];
        if (PSSLineChart.containPixel("grid", pointInPixel)) {
          /*此处添加具体执行代码*/

          var pointInGrid = PSSLineChart.convertFromPixel(
            { seriesIndex: 0 },
            pointInPixel
          );
          //X轴序号
          var xIndex = pointInGrid[0];

          //获取当前图表的option
          var op = PSSLineChart.getOption();

          //获得图表中我们想要的数据
          var month = op.xAxis[0].data[xIndex];
          var value = op.series[0].data[xIndex];
          let xaxis = this.chartDataResult.rows.timeline;
          xIndex = (xIndex + 1) / xaxis.length;
          this.month_new = xIndex;
          this.opacity = 1;
          this.chartSettings.dataZoom[0].start = op.dataZoom[0].start;
          this.chartSettings.dataZoom[0].end = op.dataZoom[0].end;
          await this.drawAll();
          this.drawPieChartFPS();
          this.drawPieChartFrameTime();
          this.drawPieChartCPUCoreUsage();
          this.drawPieChartCPUUsage();

          this.drawPieChartMemoryDetail();

          this.drawPieChartGPUGeneralCounter();
          // this.drawPieChartGPUMemoryCounter();
          this.drawPieChartGPUShaderCounter();
          this.drawPieChartWakeups();
          this.drawPieChartCPUUsageNormalized();
        }
        let boxWidth = document.getElementById(this.pictureArr[0].time)
          .offsetWidth;

        // 获取居中平移距离
        let ofwidth = document.getElementById("cs").offsetLeft + boxWidth;

        // 将每一次平移居中位置放置每一个对象中
        this.pictureArr.forEach(function (v) {
          v.ofwidth = ofwidth -= boxWidth + 10;
          //
          //
        });
        let x = month;
        let pictureObj = this.pictureArr.filter(function (v) {
          return v.time === x;
        });

        if (pictureObj.length > 0) {
          file1 = pictureObj[0].ofwidth + "px";
          document.getElementById(
            "scro"
          ).style.transform = `translateX(${file1})`;
          document.getElementById(pictureObj[0].time).firstChild.style.outline =
            "6px solid #4271fb";
          let po = this.sibling1(document.getElementById(pictureObj[0].time));
          //     var siblings = sibling(document.getElementById(pictureObj[0].time));
          po.forEach(function (v) {
            //
            v.firstChild.style.outline = 0;
          });
        } else {
          let pic = this.pictureArr.filter(
            (v) => v.time === this.subtractTwoSeconds(x)
          )[0];
          file1 = pic.ofwidth + "px";
          document.getElementById(
            "scro"
          ).style.transform = `translateX(${file1})`;
          document.getElementById(pic.time).firstChild.style.outline =
            "6px solid #4271fb";
          let po = this.sibling1(document.getElementById(pic.time));
          //     var siblings = sibling(document.getElementById(pictureObj[0].time));
          po.forEach(function (v) {
            //
            v.firstChild.style.outline = 0;
          });
        }
      });
      option = {
        title: {
          text: "GPU usage",
          textStyle: {
            fontSize: 16,
            fontWeight: 700,
            color: "#333",
          },
        },
        dataZoom: this.chartSettings.dataZoom,
        toolbox: this.chartSettings.toolbox,
        tooltip: this.chartSettings.tooltip,
        legend: this.chartSettings.legend,
        grid: this.chartSettings.grid,
        yAxis: this.chartSettings.yAxis,
        xAxis: {
          type: "category",
          boundaryGap: false,
          data: this.chartDataResult.rows.timeline,
        },
        series: this.gpu_shader_counter_data,
      };
      PSSLineChart.setOption(option);
      this.judgNull(option.series, pss_line);
      // if (
      //   document.getElementById("pss_line").getAttribute("style") ===
      //   "display:none"
      // ) {
      //   document
      //     .getElementById("pss_line")
      //     .parentNode.parentNode.setAttribute("style", "display:none");
      // }
      return PSSLineChart;
    },
    sibling(elm) {
      var a = [];
      var p = elm.parentNode.children;
      for (var i = 0, pl = p.length; i < pl; i++) {
        if (p[i] !== elm) a.push(p[i]);
      }
      return a;
    },
    drawPieChartMono() {
      let mono_line = document.getElementById("mono_line");
      if (mono_line.getAttribute("style") === "display:none") {
        mono_line.setAttribute("style", "width: 100%; height: 400px");
      }

      // 用echarts时，如果存在DOM，就会报存在警告，处理方法删除DOM
      // echarts数据变动时, 数据正常，图标混乱，故以此解决
      echarts.dispose(mono_line);

      let MonoLineChart = echarts.init(mono_line);
      let option;

      option = {
        title: {
          text: "MONO堆内存趋势",
          textStyle: {
            fontSize: 16,
            fontWeight: 700,
            color: "#333",
          },
        },
        dataZoom: this.chartSettings.dataZoom,
        toolbox: this.chartSettings.toolbox,
        tooltip: this.chartSettings.tooltip,
        legend: this.chartSettings.legend,
        grid: this.chartSettings.grid,
        yAxis: this.chartSettings.yAxis,
        xAxis: {
          type: "category",
          boundaryGap: false,
          data: this.chartDataMonoMem.rows.timeline,
        },
        series: [
          {
            name: "mono_total",
            type: "line",
            showSymbol: false,
            data: this.chartDataMonoMem.rows.mono_total,
            markLine: {
              symbol: ["circle", "arrow"],
              data: [
                {
                  silent: true,
                  xAxis: this.month_new,
                  label: {
                    position: "end",
                    show: true,
                    formatter: this.month_new,
                    color: "ED5664",
                  },
                  lineStyle: {
                    type: "solid",
                    color: "#ED5664",
                    width: "1",
                    opacity: this.opacity, // 设置为0，使标记线不可见
                  },
                },
              ],
            },
          },
          {
            name: "mono_used",
            type: "line",
            showSymbol: false,
            data: this.chartDataMonoMem.rows.mono_used,
          },
        ],
      };
      MonoLineChart.setOption(option);
      if (
        this.testInfo0.proj_name === "AOV" ||
        this.testInfo0.proj_name === "AOV测试项目" ||
        this.testInfo0.proj_name === "AOV主干Garena" ||
        this.testInfo0.proj_name === "AOV主干Tencent"
      ) {
        mono_line.setAttribute("style", "display:none");
      }
      this.judgNull(option.series, mono_line);

      // if (
      //   document.getElementById("mono_line").getAttribute("style") ===
      //   "display:none"
      // ) {
      //   document
      //     .getElementById("mono_line")
      //     .parentNode.parentNode.setAttribute("style", "display:none");
      // }
      return MonoLineChart;
    },
    drawPieChartDrawCall() {
      let draw_call_line = document.getElementById("draw_call_line");
      echarts.dispose(draw_call_line);

      let DrawCallLineChart = echarts.init(draw_call_line);
      let option;

      option = {
        title: {
          text: "DrawCall",
          textStyle: {
            fontSize: 16,
            fontWeight: 700,
            color: "#333",
          },
        },
        dataZoom: this.chartSettings.dataZoom,
        tooltip: this.chartSettings.tooltip,
        toolbox: this.chartSettings.toolbox,
        legend: this.chartSettings.legend,
        grid: this.chartSettings.grid,
        yAxis: this.chartSettings.yAxis,
        xAxis: {
          type: "category",
          boundaryGap: false,
          data: this.chartDataDrawCall.rows.timeline,
        },
        series: [
          {
            name: "drawcall",
            type: "line",
            showSymbol: false,
            data: this.chartDataDrawCall.rows.drawcall,
            itemStyle: this.chartSettings.itemStyle2,
            markLine: {
              symbol: ["circle", "arrow"],
              data: [
                {
                  silent: true,
                  xAxis: this.month_new,
                  label: {
                    position: "end",
                    show: true,
                    formatter: this.month_new,
                    color: "ED5664",
                  },
                  lineStyle: {
                    type: "solid",
                    color: "#ED5664",
                    width: "1",
                    opacity: this.opacity, // 设置为0，使标记线不可见
                  },
                },
              ],
            },
          },
        ],
      };
      DrawCallLineChart.setOption(option);
      return DrawCallLineChart;
    },
    drawPieChartTriangle() {
      let triangle_line = document.getElementById("triangle_line");

      // 用echarts时，如果存在DOM，就会报存在警告，处理方法删除DOM
      // echarts数据变动时, 数据正常，图标混乱，故以此解决
      echarts.dispose(triangle_line);

      let TriangleLineChart = echarts.init(triangle_line);
      let option;

      option = {
        title: {
          text: "三角形数量",
          textStyle: {
            fontSize: 16,
            fontWeight: 700,
            color: "#333",
          },
        },
        dataZoom: this.chartSettings.dataZoom,
        toolbox: this.chartSettings.toolbox,
        tooltip: this.chartSettings.tooltip,
        legend: this.chartSettings.legend,
        grid: this.chartSettings.grid,
        yAxis: this.chartSettings.yAxis,
        xAxis: {
          type: "category",
          boundaryGap: false,
          data: this.chartDataTriangle.rows.timeline,
        },
        series: [
          {
            name: "triangle",
            type: "line",
            showSymbol: false,
            data: this.chartDataTriangle.rows.triangle,
            itemStyle: this.chartSettings.itemStyle2,
            markLine: {
              symbol: ["circle", "arrow"],
              data: [
                {
                  silent: true,
                  xAxis: this.month_new,
                  label: {
                    position: "end",
                    show: true,
                    formatter: this.month_new,
                    color: "ED5664",
                  },
                  lineStyle: {
                    type: "solid",
                    color: "#ED5664",
                    width: "1",
                    opacity: this.opacity, // 设置为0，使标记线不可见
                  },
                },
              ],
            },
          },
        ],
      };
      TriangleLineChart.setOption(option);
      return TriangleLineChart;
    },
    drawPieChartTemp() {
      let temp_line = document.getElementById("temp_line");
      if (temp_line.getAttribute("style") === "display:none") {
        temp_line.setAttribute("style", "width: 100%; height: 400px");
      }
      // 用echarts时，如果存在DOM，就会报存在警告，处理方法删除DOM
      // echarts数据变动时, 数据正常，图标混乱，故以此解决
      echarts.dispose(temp_line);

      let TempLineChart = echarts.init(temp_line);
      let list1 = [];
      list1 = this.pictureArr;

      let file1 = this.file;
      let time = this.chartDataResult.rows.timeline;
      let labelName = this.chartDataResult.rows.label;
      let lableList3 = this.lableList3;
      TempLineChart.on("datazoom", (params) => {
        // 获取索引
        let start_rate = params.start;
        let end_rate = params.end;

        this.startValue = start_rate;
        this.endValue = end_rate;

        let start = TempLineChart.getModel().option.dataZoom[0].startValue;
        let end = TempLineChart.getModel().option.dataZoom[0].endValue;

        let arr = time.filter((v, i) => {
          if (start === time.length) {
            return i >= start - 1 && i < end;
          } else {
            return i >= start && i <= end;
          }
        });

        let newLabelName = labelName.flat().filter((v, i) => {
          if (start === time.length) {
            return i >= start - 1 && i < end;
          } else {
            return i >= start && i <= end;
          }
        });

        // 获取新的lable
        var newArr = [],
          tempArr = [];
        for (var i = 0, j = newLabelName.length; i < j; i++) {
          if (newLabelName[i] == newLabelName[i + 1]) {
            tempArr.push(newLabelName[i]);
          } else {
            tempArr.push(newLabelName[i]);
            newArr.push(tempArr.slice(0));
            tempArr.length = 0;
          }
        }

        let labelWidthAll1 = [];
        let c = newArr.flat();
        let n = Array.from(new Set(c));
        let arr3 = [];

        lableList3.forEach(function (v) {
          n.forEach(function (j) {
            if (v.id_label == j) {
              arr3.push(v);
            }
          });
        });

        newArr.forEach(function (v) {
          labelWidthAll1.push((v.length / arr.length) * 100 + "%");
        });

        arr3.forEach(function (v, i) {
          labelWidthAll1.forEach(function (j, index) {
            if (i == index) {
              v.width = j;
            }
          });
        });

        this.lableList = arr3;
        this.chartSettings.dataZoom[0].start = start_rate;
        this.chartSettings.dataZoom[0].end = end_rate;

        this.drawPieChartFPS();
        this.drawPieChartFrameTime();
        this.drawPieChartCPUUsage();
        this.drawPieChartCPUFreq();
        this.drawPieChartPSS();
        this.drawPieChartMemoryDetail();
        this.drawPieChartGPUGeneralCounter();
        this.drawPieChartGPUMemoryCounter();
        this.drawPieChartGPUShaderCounter();
        this.drawPieChartFlow();
        if (this.testInfo0.device.toUpperCase().indexOf("IPHONE") != -1) {
          this.drawPieChartCsWitch();
          this.drawPieChartWakeups();
        }

        if (this.chartDatacustom?.rows?.i?.length !== 0) {
          this.drawPieChartMonomem();
          this.drawPieChartVerts();
          this.drawPieChartTris();
          this.drawPieChartDc();
          this.drawPieChartGc();
        }

        //
        if (this.chartDataMonoMem?.rows?.timeline?.length !== 0) {
          this.drawPieChartMono();
        }
        if (this.chartDataDrawCall?.rows?.timeline?.length !== 0) {
          this.drawPieChartDrawCall();
        }
        if (this.chartDataTriangle?.rows?.timeline?.length !== 0) {
          this.drawPieChartTriangle();
        }
        // if (this.chartDataTemp?.rows?.timeline?.length !== 0) {
        //   this.drawPieChartTemp();
        // }
        if (this.chartDataElectric?.rows?.timeline?.length !== 0) {
          this.drawPieChartElectric();
        }

        this.getPictureData();
        this.drawAnalyseTrend();
        this.drawPieChartCPUUsageNormalized();
        this.drawPieChartCPUCoreUsage();
        this.drawPieChartCPUClock();
      });
      TempLineChart.getZr().on("click", async (params) => {
        var pointInPixel = [params.offsetX, params.offsetY];
        if (TempLineChart.containPixel("grid", pointInPixel)) {
          /*此处添加具体执行代码*/

          var pointInGrid = TempLineChart.convertFromPixel(
            { seriesIndex: 0 },
            pointInPixel
          );
          //X轴序号
          var xIndex = pointInGrid[0];

          //获取当前图表的option
          var op = TempLineChart.getOption();

          //获得图表中我们想要的数据
          var month = op.xAxis[0].data[xIndex];
          var value = op.series[0].data[xIndex];
          let xaxis = this.chartDataTemp.rows.timeline;
          xIndex = (xIndex + 1) / xaxis.length;
          this.month_new = xIndex;
          this.opacity = 1;
          this.chartSettings.dataZoom[0].start = op.dataZoom[0].start;
          this.chartSettings.dataZoom[0].end = op.dataZoom[0].end;
          await this.drawAll();
          this.drawPieChartFPS();
          this.drawPieChartFrameTime();
          this.drawPieChartCPUUsage();
          this.drawPieChartCPUFreq();
          this.drawPieChartPSS();
          this.drawPieChartMemoryDetail();
          this.drawPieChartGPUGeneralCounter();
          this.drawPieChartGPUMemoryCounter();
          this.drawPieChartGPUShaderCounter();
          this.drawPieChartFlow();
          if (this.testInfo0.device.toUpperCase().indexOf("IPHONE") != -1) {
            this.drawPieChartCsWitch();
            this.drawPieChartWakeups();
          }

          if (this.chartDatacustom?.rows?.i?.length !== 0) {
            this.drawPieChartMonomem();
            this.drawPieChartVerts();
            this.drawPieChartTris();
            this.drawPieChartDc();
            this.drawPieChartGc();
          }

          //
          if (this.chartDataMonoMem?.rows?.timeline?.length !== 0) {
            this.drawPieChartMono();
          }
          if (this.chartDataDrawCall?.rows?.timeline?.length !== 0) {
            this.drawPieChartDrawCall();
          }
          if (this.chartDataTriangle?.rows?.timeline?.length !== 0) {
            this.drawPieChartTriangle();
          }
          if (this.chartDataTemp?.rows?.timeline?.length !== 0) {
            this.drawPieChartTemp();
          }
          if (this.chartDataElectric?.rows?.timeline?.length !== 0) {
            this.drawPieChartElectric();
          }

          this.getPictureData();
          this.drawPieChartCPUUsageNormalized();
          this.drawPieChartCPUCoreUsage();
          this.drawPieChartCPUClock();
          this.drawAnalyseTrend();
        }
        let boxWidth = document.getElementById(this.pictureArr[0].time)
          .offsetWidth;

        // 获取居中平移距离
        let ofwidth = document.getElementById("cs").offsetLeft + boxWidth;

        // 将每一次平移居中位置放置每一个对象中
        this.pictureArr.forEach(function (v) {
          v.ofwidth = ofwidth -= boxWidth + 10;
          //
          //
        });
        let x = month;
        let pictureObj = this.pictureArr.filter(function (v) {
          return v.time === x;
        });

        if (pictureObj.length > 0) {
          file1 = pictureObj[0].ofwidth + "px";
          document.getElementById(
            "scro"
          ).style.transform = `translateX(${file1})`;
          document.getElementById(pictureObj[0].time).firstChild.style.outline =
            "6px solid #4271fb";
          let po = this.sibling1(document.getElementById(pictureObj[0].time));
          //     var siblings = sibling(document.getElementById(pictureObj[0].time));
          po.forEach(function (v) {
            //
            v.firstChild.style.outline = 0;
          });
        } else {
          let pic = this.pictureArr.filter(
            (v) => v.time === this.subtractTwoSeconds(x)
          )[0];
          file1 = pic.ofwidth + "px";
          document.getElementById(
            "scro"
          ).style.transform = `translateX(${file1})`;
          document.getElementById(pic.time).firstChild.style.outline =
            "6px solid #4271fb";
          let po = this.sibling1(document.getElementById(pic.time));
          //     var siblings = sibling(document.getElementById(pictureObj[0].time));
          po.forEach(function (v) {
            //
            v.firstChild.style.outline = 0;
          });
        }
      });
      let option;
      let series = this.temp_line_data;

      option = {
        title: {
          text: "手机温度",
          textStyle: {
            fontSize: 16,
            fontWeight: 700,
            color: "#333",
          },
        },
        dataZoom: this.chartSettings.dataZoom,
        toolbox: this.chartSettings.toolbox,
        tooltip: this.chartSettings.tooltip,
        legend: this.chartSettings.legend,
        grid: this.chartSettings.grid,
        yAxis: this.chartSettings.yAxis,
        xAxis: {
          type: "category",
          boundaryGap: false,
          data: this.chartDataTemp.rows.timeline,
        },
        series: series,
      };
      TempLineChart.setOption(option);
      this.judgNull(option.series, temp_line);
      // this.judgNull(option.series, temp_line);
      // if (
      //   document.getElementById("temp_line").getAttribute("style") ===
      //     "display:none" &&
      //   document.getElementById("electric_line").getAttribute("style") ===
      //     "display:none"
      // ) {
      //   document
      //     .getElementById("temp_line")
      //     .parentNode.parentNode.setAttribute("style", "display:none");
      // }
      return TempLineChart;
    },
    drawPieChartElectric() {
      let electric_line = document.getElementById("electric_line");

      if (electric_line.getAttribute("style") === "display:none") {
        electric_line.setAttribute("style", "width: 100%; height: 400px");
      }

      // 用echarts时，如果存在DOM，就会报存在警告，处理方法删除DOM
      // echarts数据变动时, 数据正常，图标混乱，故以此解决
      echarts.dispose(electric_line);

      let ElectricLineChart = echarts.init(electric_line);
      let list1 = [];
      list1 = this.pictureArr;

      let file1 = this.file;
      let time = this.chartDataResult.rows.timeline;
      let labelName = this.chartDataResult.rows.label;
      let lableList3 = this.lableList3;
      ElectricLineChart.on("datazoom", async (params) => {
        // 获取索引
        let start_rate = params.start;
        let end_rate = params.end;

        this.startValue = start_rate;
        this.endValue = end_rate;

        let start = ElectricLineChart.getModel().option.dataZoom[0].startValue;
        let end = ElectricLineChart.getModel().option.dataZoom[0].endValue;

        let arr = time.filter((v, i) => {
          if (start === time.length) {
            return i >= start - 1 && i < end;
          } else {
            return i >= start && i <= end;
          }
        });

        let newLabelName = labelName.flat().filter((v, i) => {
          if (start === time.length) {
            return i >= start - 1 && i < end;
          } else {
            return i >= start && i <= end;
          }
        });

        // 获取新的lable
        var newArr = [],
          tempArr = [];
        for (var i = 0, j = newLabelName.length; i < j; i++) {
          if (newLabelName[i] == newLabelName[i + 1]) {
            tempArr.push(newLabelName[i]);
          } else {
            tempArr.push(newLabelName[i]);
            newArr.push(tempArr.slice(0));
            tempArr.length = 0;
          }
        }

        let labelWidthAll1 = [];
        let c = newArr.flat();
        let n = Array.from(new Set(c));
        let arr3 = [];

        lableList3.forEach(function (v) {
          n.forEach(function (j) {
            if (v.id_label == j) {
              arr3.push(v);
            }
          });
        });

        newArr.forEach(function (v) {
          labelWidthAll1.push((v.length / arr.length) * 100 + "%");
        });

        arr3.forEach(function (v, i) {
          labelWidthAll1.forEach(function (j, index) {
            if (i == index) {
              v.width = j;
            }
          });
        });

        this.lableList = arr3;
        this.chartSettings.dataZoom[0].start = start_rate;
        this.chartSettings.dataZoom[0].end = end_rate;
        await this.drawAll();
        this.drawPieChartFPS();
        this.drawPieChartFrameTime();
        this.drawPieChartCPUUsage();
        this.drawPieChartCPUFreq();
        this.drawPieChartPSS();
        this.drawPieChartMemoryDetail();
        this.drawPieChartGPUGeneralCounter();
        this.drawPieChartGPUMemoryCounter();
        this.drawPieChartGPUShaderCounter();
        this.drawPieChartFlow();
        if (this.testInfo0.device.toUpperCase().indexOf("IPHONE") != -1) {
          this.drawPieChartCsWitch();
          this.drawPieChartWakeups();
        }

        if (this.chartDatacustom?.rows?.i?.length !== 0) {
          this.drawPieChartMonomem();
          this.drawPieChartVerts();
          this.drawPieChartTris();
          this.drawPieChartDc();
          this.drawPieChartGc();
        }

        //
        if (this.chartDataMonoMem?.rows?.timeline?.length !== 0) {
          this.drawPieChartMono();
        }
        if (this.chartDataDrawCall?.rows?.timeline?.length !== 0) {
          this.drawPieChartDrawCall();
        }
        if (this.chartDataTriangle?.rows?.timeline?.length !== 0) {
          this.drawPieChartTriangle();
        }
        if (this.chartDataTemp?.rows?.timeline?.length !== 0) {
          this.drawPieChartTemp();
        }
        // if (this.chartDataElectric?.rows?.timeline?.length !== 0) {
        //   this.drawPieChartElectric();
        // }

        this.getPictureData();
        this.drawAnalyseTrend();
        this.drawPieChartCPUUsageNormalized();
        this.drawPieChartCPUCoreUsage();
        this.drawPieChartCPUClock();
      });
      ElectricLineChart.getZr().on("click", async (params) => {
        var pointInPixel = [params.offsetX, params.offsetY];
        if (ElectricLineChart.containPixel("grid", pointInPixel)) {
          /*此处添加具体执行代码*/

          var pointInGrid = ElectricLineChart.convertFromPixel(
            { seriesIndex: 0 },
            pointInPixel
          );
          //X轴序号
          var xIndex = pointInGrid[0];

          //获取当前图表的option
          var op = ElectricLineChart.getOption();

          //获得图表中我们想要的数据
          var month = op.xAxis[0].data[xIndex];
          var value = op.series[0].data[xIndex];
          let xaxis = this.chartDataElectric.rows.timeline;
          xIndex = (xIndex + 1) / xaxis.length;
          this.month_new = xIndex;
          this.opacity = 1;
          this.chartSettings.dataZoom[0].start = op.dataZoom[0].start;
          this.chartSettings.dataZoom[0].end = op.dataZoom[0].end;
          await this.drawAll();
          this.drawPieChartFPS();
          this.drawPieChartFrameTime();
          this.drawPieChartCPUUsage();
          this.drawPieChartCPUFreq();
          this.drawPieChartPSS();
          this.drawPieChartMemoryDetail();
          this.drawPieChartGPUGeneralCounter();
          this.drawPieChartGPUMemoryCounter();
          this.drawPieChartGPUShaderCounter();
          this.drawPieChartFlow();
          if (this.testInfo0.device.toUpperCase().indexOf("IPHONE") != -1) {
            this.drawPieChartCsWitch();
            this.drawPieChartWakeups();
          }

          if (this.chartDatacustom?.rows?.i?.length !== 0) {
            this.drawPieChartMonomem();
            this.drawPieChartVerts();
            this.drawPieChartTris();
            this.drawPieChartDc();
            this.drawPieChartGc();
          }

          //
          if (this.chartDataMonoMem?.rows?.timeline?.length !== 0) {
            this.drawPieChartMono();
          }
          if (this.chartDataDrawCall?.rows?.timeline?.length !== 0) {
            this.drawPieChartDrawCall();
          }
          if (this.chartDataTriangle?.rows?.timeline?.length !== 0) {
            this.drawPieChartTriangle();
          }
          if (this.chartDataTemp?.rows?.timeline?.length !== 0) {
            this.drawPieChartTemp();
          }
          if (this.chartDataElectric?.rows?.timeline?.length !== 0) {
            this.drawPieChartElectric();
          }

          this.getPictureData();
          this.drawPieChartCPUUsageNormalized();
          this.drawPieChartCPUCoreUsage();
          this.drawPieChartCPUClock();
          this.drawAnalyseTrend();
        }
        let boxWidth = document.getElementById(this.pictureArr[0].time)
          .offsetWidth;

        // 获取居中平移距离
        let ofwidth = document.getElementById("cs").offsetLeft + boxWidth;

        // 将每一次平移居中位置放置每一个对象中
        this.pictureArr.forEach(function (v) {
          v.ofwidth = ofwidth -= boxWidth + 10;
          //
          //
        });
        let x = month;
        let pictureObj = this.pictureArr.filter(function (v) {
          return v.time === x;
        });

        if (pictureObj.length > 0) {
          file1 = pictureObj[0].ofwidth + "px";
          document.getElementById(
            "scro"
          ).style.transform = `translateX(${file1})`;
          document.getElementById(pictureObj[0].time).firstChild.style.outline =
            "6px solid #4271fb";
          let po = this.sibling1(document.getElementById(pictureObj[0].time));
          //     var siblings = sibling(document.getElementById(pictureObj[0].time));
          po.forEach(function (v) {
            //
            v.firstChild.style.outline = 0;
          });
        } else {
          let pic = this.pictureArr.filter(
            (v) => v.time === this.subtractTwoSeconds(x)
          )[0];
          file1 = pic.ofwidth + "px";
          document.getElementById(
            "scro"
          ).style.transform = `translateX(${file1})`;
          document.getElementById(pic.time).firstChild.style.outline =
            "6px solid #4271fb";
          let po = this.sibling1(document.getElementById(pic.time));
          //     var siblings = sibling(document.getElementById(pictureObj[0].time));
          po.forEach(function (v) {
            //
            v.firstChild.style.outline = 0;
          });
        }
      });
      let option;

      option = {
        title: {
          text: "手机电量",
          textStyle: {
            fontSize: 16,
            fontWeight: 700,
            color: "#333",
          },
        },
        dataZoom: this.chartSettings.dataZoom,
        toolbox: this.chartSettings.toolbox,
        tooltip: this.chartSettings.tooltip,
        legend: this.chartSettings.legend,
        grid: this.chartSettings.grid,
        yAxis: this.chartSettings.yAxis,
        xAxis: {
          type: "category",
          boundaryGap: false,
          data: this.chartDataElectric.rows.timeline,
        },
        series: this.electric_line_data,
      };
      ElectricLineChart.setOption(option);
      this.judgNull(option.series, electric_line);
      // this.judgNull(option.series, electric_line);
      // this.judgZero(option.series, electric_line);
      // if (
      //   document.getElementById("temp_line").getAttribute("style") ===
      //     "display:none" &&
      //   document.getElementById("electric_line").getAttribute("style") ===
      //     "display:none"
      // ) {
      //   document
      //     .getElementById("temp_line")
      //     .parentNode.parentNode.setAttribute("style", "display:none");
      // }
      return ElectricLineChart;
    },
    getName(item, i) {
      if (item.indexOf("_") != -1) {
        return item.split("_")[0];
      } else {
        return item;
      }
    },
    leftBtn(item) {
      if (this.pictureArr.length != 0) {
        let boxWidth = document.getElementById(this.pictureArr[0].time)
          .offsetWidth;
        let ofwidth = document.getElementById("cs").offsetLeft + boxWidth;

        this.pictureArr.forEach(function (v) {
          //
          v.ofwidth = ofwidth -= boxWidth + 10;
          //
          //
        });
        let i = 0;

        this.pictureArr.forEach((v, index) => {
          if (v.img === item) {
            i = index;
          }
        });

        if (i - 1 >= 0) {
          let file1 = "";
          file1 = this.pictureArr[i - 1].ofwidth + "px";
          document.getElementById(
            "scro"
          ).style.transform = `translateX(${file1})`;

          document.getElementById(
            this.pictureArr[i - 1].time
          ).firstChild.style.outline = "6px solid #4271fb";
          var siblings = this.sibling(
            document.getElementById(this.pictureArr[i - 1].time)
          );

          siblings.forEach(function (v) {
            //
            v.firstChild.style.outline = 0;
          });
          this.maskImg.img = this.pictureArr[i - 1].img;
        }
      }
    },
    sibling1(elm) {
      var a = [];
      var p = elm.parentNode.children;
      for (var i = 0, pl = p.length; i < pl; i++) {
        if (p[i] !== elm) a.push(p[i]);
      }
      return a;
    },
    rightBtn1(item) {
      if (this.pictureArr.length != 0) {
        let boxWidth = document.getElementById(this.pictureArr[0].time)
          .offsetWidth;
        let ofwidth = document.getElementById("cs").offsetLeft + boxWidth;

        this.pictureArr.forEach(function (v) {
          //
          v.ofwidth = ofwidth -= boxWidth + 10;
          //
          //
        });
        let i = 0;

        this.pictureArr.forEach((v, index) => {
          if (v.img === item) {
            i = index;
          }
        });

        if (i + 1 <= this.pictureArr?.length) {
          let file1 = "";
          file1 = this.pictureArr[i + 1].ofwidth + "px";
          document.getElementById(
            "scro"
          ).style.transform = `translateX(${file1})`;
          document.getElementById(
            this.pictureArr[i + 1].time
          ).firstChild.style.outline = "6px solid #4271fb";
          var siblings = this.sibling(
            document.getElementById(this.pictureArr[i + 1].time)
          );
          siblings.forEach(function (v) {
            //
            v.firstChild.style.outline = 0;
          });
          this.maskImg.img = this.pictureArr[i + 1].img;
        }
      }
    },
    drawPieChartMonomem() {
      let monomem = document.getElementById("monomem");
      if (monomem.getAttribute("style") === "display:none") {
        monomem.setAttribute("style", "width: 100%; height: 400px");
      }

      // 用echarts时，如果存在DOM，就会报存在警告，处理方法删除DOM
      // echarts数据变动时, 数据正常，图标混乱，故以此解决
      echarts.dispose(monomem);

      let MonomemChart = echarts.init(monomem);
      let option;
      option = {
        title: {
          text: "Mono Memory",
          textStyle: {
            fontSize: 16,
            fontWeight: 700,
            color: "#333",
          },
        },
        dataZoom: this.chartSettings.dataZoom,
        toolbox: this.chartSettings.toolbox,
        tooltip: this.chartSettings.tooltip,
        legend: this.chartSettings.legend,
        grid: this.chartSettings.grid,
        yAxis: this.chartSettings.yAxis,
        xAxis: {
          type: "category",
          boundaryGap: false,
          data: this.chartDatacustom.rows.i,
        },
        series: [
          {
            name: "monomem",
            type: "line",
            showSymbol: false,
            data: this.chartDatacustom.rows.monomem,
            itemStyle: this.chartSettings.itemStyle2,
            markLine: {
              symbol: ["circle", "arrow"],
              data: [
                {
                  silent: true,
                  xAxis: this.month_new,
                  label: {
                    position: "end",
                    show: true,
                    formatter: this.month_new,
                    color: "ED5664",
                  },
                  lineStyle: {
                    type: "solid",
                    color: "#ED5664",
                    width: "1",
                    opacity: this.opacity, // 设置为0，使标记线不可见
                  },
                },
              ],
            },
          },
        ],
      };
      MonomemChart.setOption(option);
      this.judgNull(option.series, monomem);
      // if (
      //   document.getElementById("monomem").getAttribute("style") ===
      //     "display:none" &&
      //   document.getElementById("gc_line").getAttribute("style") ===
      //     "display:none" &&
      //   document.getElementById("dc_line").getAttribute("style") ===
      //     "display:none" &&
      //   document.getElementById("Tris").getAttribute("style") ===
      //     "display:none" &&
      //   document.getElementById("Verts").getAttribute("style") ===
      //     "display:none"
      // ) {
      //   document
      //     .getElementById("monomem")
      //     .parentNode.parentNode.setAttribute("style", "display:none");
      // }
      return MonomemChart;
    },
    drawPieChartGc() {
      let gc_line = document.getElementById("gc_line");
      if (gc_line.getAttribute("style") === "display:none") {
        gc_line.setAttribute("style", "width: 100%; height: 400px");
      }

      // 用echarts时，如果存在DOM，就会报存在警告，处理方法删除DOM
      // echarts数据变动时, 数据正常，图标混乱，故以此解决
      echarts.dispose(gc_line);
      let GCChart = echarts.init(gc_line);
      let option;
      option = {
        title: {
          text: "GC",
          textStyle: {
            fontSize: 16,
            fontWeight: 700,
            color: "#333",
          },
        },
        dataZoom: this.chartSettings.dataZoom,
        toolbox: this.chartSettings.toolbox,
        tooltip: this.chartSettings.tooltip,
        legend: this.chartSettings.legend,
        grid: this.chartSettings.grid,
        yAxis: this.chartSettings.yAxis,
        xAxis: {
          type: "category",
          boundaryGap: false,
          data: this.chartDatacustom.rows.i,
        },
        series: [
          {
            name: "gc_line",
            type: "line",
            showSymbol: false,
            data: this.chartDatacustom.rows.gc,
            itemStyle: this.chartSettings.itemStyle2,
            markLine: {
              symbol: ["circle", "arrow"],
              data: [
                {
                  silent: true,
                  xAxis: this.month_new,
                  label: {
                    position: "end",
                    show: true,
                    formatter: this.month_new,
                    color: "ED5664",
                  },
                  lineStyle: {
                    type: "solid",
                    color: "#ED5664",
                    width: "1",
                    opacity: this.opacity, // 设置为0，使标记线不可见
                  },
                },
              ],
            },
          },
        ],
      };
      GCChart.setOption(option);
      this.judgNull(option.series, gc_line);
      // if (
      //   document.getElementById("monomem").getAttribute("style") ===
      //     "display:none" &&
      //   document.getElementById("gc_line").getAttribute("style") ===
      //     "display:none" &&
      //   document.getElementById("dc_line").getAttribute("style") ===
      //     "display:none" &&
      //   document.getElementById("Tris").getAttribute("style") ===
      //     "display:none" &&
      //   document.getElementById("Verts").getAttribute("style") ===
      //     "display:none"
      // ) {
      //   document
      //     .getElementById("monomem")
      //     .parentNode.parentNode.setAttribute("style", "display:none");
      // }
      return GCChart;
    },
    getCol() {
      return [
        // {type: 'selection', align: 'center', fixed: true},
        { prop: "tagName", label: "标签", fixed: true },
        { prop: "Smooth", label: "Smooth(稳帧指数)" },
        { prop: "var_fps", label: "Var(FPS)" },
        { prop: "Std(FPS)", label: "Std(FPS)" },

        { prop: "var_fps", label: "Var(FPS)" },
        { prop: "fps_lt_18_pcnt", label: "FPS>18%[%]" },
        { prop: "fps_lt_25_pcnt", label: "FPS>25%[%]" },

        { prop: "Drop(FPS)[/h]", label: "Drop(FPS)[/h]" },
        { prop: "min_fps", label: "Min(FPS)" },
        { prop: "Median(FPS)", label: "Median(FPS)" },
        { prop: "MedRange(FPS)[%]", label: "MedRange(FPS)[%]" },
        { prop: "SmallJank(/10min)", label: "SmallJank(微小卡顿)\n(/10min)" },
        { prop: "Jank(/10min)", label: "Jank(卡顿)(/10min)" },
        { prop: "BigJank(/10min)", label: "BigJank(严重卡顿)(/10min)" },
        { prop: "Stutter[%]", label: "Stutter(卡顿率) [%]" },
        { prop: "Avg(FTime)", label: "Avg(FTime)" },
        { prop: "Std(FTime)", label: "Std(FTime)" },
        { prop: "Var(FTime)", label: "Var(FTime)" },
        { prop: "FTime>=100[%]", label: "FTime>=100[%]" },
        { prop: "Delta(FTime)>100ms[/h]", label: "Delta(FTime)>100ms[/h]" },
        { prop: "avg_cpu", label: "Avg(AppCPU) [%]" },
        { prop: "cpu_lt_60_pcnt", label: "AppCPU<=60 [%]" },
        { prop: "cpu_lt_80_pcnt", label: "AppCPU<=80 [%]" },
        { prop: "AppUserCPU<=60[%]", label: "AppUserCPU<=60[%]" },
        { prop: "AppUserCPU<=80[%]", label: "AppUserCPU<=80[%]" },
        { prop: "AppKernelCPU", label: "Avg(AppKernelCPU) [%]" },
        { prop: "AppKernelCPU<=60[%]", label: "AppKernelCPU<=60 [%]" },
        { prop: "AppKernelCPU<=80[%]", label: "AppKernelCPU<=80 [%]" },
        { prop: "PrivateBytes", label: "Avg(PrivateBytes) [MB]" },
        { prop: "VirtualBytes", label: "Avg(VirtualBytes) [MB]" },
        { prop: "PageFaults", label: "Avg(PageFaults)" },
        { prop: "GTemp0", label: "Avg(GTemp0) [℃]" },
        { prop: "AppGUsage3D0", label: "Avg(AppGUsage3D0) [%]" },
        { prop: "TotalGUsage3D0", label: "Avg(TotalGUsage3D0) [%]" },
        { prop: "TotalGUsage3D1", label: "Avg(TotalGUsage3D1) [%]" },
        { prop: "GTemp2", label: "Avg(GTemp2) [℃]" },
        { prop: "TotalGUsage3D2", label: "Avg(TotalGUsage3D2) [%]" },
        { prop: "AppDedicated0", label: "Avg(AppDedicated0) [bytes]" },
        { prop: "AppShared0", label: "Avg(AppShared0) [bytes]" },
        { prop: "Dedicated0", label: "Avg(Dedicated0) [bytes]" },
        { prop: "Shared0", label: "Avg(Shared0) [bytes]" },
        { prop: "Dedicated1", label: "Avg(Dedicated1) [bytes]" },
        { prop: "Shared1", label: "Avg(Shared1) [bytes]" },
        { prop: "avg_dc", label: "Avg(DrawCall)" },
        { prop: "IOReadCount", label: "Avg(IOReadCount)" },
        { prop: "IOReadBytes", label: "Avg(IOReadBytes)" },
        { prop: "IOWriteCount", label: "Avg(IOWriteCount)" },
        { prop: "IOWriteBytes", label: "Avg(IOWriteBytes)" },
        { prop: "ThreadCount", label: "Avg(ThreadCount)" },
        { prop: "HandleCount", label: "Avg(HandleCount)" },
      ];
    },
    drawPieChartDc() {
      let dc_line = document.getElementById("dc_line");
      if (dc_line.getAttribute("style") === "display:none") {
        dc_line.setAttribute("style", "width: 100%; height: 400px");
      }

      // 用echarts时，如果存在DOM，就会报存在警告，处理方法删除DOM
      // echarts数据变动时, 数据正常，图标混乱，故以此解决
      echarts.dispose(dc_line);

      let DCChart = echarts.init(dc_line);
      let option;
      option = {
        title: {
          text: "DrawCall",
          textStyle: {
            fontSize: 16,
            fontWeight: 700,
            color: "#333",
          },
        },
        dataZoom: this.chartSettings.dataZoom,
        toolbox: this.chartSettings.toolbox,
        tooltip: this.chartSettings.tooltip,
        legend: this.chartSettings.legend,
        grid: this.chartSettings.grid,
        yAxis: this.chartSettings.yAxis,
        xAxis: {
          type: "category",
          boundaryGap: false,
          data: this.chartDatacustom.rows.i,
        },
        series: [
          {
            name: "dc_line",
            type: "line",
            showSymbol: false,
            data: this.chartDatacustom.rows.dc,
            itemStyle: this.chartSettings.itemStyle2,
            markLine: {
              symbol: ["circle", "arrow"],
              data: [
                {
                  silent: true,
                  xAxis: this.month_new,
                  label: {
                    position: "end",
                    show: true,
                    formatter: this.month_new,
                    color: "ED5664",
                  },
                  lineStyle: {
                    type: "solid",
                    color: "#ED5664",
                    width: "1",
                    opacity: this.opacity, // 设置为0，使标记线不可见
                  },
                },
              ],
            },
          },
        ],
      };
      DCChart.setOption(option);
      this.judgNull(option.series, dc_line);
      // if (
      //   document.getElementById("monomem").getAttribute("style") ===
      //     "display:none" &&
      //   document.getElementById("gc_line").getAttribute("style") ===
      //     "display:none" &&
      //   document.getElementById("dc_line").getAttribute("style") ===
      //     "display:none" &&
      //   document.getElementById("Tris").getAttribute("style") ===
      //     "display:none" &&
      //   document.getElementById("Verts").getAttribute("style") ===
      //     "display:none"
      // ) {
      //   document
      //     .getElementById("monomem")
      //     .parentNode.parentNode.setAttribute("style", "display:none");
      // }
      return DCChart;
    },
    drawPieChartTris() {
      let Tris = document.getElementById("Tris");
      if (Tris.getAttribute("style") === "display:none") {
        Tris.setAttribute("style", "width: 100%; height: 400px");
      }

      // 用echarts时，如果存在DOM，就会报存在警告，处理方法删除DOM
      // echarts数据变动时, 数据正常，图标混乱，故以此解决
      echarts.dispose(Tris);
      let TrisChart = echarts.init(Tris);
      let option;
      option = {
        title: {
          text: "三角形数",
          textStyle: {
            fontSize: 16,
            fontWeight: 700,
            color: "#333",
          },
        },
        dataZoom: this.chartSettings.dataZoom,
        toolbox: this.chartSettings.toolbox,
        tooltip: this.chartSettings.tooltip,
        legend: this.chartSettings.legend,
        grid: this.chartSettings.grid,
        yAxis: this.chartSettings.yAxis,
        xAxis: {
          type: "category",
          boundaryGap: false,
          data: this.chartDatacustom.rows.i,
        },
        series: [
          {
            name: "Tris",
            type: "line",
            showSymbol: false,
            data: this.chartDatacustom.rows.Tris,
            itemStyle: this.chartSettings.itemStyle2,
            markLine: {
              symbol: ["circle", "arrow"],
              data: [
                {
                  silent: true,
                  xAxis: this.month_new,
                  label: {
                    position: "end",
                    show: true,
                    formatter: this.month_new,
                    color: "ED5664",
                  },
                  lineStyle: {
                    type: "solid",
                    color: "#ED5664",
                    width: "1",
                    opacity: this.opacity, // 设置为0，使标记线不可见
                  },
                },
              ],
            },
          },
        ],
      };
      TrisChart.setOption(option);
      this.judgNull(option.series, Tris);
      // if (
      //   document.getElementById("monomem").getAttribute("style") ===
      //     "display:none" &&
      //   document.getElementById("gc_line").getAttribute("style") ===
      //     "display:none" &&
      //   document.getElementById("dc_line").getAttribute("style") ===
      //     "display:none" &&
      //   document.getElementById("Tris").getAttribute("style") ===
      //     "display:none" &&
      //   document.getElementById("Verts").getAttribute("style") ===
      //     "display:none"
      // ) {
      //   document
      //     .getElementById("monomem")
      //     .parentNode.parentNode.setAttribute("style", "display:none");
      // }
      return TrisChart;
    },
    drawPieChartVerts() {
      let Verts = document.getElementById("Verts");
      if (Verts.getAttribute("style") === "display:none") {
        Verts.setAttribute("style", "width: 100%; height: 400px");
      }

      // 用echarts时，如果存在DOM，就会报存在警告，处理方法删除DOM
      // echarts数据变动时, 数据正常，图标混乱，故以此解决
      echarts.dispose(Verts);
      let VertsChart = echarts.init(Verts);
      let option;
      option = {
        title: {
          text: "顶点数",
          textStyle: {
            fontSize: 16,
            fontWeight: 700,
            color: "#333",
          },
        },
        dataZoom: this.chartSettings.dataZoom,
        toolbox: this.chartSettings.toolbox,
        tooltip: this.chartSettings.tooltip,
        legend: this.chartSettings.legend,
        grid: this.chartSettings.grid,
        yAxis: this.chartSettings.yAxis,
        xAxis: {
          type: "category",
          boundaryGap: false,
          data: this.chartDatacustom.rows.i,
        },
        series: [
          {
            name: "Verts",
            type: "line",
            showSymbol: false,
            data: this.chartDatacustom.rows.Verts,
            itemStyle: this.chartSettings.itemStyle2,
            markLine: {
              symbol: ["circle", "arrow"],
              data: [
                {
                  silent: true,
                  xAxis: this.month_new,
                  label: {
                    position: "end",
                    show: true,
                    formatter: this.month_new,
                    color: "ED5664",
                  },
                  lineStyle: {
                    type: "solid",
                    color: "#ED5664",
                    width: "1",
                    opacity: this.opacity, // 设置为0，使标记线不可见
                  },
                },
              ],
            },
          },
        ],
      };
      VertsChart.setOption(option);
      this.judgNull(option.series, Verts);
      // if (
      //   document.getElementById("monomem").getAttribute("style") ===
      //     "display:none" &&
      //   document.getElementById("gc_line").getAttribute("style") ===
      //     "display:none" &&
      //   document.getElementById("dc_line").getAttribute("style") ===
      //     "display:none" &&
      //   document.getElementById("Tris").getAttribute("style") ===
      //     "display:none" &&
      //   document.getElementById("Verts").getAttribute("style") ===
      //     "display:none"
      // ) {
      //   document
      //     .getElementById("monomem")
      //     .parentNode.parentNode.setAttribute("style", "display:none");
      // }
      return VertsChart;
    },
    getOverview2(data2, data, type) {
      if (
        this.testInfo0.proj_name === "AOV" ||
        this.testInfo0.proj_name === "AOV测试项目" ||
        this.testInfo0.proj_name === "AOV主干Garena" ||
        this.testInfo0.proj_name === "AOV主干Tencent"
      ) {
        if (type === false) {
          this.overviewValue2 = [
            {
              label: "Avg(FPS)",
              value: data2?.avg_fps,
            },
            {
              label: "CPU<60%[%]",
              value: data2?.cpu_lt_60_pcnt,
            },
            {
              label: "Avg(AppCPU)[%]",
              value: data2?.avg_cpu,
            },
            {
              label: "Max(MonoMem)[M]",
              value: data2?.max_mono_total,
            },
            {
              label: "Used(MonoMem)[M]",
              value: data2?.max_mono_used,
            },
            {
              label: "Max(PSS)[M]",
              value: data2?.max_pss,
            },
            {
              label: "Max(Triangle)[个]",
              value: data2?.max_triangle,
            },
            {
              label: "Max(DrwaCall)[次]",
              value: data2?.max_dc,
            },
            {
              label: "卡顿率[%]",
              value: data2?.lag_pcnt,
            },
            {
              label: "Mono堆内存峰值(MB)",
              value: data2?.monomem,
            },
            {
              label: "GC次数",
              value: data2?.gc,
            },

            {
              label: "DrawCall均值",
              value: data2?.avg_dc,
            },
            {
              label: "三角形数均值",
              value: data2?.Tris,
            },
            {
              label: "顶点数均值",
              value: data2?.Verts,
            },
          ];
        } else {
          this.overviewValue2 = [
            {
              label: "Avg(FPS)",
              value: JSON.stringify(data) === "{}" ? "-" : data?.avg_fps,
            },
            {
              label: "CPU<60%[%]",
              value: JSON.stringify(data) === "{}" ? "-" : data?.cpu_lt_60_pcnt,
            },
            {
              label: "Avg(AppCPU)[%]",
              value: JSON.stringify(data) === "{}" ? "-" : data?.avg_cpu,
            },
            {
              label: "Max(MonoMem)[M]",
              value: JSON.stringify(data) === "{}" ? "-" : data?.max_mono_total,
            },
            {
              label: "Used(MonoMem)[M]",
              value: JSON.stringify(data) === "{}" ? "-" : data?.max_mono_used,
            },
            {
              label: "Max(PSS)[M]",
              value: JSON.stringify(data) === "{}" ? "-" : data?.max_pss,
            },
            {
              label: "Max(Triangle)[个]",
              value: JSON.stringify(data) === "{}" ? "-" : data?.max_triangle,
            },
            {
              label: "Max(DrwaCall)[次]",
              value: JSON.stringify(data) === "{}" ? "-" : data?.max_dc,
            },
            {
              label: "卡顿率[%]",
              value: JSON.stringify(data) === "{}" ? "-" : data?.lag_pcnt,
            },
            {
              label: "Mono堆内存峰值(MB)",
              value: JSON.stringify(data) === "{}" ? "-" : data?.monomem,
            },
            {
              label: "GC次数",
              value: JSON.stringify(data) === "{}" ? "-" : data?.gc,
            },

            {
              label: "DrawCall均值",
              value: JSON.stringify(data) === "{}" ? "-" : data?.avg_dc,
            },
            {
              label: "三角形数均值",
              value: JSON.stringify(data) === "{}" ? "-" : data?.Tris,
            },
            {
              label: "顶点数均值",
              value: JSON.stringify(data) === "{}" ? "-" : data?.Verts,
            },
          ];
        }
      } else {
        this.overviewValue2 = [
          {
            label: "Avg(FPS)",
            value: JSON.stringify(data) === "{}" ? "-" : data?.avg_fps,
          },
          {
            label: "Jank",
            value: JSON.stringify(data) === "{}" ? "-" : data?.jank,
          },
          {
            label: "BigJank",
            value: JSON.stringify(data) === "{}" ? "-" : data?.big_jank,
          },
          {
            label: "Avg(AppCPU)[%]",
            value: JSON.stringify(data) === "{}" ? "-" : data?.avg_cpu,
          },
          {
            label: "Avg(CTemp)[°C])",
            value:
              this.testInfo0.device.toUpperCase().indexOf("IPHONE") != -1
                ? "-"
                : JSON.stringify(data) === "{}"
                ? "-"
                : data?.cpu_temp,
          },
          {
            label: "Avg(BTemp)[°C])",
            value: JSON.stringify(data) === "{}" ? "-" : data?.battery_temp,
          },
          {
            label: "Avg(AppCPU)[%]Normalized",
            value:
              JSON.stringify(data) === "{}" ? "-" : data?.app_cpu_normalized,
          },
          {
            label: "CPU<=60%[%]",
            value: JSON.stringify(data) === "{}" ? "-" : data?.cpu_lt_60_pcnt,
          },
          {
            label: "Send[KB/s]",
            value: JSON.stringify(data) === "{}" ? "-" : data?.send,
          },
          {
            label: "Recv[KB/s]",
            value: JSON.stringify(data) === "{}" ? "-" : data?.recv,
          },
        ];
        if (
          this.testInfo0.proj_name === "CF手游" ||
          this.testInfo0.proj_name === "CFM手游测试"
        ) {
          this.overviewValue2.push(
            {
              label: "Max(MonoMem)[M]",
              value: data2?.max_mono_total,
            },
            {
              label: "Used(MonoMem)[M]",
              value: data2?.max_mono_used,
            },
            {
              label: "Max(PSS)[M]",
              value: data2?.max_pss,
            },
            {
              label: "Max(Triangle)[个]",
              value: data2?.max_triangle,
            },
            {
              label: "Max(DrwaCall)[次]",
              value: data2?.max_dc,
            },
            {
              label: "卡顿率[%]",
              value: data2?.lag_pcnt,
            },
            {
              label: "Mono堆内存峰值(MB)",
              value: data2?.monomem,
            },
            {
              label: "GC次数",
              value: data2?.gc,
            },
            {
              label: "DrawCall均值",
              value: data2?.avg_dc,
            },
            {
              label: "三角形数均值",
              value: data2?.Tris,
            },
            {
              label: "顶点数均值",
              value: data2?.Verts,
            }
          );
        }
        if (this.testInfo0.proj_name === "QQ飞车手游") {
          this.overviewValue2.push(
            {
              label: "CPU0功耗",
              value: JSON.stringify(data) === "{}" ? "-" : data?.cpu_power_0,
            },
            {
              label: "CPU1功耗",
              value: JSON.stringify(data) === "{}" ? "-" : data?.cpu_power_1,
            },
            {
              label: "CPU2功耗",
              value: JSON.stringify(data) === "{}" ? "-" : data?.cpu_power_2,
            },
            {
              label: "CPU3功耗",
              value: JSON.stringify(data) === "{}" ? "-" : data?.cpu_power_3,
            },
            {
              label: "CPU4功耗",
              value: JSON.stringify(data) === "{}" ? "-" : data?.cpu_power_4,
            },
            {
              label: "CPU5功耗",
              value: JSON.stringify(data) === "{}" ? "-" : data?.cpu_power_5,
            },
            {
              label: "CPU6功耗",
              value: JSON.stringify(data) === "{}" ? "-" : data?.cpu_power_6,
            },
            {
              label: "CPU7功耗",
              value: JSON.stringify(data) === "{}" ? "-" : data?.cpu_power_7,
            }
          );
        }
      }
    },

    getFPSValue(data) {
      this.FPSValue = [
        {
          label: "Avg(FPS)",
          value: JSON.stringify(data) === "{}" ? "-" : data?.avg_fps,
        },
        {
          label: "Smooth(稳帧指数)",
          value: JSON.stringify(data) === "{}" ? "-" : data?.Smooth,
        },
        {
          label: "Std(FPS)",
          value: JSON.stringify(data) === "{}" ? "-" : data["Std(FPS)"],
        },
        {
          label: "Var(FPS)",
          value: JSON.stringify(data) === "{}" ? "-" : data.var_fps,
        },
        {
          label: "FPS<=10[%]",
          value: this.ChangeFPS?.lteFPS,
        },
        {
          label: "FPS>=25[%]",
          value: this.ChangeFPS?.gteFPS,
        },
        // {
        //   label: "FPS>=18[%]",
        //   value: JSON.stringify(data) === "{}" ? "-" : data?.fps_lt_18_pcnt,
        // },
        // {
        //   label: "FPS>=40[%]",
        //   value: JSON.stringify(data) === "{}" ? "-" : data?.fps_lt_40_pcnt,
        // },
        {
          label: "Drop(FPS)[/h]",
          value: JSON.stringify(data) === "{}" ? "-" : data["Drop(FPS)[/h]"],
        },
        {
          label: "Min(FPS)",
          value: JSON.stringify(data) === "{}" ? "-" : data?.min_fps,
        },
        {
          label: "Median(FPS)",
          value: JSON.stringify(data) === "{}" ? "-" : data["Median(FPS)"],
        },
        {
          label: "MedRange(FPS)[%]",
          value: JSON.stringify(data) === "{}" ? "-" : data["MedRange(FPS)[%]"],
        },
        {
          label: "SmallJank(微小卡顿)\n(/10min)",
          value:
            JSON.stringify(data) === "{}" ? "-" : data["SmallJank(/10min)"],
        },
        {
          label: "Jank(卡顿)(/10min)",
          value: JSON.stringify(data) === "{}" ? "-" : data["Jank(/10min)"],
        },
        {
          label: "BigJank(严重卡顿)(/10min)",
          value: JSON.stringify(data) === "{}" ? "-" : data["BigJank(/10min)"],
        },
        {
          label: "Stutter(卡顿率) [%]",
          value: JSON.stringify(data) === "{}" ? "-" : data["Stutter[%]"],
        },
        {
          label: "Avg(FTime)",
          value: JSON.stringify(data) === "{}" ? "-" : data["Avg(FTime)"],
        },
        {
          label: "Std(FTime)",
          value: JSON.stringify(data) === "{}" ? "-" : data["Std(FTime)"],
        },
        {
          label: "Var(FTime)",
          value: JSON.stringify(data) === "{}" ? "-" : data["Var(FTime)"],
        },
        {
          label: "FTime>=100[%]",
          value: JSON.stringify(data) === "{}" ? "-" : data["FTime>=100[%]"],
        },
        {
          label: "Delta(FTime)>100ms[/h]",
          value:
            JSON.stringify(data) === "{}"
              ? "-"
              : data["Delta(FTime)>100ms[/h]"],
        },
        // {
        //   label: "GC次数[次]",
        //   value: this.testInfo?.gc_cnt,
        // },
        // {
        //   label: "GC频率[次/分]",
        //   value: this.testInfo?.gc_freq,
        // },
      ];
    },
    getMemoryValue(data) {
      this.MemoryValue = [
        {
          label: "Peak(WorkingSet) [MB]",
          value: JSON.stringify(data) === "{}" ? "-" : data["Peak(WorkingSet)"],
        },
        {
          label: "Avg(WorkingSet) [MB]",
          value: JSON.stringify(data) === "{}" ? "-" : data?.WorkingSet,
        },
        {
          label: "Avg(PrivateBytes) [MB]",
          value: JSON.stringify(data) === "{}" ? "-" : data?.PrivateBytes,
        },
        {
          label: "Avg(VirtualBytes) [MB]",
          value: JSON.stringify(data) === "{}" ? "-" : data?.VirtualBytes,
        },
        {
          label: "Avg(PageFaults)",
          value: JSON.stringify(data) === "{}" ? "-" : data?.PageFaults,
        },
      ];
    },
    showBox(data) {
      return data
        .map((v) => v.data.every((item) => item == ""))
        .every((i) => i == true);
    },
    getGPUValue(data) {
      this.GPUValue = [
        {
          label: "Avg(GTemp0) [℃]",
          value: JSON.stringify(data) === "{}" ? "-" : data?.GTemp0,
        },
        {
          label: "Avg(AppGUsage3D0) [%]",
          value: JSON.stringify(data) === "{}" ? "-" : data?.AppGUsage3D0,
        },
        {
          label: "Avg(TotalGUsage3D1) [%]",
          value: JSON.stringify(data) === "{}" ? "-" : data?.TotalGUsage3D1,
        },
        {
          label: "Avg(GTemp2) [℃]",
          value: JSON.stringify(data) === "{}" ? "-" : data?.GTemp2,
        },
        {
          label: "Avg(TotalGUsage3D2) [%]",
          value: JSON.stringify(data) === "{}" ? "-" : data?.TotalGUsage3D2,
        },
      ];
    },
    getGPUMemoryValue(data) {
      this.GPUMemoryUsage = [
        {
          label: "Avg(AppDedicated0) [bytes]",
          value: JSON.stringify(data) === "{}" ? "-" : data?.AppDedicated0,
        },
        {
          label: "Avg(AppShared0) [bytes]",
          value: JSON.stringify(data) === "{}" ? "-" : data?.AppShared0,
        },
        {
          label: "Avg(AppDedicated0) [bytes]",
          value: JSON.stringify(data) === "{}" ? "-" : data?.AppDedicated0,
        },
        {
          label: "Avg(Shared0) [bytes]",
          value: JSON.stringify(data) === "{}" ? "-" : data?.Shared0,
        },
        {
          label: "Avg(Dedicated1) [bytes]",
          value: JSON.stringify(data) === "{}" ? "-" : data?.Dedicated1,
        },
        {
          label: "Avg(Shared1) [bytes]",
          value: JSON.stringify(data) === "{}" ? "-" : data?.Shared1,
        },
      ];
    },
    getRenderValue(data) {
      this.renderValue = [
        {
          label: "Avg(Drawcall)[次]",
          value: JSON.stringify(data) === "{}" ? "-" : data?.avg_dc,
        },
        // {
        //   label: "Avg(PrivateBytes) [MB]",
        //   value: JSON.stringify(data) === "{}" ? "-" : data?.AppShared0,
        // },
      ];
    },
    getIoValue(data) {
      this.ioValue = [
        {
          label: "Avg(IOReadCount)",
          value: JSON.stringify(data) === "{}" ? "-" : data?.IOReadCount,
        },
        {
          label: "Avg(IOReadBytes)",
          value: JSON.stringify(data) === "{}" ? "-" : data?.IOReadBytes,
        },
        {
          label: "Avg(IOWriteCount)",
          value: JSON.stringify(data) === "{}" ? "-" : data?.IOWriteCount,
        },
        {
          label: "Avg(IOWriteBytes)",
          value: JSON.stringify(data) === "{}" ? "-" : data?.IOWriteBytes,
        },
        // {
        //   label: "Avg(PrivateBytes) [MB]",
        //   value: JSON.stringify(data) === "{}" ? "-" : data?.AppShared0,
        // },
      ];
    },
    getThreadValue(data) {
      this.threadValue = [
        {
          label: "Avg(ThreadCount)",
          value: JSON.stringify(data) === "{}" ? "-" : data?.ThreadCount,
        },

        // {
        //   label: "Avg(PrivateBytes) [MB]",
        //   value: JSON.stringify(data) === "{}" ? "-" : data?.AppShared0,
        // },
      ];
    },
    getHandledValue(data) {
      this.handledValue = [
        {
          label: "Avg(HandleCount)",
          value: JSON.stringify(data) === "{}" ? "-" : data?.HandleCount,
        },

        // {
        //   label: "Avg(PrivateBytes) [MB]",
        //   value: JSON.stringify(data) === "{}" ? "-" : data?.AppShared0,
        // },
      ];
    },
    getCPUValue(data) {
      this.CPUValue = [
        {
          label: "Avg(AppCPU) [%]",
          value: JSON.stringify(data) === "{}" ? "-" : data?.avg_cpu,
        },
        {
          label: "AppCPU<=60 [%]",
          value: JSON.stringify(data) === "{}" ? "-" : data?.cpu_lt_60_pcnt,
        },
        {
          label: "AppCPU<=80 [%]",
          value: JSON.stringify(data) === "{}" ? "-" : data?.cpu_lt_80_pcnt,
        },
        {
          label: "AppUserCPU<=60[%]",
          value:
            JSON.stringify(data) === "{}" ? "-" : data["AppUserCPU<=60[%]"],
        },
        {
          label: "AppUserCPU<=80[%]",
          value:
            JSON.stringify(data) === "{}" ? "-" : data["AppUserCPU<=80[%]"],
        },
        {
          label: "Avg(AppKernelCPU) [%]",
          value: JSON.stringify(data) === "{}" ? "-" : data?.AppKernelCPU,
        },
        {
          label: "AppKernelCPU<=60 [%]",
          value:
            JSON.stringify(data) === "{}" ? "-" : data["AppKernelCPU<=60[%]"],
        },
        {
          label: "AppKernelCPU<=80 [%]",
          value:
            JSON.stringify(data) === "{}" ? "-" : data["AppKernelCPU<=80[%]"],
        },
      ];
    },
    getNetWorkValue(data) {
      this.NetWorkValue = [
        {
          label: "DPS[KB/s]",
          value:
            this.testInfo2.custom_data !== "-"
              ? JSON.parse(this.testInfo2.custom_data)?.DPS
              : JSON.stringify(data) === "{}"
              ? "-"
              : data?.dps,
        },
        {
          label: "Send[KB/s]",
          value: JSON.stringify(data) === "{}" ? "-" : data?.send,
        },
        {
          label: "Recv[KB/s]",
          value: JSON.stringify(data) === "{}" ? "-" : data?.recv,
        },
        // {
        //   label: "进程上行流量[KB/s]",
        //   value: this.testInfo?.process_up_flow,
        // },
        // {
        //   label: "进程下行流量[KB/s]",
        //   value: this.testInfo?.process_down_flow,
        // },
        // {
        //   label: "逻辑上行流量[KB/s]",
        //   value: this.testInfo?.logic_up_flow,
        // },
        // {
        //   label: "逻辑下行流量[KB/s]",
        //   value: this.testInfo?.logic_down_flow,
        // },
      ];
    },
    getCsWitch(data) {
      this.CswitchValue = [
        {
          label: "Avg(CSwitch)",
          value:
            JSON.stringify(data) === "{}"
              ? "-"
              : data.custom_data == null ||
                data.custom_data == undefined ||
                data.custom_data == "-"
              ? ""
              : JSON.parse(data.custom_data)?.CSwitch
              ? JSON.parse(data.custom_data)?.CSwitch
              : "-",
        },
      ];
    },
    getWakeups(data) {
      this.WakeupsValue = [
        {
          label: "Avg(Wakeups)",
          value:
            JSON.stringify(data) === "{}"
              ? "-"
              : data.custom_data == null ||
                data.custom_data == undefined ||
                data.custom_data == "-"
              ? ""
              : JSON.parse(data.custom_data)?.Wakeups
              ? JSON.parse(data.custom_data)?.Wakeups
              : "-",
        },
      ];
    },
    getCustom(data) {
      this.custom = [
        {
          label: "Mono堆内存峰值(MB)",
          value: JSON.stringify(data) === "{}" ? "-" : data?.monomem,
        },
        {
          label: "GC次数",
          value: JSON.stringify(data) === "{}" ? "-" : data?.gc,
        },
        {
          label: "DrawCall均值",
          value: JSON.stringify(data) === "{}" ? "-" : data?.avg_dc,
        },
        {
          label: "三角形数均值",
          value: JSON.stringify(data) === "{}" ? "-" : data?.Tris,
        },
        {
          label: "顶点数均值",
          value: JSON.stringify(data) === "{}" ? "-" : data?.Verts,
        },
      ];
      if (
        this.testInfo0.proj_name === "CF手游" ||
        this.testInfo0.proj_name === "CFM手游测试"
      ) {
        this.custom = [
          {
            label: "Mono堆内存峰值(MB)",
            value: JSON.stringify(data) === "{}" ? "-" : data?.monomem,
          },
          {
            label: "GC次数",
            value: JSON.stringify(data) === "{}" ? "-" : data?.gc,
          },
          {
            label: "DrawCall均值",
            value: JSON.stringify(data) === "{}" ? "-" : data?.avg_dc,
          },
          {
            label: "三角形数均值",
            value: JSON.stringify(data) === "{}" ? "-" : data?.Tris,
          },
          {
            label: "顶点数均值",
            value: JSON.stringify(data) === "{}" ? "-" : data?.Verts,
          },
          {
            label: "DrawCall最大值",
            value: JSON.stringify(data) === "{}" ? "-" : data?.max_dc,
          },
          {
            label: "三角形数最大值",
            value: JSON.stringify(data) === "{}" ? "-" : data?.max_triangle,
          },
          {
            label: "顶点数最大值",
            value:
              JSON.stringify(data) === "{}"
                ? "-"
                : data.custom_data
                ? JSON.parse(data.custom_data)?.max_vertices
                : "-",
          },
        ];
      }
    },
  },
};
</script>
<style scoped>
.runmax {
  width: 1600px;
  margin: 0 auto;
}
.runmax .h5_style {
  font-size: 20px;
  font-weight: 700;
}
.runmax ul {
  list-style: none;
}
/* 标题 */
.runmax_title {
  background: linear-gradient(90deg, #3280c8, #36ba88);
  color: #ffffff;
  height: 200px;
}
.runmax_title .title_main {
  height: 150px;
  padding: 20px;
  display: flex;
  justify-content: space-between;
}
.runmax_title .title_main div {
  display: flex;
}
.runmax_title .img_style {
  width: 84px;
  height: 84px;
  background-color: #6ff2;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 5px;
}
.runmax_title .img_style img {
  width: 95%;
}
.runmax_title ul {
  padding-left: 15px;
  margin-bottom: 0;
}
.runmax_title .title_main .title_right {
  width: 100%;
  justify-content: space-around;
}
.runmax_title .title_main .title_left ul {
  border-right: 1px solid #e4e7fb;
  padding-right: 25px;
}
.runmax_title .title_main div:not(:first-child) .img_style {
  border-radius: 50%;
  width: 70px;
  height: 70px;
}
.runmax_title .title_main div:not(:first-child) img {
  width: 40px;
}
.runmax_title ul li {
  font-size: 14px;
  color: #e4e7fb;
}
.runmax_title ul li:first-child {
  font-weight: 700;
  font-size: 20px;
  margin-bottom: 15px;
  color: white;
}
.runmax_title .title_end {
  height: 50px;
  background-color: #6ff2;
  line-height: 50px;
  padding-left: 20px;
  font-size: 14px;
}
.runmax_title .title_end span {
  color: white;
  opacity: 0.8;
}

.runmax .h2_style {
  font-size: 20px;
  font-weight: 700;
  padding-left: 8px;
  border-left: 4px solid #4371fd;
}
.runmax .label_style {
  display: flex;
  text-align: center;
  flex-wrap: wrap;
}
.runmax .label_style ul li:first-child {
  font-size: 14px;
  color: #666;
  max-height: 50px;
  height: 50px;
}
.runmax .label_style ul li:last-child {
  margin-top: 15px;
  font-weight: 700;
  font-size: 24px;
  color: #333;
}
/* 概览 */

.overview .header_style {
  display: flex;
  justify-content: space-between;
}
.overview .header_style a {
  font-size: 14px;
  color: #4371fd;
  text-decoration: none;
}
.overview .overview_table {
  margin-top: 28px;
  margin-left: 10px;
}
.overview .overview_table .table_p {
  font-size: 16px;
  font-weight: 700;
  color: #333;
  margin-bottom: 12px !important;
}
.overview .overview_table .table_p i {
  color: #acb0bf;
}
.footer {
  height: 40px;
  text-align: center;
  line-height: 60px;
  font-size: 14px;
  color: #acb0bf;
}
.footer span {
  color: #1a1d27;
  cursor: pointer;
}
</style>


<style>
/* 概览 */

.runmax .el-card__header {
  border: none !important;
  padding-bottom: 0 !important;
}
.runmax .el-card__body {
  padding-top: 0 !important;
}

.down_nav_list {
  width: 100%;

  position: fixed;
  display: flex;
  justify-content: flex-end;
  z-index: 31;
  bottom: 0;
  right: 0;
  width: 40px;
  height: 18.5%;
}
.down_nav_list li {
  list-style: none;
}
.gallery__box {
  position: absolute;
  left: 0;
  top: 0;
  z-index: 2;
  display: flex;
  align-items: center;
  overflow: hidden;
  box-sizing: border-box;
  width: 100%;
  height: 100%;
  padding-right: 40px;
  background: rgba(9, 11, 24, 0.9);
}
.gallery__list {
  display: flex;
  height: 100%;
  align-items: center;
  margin: 0;
  padding-left: 0;
  justify-content: center;

  transition: 2s;
}
.gallery__list li {
  display: flex;
  text-align: center;
  position: relative;
  height: 100%;
  align-items: center;
  justify-content: center;
}

.gallery__list li:nth-child(n + 2) {
  margin-left: 10px;
}
.gallery__list img {
  height: 102.112px;
}
.gallery_btn {
  width: 40px;
  background: #ff0;
  z-index: 99;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  box-shadow: 0 2px 10px rgba(66, 113, 251, 0.4);
  color: rgba(171, 174, 176);
  background: #fff;
  cursor: not-allowed;
  border: 0;
  outline: 0;
}
.gallery_btn1 {
  width: 40px;
  background: #ff0;
  z-index: 99;
  position: fixed;
  left: 0px;
  top: 50%;
  transform: translateY(-50%);
  height: 75px;
  box-shadow: 0 2px 10px rgba(66, 113, 251, 0.4);
  color: rgba(171, 174, 176);
  background: #fff;
  cursor: not-allowed;
  border: 0;
  outline: 0;
}
.gallery_btn i {
  font-size: 26px;
  font-weight: bold;
  color: rgba(151, 157, 176);
}
.gallery_btn1 i {
  font-size: 26px;
  font-weight: bold;
  color: rgba(151, 157, 176);
}
.gallery_btn:hover {
  background: #e3e6ef;
}
.time_stap {
  position: absolute;
  width: 100%;
  text-align: center;
  top: 85%;
  font-size: 0.14rem;
  color: #666;
  line-height: 10px;
  margin-top: 0.1rem;
}
/* .gallery__list li:after {
    display: block;
    background: none;
    border: 2px solid #313651;
    border-radius: 2px;
    margin: -2px 0 0 -2px;
    bottom: auto;
    height: 60%;
    width: 100%;
} */
/* .gallery__list li{
  box-sizing: border-box;
  padding:2px;
} */

.gallery__list li:before {
  pointer-events: none;
  content: "";
  position: absolute;
  top: 20%;
  bottom: 20%;
  left: 0;
  right: 0;
  background: rgba(9, 11, 24, 0.5);
}
.gallery__list li {
  padding: 2px;
}

.gallery__list li img {
  cursor: pointer;
}

.gallery__list .select {
  background: none;
}
.gallery__list li img {
  border: 1px solid transparent;
}
.gallery__list .select img {
  border: 1px solid #313651;
}
.select::before {
  pointer-events: none;
  content: "";
  position: absolute;
  top: 20%;
  bottom: 20%;
  left: 0;
  right: 0;
  background: none !important;
}
.gallery__big {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(9, 11, 24, 0.9);
}
.gallery__big_box {
  position: absolute;
  top: 11.1%;
  bottom: 23.1%;
  left: 8.3%;
  right: 8.3%;
  display: flex;
  align-items: center;
  justify-content: center;
}
.gallery__big_wrap {
  position: relative;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}
#testnum {
  position: relative;
}
#cs {
  position: absolute;
  top: 50%;
  left: 50%;
  margin-left: -110px;
  margin-top: -110px;
}
.el-table__fixed-header-wrapper .el-checkbox__inner {
  display: none !important;
}
.dt {
  /* position: absolute; */
  top: 20px;
  left: 50px;
  display: block;
}
.lable_box {
  position: absolute;
  display: flex;
  top: 35px;
  left: 46.8px;
  width: 93.06%;
  flex-direction: row;
}
.lable_box1 {
  position: absolute;
  display: flex;
  top: 35px;
  left: 92.5px;
  width: 90.25%;
  flex-direction: row;
}
.lable_box3 {
  position: absolute;
  display: flex;
  top: 35px;
  left: 69.5px;
  width: 91.78%;
  flex-direction: row;
}
.lable_box4 {
  position: absolute;
  display: flex;
  top: 35px;
  left: 85.4px;
  width: 90.69%;
  flex-direction: row;
}
.lable_item {
  width: 100%;
  height: 27px;
  text-align: center;
  color: #fff;
  font-size: 10px;
  line-height: 27px;
}
#info-box {
  position: absolute;
  width: 10px;
  background-color: rgba(0, 0, 255, 0.5); /* 将颜色设置为半透明的蓝色 */
  width: 200px;
  display: none;
}
/* .el-overlay {
  background-color: transparent !important;
} */
.el-drawer.ltr,
.el-drawer.rtl {
  background: rgba(255, 255, 255, 0.5);
}
.el-tree {
  background: rgba(255, 255, 255, 0.5);
}
</style>
